import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { getForms, addRoomForm, typeOfResidentialForms, infraForms, diningAreaForms, diningAreaRecreationalForms } from './view-tc-residential.component.element';
import { DFormHelpers } from 'projects/common/src/app/d-form/d-form.helpers';
import { ActivatedRoute, Router } from '@angular/router';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { v4 as uuid } from 'uuid';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import { IAddressOptions } from 'projects/common/src/app/types';
import { RoutingService } from 'projects/services/src/app/routing.service';
import { Colors, SweetAlertOptions } from 'projects/common/src/app/display-result/display-result.component';
import { UserService } from 'projects/services/src/app/API/userservice/user-service.service';
import { IDFormControl } from 'projects/common/src/app/d-form/d-form.helpers';
declare var swal: any;

declare var toastr: any;
@Component({
  selector: 'app-view-tc-residential-details',
  templateUrl: './view-tc-residential-details.component.html',
  styleUrls: ['./view-tc-residential-details.component.css']
})



export class ViewTcResidentialDetailsComponent implements OnInit {
  @ViewChild('transgenderTab') transgenderTab: ElementRef;
  @ViewChild('womenTab') womenTab: ElementRef;
  @ViewChild('menTab') menTab: ElementRef;
  residentialFacilitiesForm: any;
  sweetAlert: SweetAlertOptions;
  role;
  //areaAvailability: any;
  // incomingData: any;
  infraFormMen = {
    form: null,
    formData: null,
    defaultValue: null,
    control: null,
    validity: false
  };
  diningAreaFormsMen = {
    form: null,
    formData: null,
    defaultValue: null,
    control: null,
    validity: false
  };
  diningAreaRecreationalFormsMen = {
    form: null,
    formData: null,
    defaultValue: null,
    control: null,
    validity: false
  };
  infraFormWomen = {
    form: null,
    formData: null,
    defaultValue: null,
    control: null,
    validity: false
  };
  diningAreaFormsWomen = {
    form: null,
    formData: null,
    defaultValue: null,
    control: null,
    validity: false
  };
  diningAreaRecreationalFormsWomen = {
    form: null,
    formData: null,
    defaultValue: null,
    control: null,
    validity: false
  };
  infraFormTransgender = {
    form: null,
    formData: null,
    defaultValue: null,
    control: null,
    validity: false
  };
  diningAreaFormsTransgender = {
    form: null,
    formData: null,
    defaultValue: null,
    control: null,
    validity: false
  };
  diningAreaRecreationalFormsTransgender = {
    form: null,
    formData: null,
    defaultValue: null,
    control: null,
    validity: false
  };
  // currentSection = 'section1';
  incomingGeneraldata: any;
  incomingrfdata: any;
  incomingfdata: any;
  residentialFacilities: any;
  residentialFacilitiesWomen: any;
  residentialFacilitiesTransgender: any;
  // residentialFacilitiesDetails: any;
  existingResidentialFacilities: any;
  existingResidentialFacilitiesForMen: any;
  existingResidentialFacilitiesForWomen: any;
  existingResidentialFacilitiesForTransgender: any;
  residentialFormValid = false;
  buffer: any[] = [];
  userDetails: any;
  formDataLoaded = false;
  formLoad: any = false;
  basicInfoForm: any;
  data: any = {
    basicDetails: {},
    addressForMen: {},
    addressForWomen: {},
    addressForTransgender: {}
  };
  addressControlMen: IDFormControl;
  addressControlWoMen: IDFormControl;
  addressControlTransgender: IDFormControl;
  roomFormGroup: FormGroup;
  commendationsAndInternationalAffiliations: any[];
  downloadText = 'Preview Document Proof';
  validity: any = {
    // affiliation: false,
    residentialMen: false,
    residentialWomen: false,
    residentialTransgender: false,
    menRooms: true,
    womenRooms: true,
    transgenderRooms: true,
    typeOfResidencial: false,
    addressForMen: false,
    addressForWomen: false,
    addressForTransgender: false
  };
  validityFormMen: any = {
    // affiliation: false,
    residentialMen: false,
    menRooms: true,
    typeOfResidencial: false,
    addressForMen: false,
  };
  validityForWomen: any = {
    // affiliation: false,
    residentialWomen: false,
    womenRooms: true,
    typeOfResidencial: false,
    addressForWomen: false,
  };
  validityForTransgender: any = {
    // affiliation: false,
    residentialTransgender: false,
    transgenderRooms: true,
    typeOfResidencial: false,
    addressForTransgender: false
  };
  facilitiesForm: any;
  facilities: any;
  dropDownData: any = {
    typeOfTrainingCentres: [],
    buildingStatus: [],
    typeOfConstructionBuilding: [],
    proximityToPublicTransport: [],
    frontFaceBuilding: [],
    previousStateOfBuilding: [],
    areaClassificationOfTheCentre: [],
    entireCentreSituatedAtGroundFloor: [],
    availabilityOfInternet: [],
    safeDrinkingWater: [],
    typeOfCentreFloor: [],
    typeOfTrainingCentreWalls: []
  };
  generalFacilities: any;
  selectList: any;
  facityValidity: any;
  roomForm: any;
  selectedResidential: any;
  menRooms: any = [];
  womenRooms: any = [];
  transngender: any = [];
  roomDetails: any;
  roomControl: IDFormControl;
  facilityControl: IDFormControl;
  womenForm: any;
  transgenderForm: any;
  menControlForm: any;
  womenControlForm: any;
  transgenderControlForm: any;
  basicFormControl: any;
  transgenderControl: any;
  menControl: any;
  womenControl: any;
  isRoomValid: false;
  menuListMen = [];
  menuListWoMen = [];
  menuListTransgender = [];
  typeOfResidencialForm: any;
  typeOfResidencialData: any;
  typeOfResidentialInitialDefault: any;
  residentialFormGroup: any
  addressOptions: IAddressOptions = {
    isPlane: true,
    schemeType: 'feeBased',
    addressProofRequired: true,
    addressProofTypeRequired: true,
    nameRequired: false,
    labelDiv: 4,
    inputDiv: 8,
    fields: {
      name: false,
      detail: true,
      landmark: true,
      pincode: true,
      state: true,
      district: true,
      // tehsil: true,
      city: false,
      parliamentaryConstituency: false,
      //multipleAddressProof:true,
      addressProof: true,
      //geoLocation:true,
      addressProofType: true,
    },
    required: {
      name: true,
      detail: true,
      landmark: true,
      pincode: true,
      state: true,
      district: true,
      // tehsil: true,
      city: false,
      parliamentaryConstituency: false,
      //multipleAddressProof: true,
      //geoLocation:true,
      addressProof: true,
      addressProofType: true
    }
  };
  homePageFormGroup: FormGroup;
  menCopy = {
    transgenderAddress: false,
    womenAddress: false
  }
  womenCopy = {
    menAddress: false,
    transgenderAddress: false
  }
  transgenderCopy = {
    menAddress: false,
    womenAddress: false
  }
  roomIndex;
  residentialFacilitiesValidity: any;
  constructor(
    private activatedRoute: ActivatedRoute,
    private userService: UserService,
    private router: Router,
    private routingService: RoutingService,
    private formBuilder: FormBuilder
  ) {
    this.roomFormGroup = this.formBuilder.group({
      numberOfCots: [null, []],
      cotType: this.formBuilder.array([this.createCotType()]),
      cupBordType: this.formBuilder.array([this.createcupBordType()]),
      numberOfCupboardAndAlmirah: [null, []],
      volumeOfCupboard: this.formBuilder.array([]),
      typeOfCot: ['', []]
    })
    this.homePageFormGroup = this.formBuilder.group({
      totalArea: [null, []],
      totalCapacity: [null, []],
      nameOfResidentialFacility: [null, [Validators.required, Validators.pattern(`[a-zA-Z]+[a-zA-Z\\. ']*$`), Validators.minLength(3), Validators.maxLength(200)]],
      availabilityOfDisplayBoardFrontBuild: [null, [Validators.required]]
    });
    this.residentialFormGroup = this.formBuilder.group({
      menForm: this.formBuilder.group({
        totalArea: [null, []],
        capacity: [null, []],
        areaOfToilet: this.formBuilder.array([]),
        areaOfBathroom: this.formBuilder.array([]),
        areaOfToiletCumBathroom: this.formBuilder.array([]),
        dustbinSizeInDiningAreaRecreationalArea: this.formBuilder.array([]),
        dustbinSize: this.formBuilder.array([]),
        availabilityOfTransportSystem: [null, [Validators.required]]
      }),
      womenForm: this.formBuilder.group({
        totalArea: [null, []],
        capacity: [null, []],
        areaOfToilet: this.formBuilder.array([]),
        areaOfBathroom: this.formBuilder.array([]),
        areaOfToiletCumBathroom: this.formBuilder.array([]),
        dustbinSizeInDiningAreaRecreationalArea: this.formBuilder.array([]),
        dustbinSize: this.formBuilder.array([]),
        availabilityOfTransportSystem: [null, [Validators.required]],
        seperateEntranceForMF: [null, []]
      }),
      transgenderForm: this.formBuilder.group({
        totalArea: [null, []],
        capacity: [null, []],
        areaOfToilet: this.formBuilder.array([]),
        areaOfBathroom: this.formBuilder.array([]),
        areaOfToiletCumBathroom: this.formBuilder.array([]),
        dustbinSizeInDiningAreaRecreationalArea: this.formBuilder.array([]),
        dustbinSize: this.formBuilder.array([]),
        availabilityOfTransportSystem: [null, [Validators.required]],
        seperateEntranceForMF: [null, []]
      })
    })
    this.typeOfResidentialFormCreation();
    this.roomFormCreation();
    this.menFormCreation();
    this.womenFormCreation();
    this.transgenderFormCreation();
  }

  ngOnInit() {
    this.getUserDetails(this.mycallBack);
    this.residentialFormGroup.get('menForm').get('totalArea').valueChanges.subscribe(res => {
      this.calculationForTotalArea();
    })
    this.residentialFormGroup.get('womenForm').get('totalArea').valueChanges.subscribe(res => {
      this.calculationForTotalArea();
    })
    this.residentialFormGroup.get('transgenderForm').get('totalArea').valueChanges.subscribe(res => {
      this.calculationForTotalArea();
    })
    this.residentialFormGroup.get('menForm').get('capacity').valueChanges.subscribe(res => {
      this.calculationForTotalCapacity();
    })
    this.residentialFormGroup.get('womenForm').get('capacity').valueChanges.subscribe(res => {
      this.calculationForTotalCapacity();
    })
    this.residentialFormGroup.get('transgenderForm').get('capacity').valueChanges.subscribe(res => {
      this.calculationForTotalCapacity();
    })
    this.role = this.router.url.split("/")[1];
  }
  roomFormCreation() {
    this.roomForm = addRoomForm({}, {
      availabilityOfWindowChange: this.availabilityOfWindowChange.bind(this),
      availabilityOfDoorChange: this.availabilityOfDoorChange.bind(this),
      availabilityOfAcChange: this.availabilityOfAC.bind(this),
      areaEquippedWithRoomChange: this.areaEquippedWithRoomChange.bind(this),
      roomAreaChange: this.roomAreaChange.bind(this),
      matressChange: this.matressChange.bind(this)
    });
  }
  typeOfResidentialFormCreation() {
    this.typeOfResidencialForm = typeOfResidentialForms({}, { typeResidential: this.typeResidential.bind(this) });
  }

  menFormCreation() {
    this.residentialFacilitiesForm = getForms({
      typeOfConstructionBuilding:
        ['All walls of the Residential Facility should be well plastered,colored/distempered/whitewashed',
          'The floor should be cemented/tiled/mosaic/ceramic/hardwood/laminate/marble',
          'Walls/partition between rooms must connect the floor to the roof', 'There should not be any gap between the roof,the partition and the floor',
          'The rooms must be 100% covered by the roof'],
      houseKeepingStaff: ['Salary slip', 'Bank transaction', 'Appointment letter'],
      meals: ['Lunch/Dinner', 'Breakfast', 'Evening Snacks/Tea'],
      partitionsMadeOf: ['Brick Wall', 'Wooden', 'Gypsum Board'],
      // wallsOfResidentials: [{ name: 'Well Plastere, Colored', value: 'Well Plastere, Colored' }, { name: 'distempered', value: 'distempered' }, { name: 'whitewashed', value: 'whitewashed' }],
      // floorOfTheResidentials: ['cemented, tiled', 'ceramic', 'hardwood', 'laminate', 'marbel'],
      menuList: this.menuListMen,
      areaAvailability: [{
        name: 'Yes',
        value: true
      }, {
        name: 'No',
        value: false
      }]
    }, {
        onChange: this.onMenAvaliabilityChange.bind(this),
        onCCTVChange: this.onCCTVChange.bind(this),
        cctvChange: this.onCCTCDocumentChangeMen.bind(this),
        onChangeBathRoom: this.menBathRoomChange.bind(this),
        onChangeBathRoomCumToilet: this.menBathRoomCumToilet.bind(this),
        onCleanlinessChange: this.menCleanlinessChange.bind(this),
        availabilityOfFirstAidKitChange: this.menAvailabilityOfFirstAidKit.bind(this),
        fireFightingEquipmentChange: this.menavailabilityOfFireFightingEquipment.bind(this),
        biometricChange: this.menbiometricChange.bind(this),
        countOfDustbinChangeCleanandHygien: this.menDustbinCleanandHygienChange.bind(this),
        //	isMedicalContactChange:this.menisMedicalContactChange.bind(this)
        // availabilityOfDiningAreaChange: this.menavailabilityOfDiningAreaChange.bind(this),
        // availabilityOfDiningAreaAndRecreationalAreaChange: this.menavailabilityOfDiningAreaAndRecreationalArea.bind(this),
        // mealsChange: this.menmealsChange.bind(this),
        // availabilityOfDustbinInDiningArea: this.menAvailabilityOfDustbinInDiningArea.bind(this),
        // availabilityOfDustbinInDiningAreaRecreationalArea: this.menAvailabilityOfDustbinInDiningAreaRecreationalArea.bind(this),
        // countOfToiletChange: this.menCountOfToiletChange.bind(this),
        // countOfBathroomChange: this.menCountOfBathroomChange.bind(this),
        // countOfToiletCumBathroomChange: this.menCountOfToiletCumBathroomChange.bind(this),
        // diningAreaChange: this.mendiningAreaChange.bind(this),
        // diningAreaRecreationalChange:this.mendiningAreaRecreationalChange.bind(this),
        // seperateEntranceChange: this.seperateEntranceChangeChange.bind(this),
        // totalAreaChange:this.menTotalAreaChange.bind(this),
        // totalResidentialCapacityChange:this.menTotalResidentialCapacityChange.bind(this)
      }, {
        //		label: 'Amenities',
        subLabel: 'Residential Area for Men:',
        cctvLabel: 'cctvMen',
        warden: {
          label: 'Male Warden:',
          placeholder: 'Select Male Warden',
        },
        hide: false,
        require: true,
        doctorLabel: 'Availability of Men Doctor on Call'
      });
    this.infraFormMen['form'] = infraForms({
      typeOfConstructionBuilding:
        ['All walls of the Residential Facility should be well plastered,colored/distempered/whitewashed',
          'The floor should be cemented/tiled/mosaic/ceramic/hardwood/laminate/marble',
          'Walls/partition between rooms must connect the floor to the roof', 'There should not be any gap between the roof,the partition and the floor',
          'The rooms must be 100% covered by the roof'],
      houseKeepingStaff: ['Salary slip', 'Bank transaction', 'Appointment letter'],
      meals: ['Lunch/Dinner', 'Breakfast', 'Evening Snacks/Tea'],
      partitionsMadeOf: ['Brick Wall', 'Wooden', 'Gypsum Board'],
      // wallsOfResidentials: [{ name: 'Well Plastere, Colored', value: 'Well Plastere, Colored' }, { name: 'distempered', value: 'distempered' }, { name: 'whitewashed', value: 'whitewashed' }],
      // floorOfTheResidentials: ['cemented, tiled', 'ceramic', 'hardwood', 'laminate', 'marbel'],
      menuList: this.menuListMen,
      areaAvailability: [{
        name: 'Yes',
        value: true
      }, {
        name: 'No',
        value: false
      }]
    }, {
        // onChange: this.onMenAvaliabilityChange.bind(this),
        // onCCTVChange: this.onCCTVChange.bind(this),
        // onChangeToilet: this.menToiletChange.bind(this),
        // onChangeBathRoom: this.menBathRoomChange.bind(this),
        // onChangeBathRoomCumToilet: this.menBathRoomCumToilet.bind(this),
        // onCleanlinessChange: this.menCleanlinessChange.bind(this),
        // availabilityOfFirstAidKitChange: this.menAvailabilityOfFirstAidKit.bind(this),
        // fireFightingEquipmentChange: this.menavailabilityOfFireFightingEquipment.bind(this),
        // biometricChange: this.menbiometricChange.bind(this),
        // availabilityOfDiningAreaChange: this.menavailabilityOfDiningAreaChange.bind(this),
        // availabilityOfDiningAreaAndRecreationalAreaChange: this.menavailabilityOfDiningAreaAndRecreationalArea.bind(this),
        // mealsChange: this.menmealsChange.bind(this),
        // availabilityOfDustbinInDiningArea: this.menAvailabilityOfDustbinInDiningArea.bind(this),
        // availabilityOfDustbinInDiningAreaRecreationalArea: this.menAvailabilityOfDustbinInDiningAreaRecreationalArea.bind(this),
        onChangeBathRoom: this.menBathRoomChange.bind(this),
        onChangeBathRoomCumToilet: this.menBathRoomCumToilet.bind(this),
        onChangeToilet: this.menToiletChange.bind(this),
        countOfToiletChange: this.menCountOfToiletChange.bind(this),
        countOfBathroomChange: this.menCountOfBathroomChange.bind(this),
        countOfToiletCumBathroomChange: this.menCountOfToiletCumBathroomChange.bind(this),
        // diningAreaChange: this.mendiningAreaChange.bind(this),
        // diningAreaRecreationalChange: this.mendiningAreaRecreationalChange.bind(this),
        // seperateEntranceChange: this.seperateEntranceChangeChange.bind(this),
        // totalAreaChange: this.menTotalAreaChange.bind(this),
        // totalResidentialCapacityChange: this.menTotalResidentialCapacityChange.bind(this)
      }, {
        //	label: 'Amenities',
        subLabel: 'Residential Area for Men:',
        cctvLabel: 'cctvMen',
        warden: {
          label: 'Male Warden:',
          placeholder: 'Select Male Warden',
        },
        hide: false,
        require: true,
        doctorLabel: 'Availability of Men Doctor on Call'
      });
    this.diningAreaFormsMen.form = diningAreaForms({
      typeOfConstructionBuilding:
        ['All walls of the Residential Facility should be well plastered,colored/distempered/whitewashed',
          'The floor should be cemented/tiled/mosaic/ceramic/hardwood/laminate/marble',
          'Walls/partition between rooms must connect the floor to the roof', 'There should not be any gap between the roof,the partition and the floor',
          'The rooms must be 100% covered by the roof'],
      houseKeepingStaff: ['Salary slip', 'Bank transaction', 'Appointment letter'],
      meals: ['Lunch/Dinner', 'Breakfast', 'Evening Snacks/Tea'],
      partitionsMadeOf: ['Brick Wall', 'Wooden', 'Gypsum Board'],
      // wallsOfResidentials: [{ name: 'Well Plastere, Colored', value: 'Well Plastere, Colored' }, { name: 'distempered', value: 'distempered' }, { name: 'whitewashed', value: 'whitewashed' }],
      // floorOfTheResidentials: ['cemented, tiled', 'ceramic', 'hardwood', 'laminate', 'marbel'],
      menuList: this.menuListMen,
      areaAvailability: [{
        name: 'Yes',
        value: true
      }, {
        name: 'No',
        value: false
      }]
    }, {
        // onChange: this.onMenAvaliabilityChange.bind(this),
        // onCCTVChange: this.onCCTVChange.bind(this),
        // onChangeToilet: this.menToiletChange.bind(this),
        // onChangeBathRoom: this.menBathRoomChange.bind(this),
        // onChangeBathRoomCumToilet: this.menBathRoomCumToilet.bind(this),
        // onCleanlinessChange: this.menCleanlinessChange.bind(this),
        // availabilityOfFirstAidKitChange: this.menAvailabilityOfFirstAidKit.bind(this),
        // fireFightingEquipmentChange: this.menavailabilityOfFireFightingEquipment.bind(this),
        // biometricChange: this.menbiometricChange.bind(this),
        cillingFanChangeDiningArea: this.mencillingFanChangeDiningArea.bind(this),
        wallFanChangeDiningArea: this.menwallFanChangeDiningArea.bind(this),
        bulbChangeDiningArea: this.menbulbChangeDiningArea.bind(this),
        availabilityOfDiningAreaChange: this.menavailabilityOfDiningAreaChange.bind(this),
        // availabilityOfDiningAreaAndRecreationalAreaChange: this.menavailabilityOfDiningAreaAndRecreationalArea.bind(this),
        //mealsChange: this.menmealsChange.bind(this),
        availabilityOfDustbinInDiningArea: this.menAvailabilityOfDustbinInDiningArea.bind(this),
        // availabilityOfDustbinInDiningAreaRecreationalArea: this.menAvailabilityOfDustbinInDiningAreaRecreationalArea.bind(this),
        // countOfToiletChange: this.menCountOfToiletChange.bind(this),
        // countOfBathroomChange: this.menCountOfBathroomChange.bind(this),
        // countOfToiletCumBathroomChange: this.menCountOfToiletCumBathroomChange.bind(this),
        diningAreaChange: this.mendiningAreaChange.bind(this),
        // diningAreaRecreationalChange: this.mendiningAreaRecreationalChange.bind(this),
        // seperateEntranceChange: this.seperateEntranceChangeChange.bind(this),
        // totalAreaChange: this.menTotalAreaChange.bind(this),
        // totalResidentialCapacityChange: this.menTotalResidentialCapacityChange.bind(this)
      }, {
        label: 'Amenities',
        subLabel: 'Residential Area for Men:',
        cctvLabel: 'cctvMen',
        warden: {
          label: 'Male Warden:',
          placeholder: 'Select Male Warden',
        },
        hide: false,
        require: true,
        doctorLabel: 'Availability of Men Doctor on Call'
      })
    this.diningAreaRecreationalFormsMen.form = diningAreaRecreationalForms({
      typeOfConstructionBuilding:
        ['All walls of the Residential Facility should be well plastered,colored/distempered/whitewashed',
          'The floor should be cemented/tiled/mosaic/ceramic/hardwood/laminate/marble',
          'Walls/partition between rooms must connect the floor to the roof', 'There should not be any gap between the roof,the partition and the floor',
          'The rooms must be 100% covered by the roof'],
      houseKeepingStaff: ['Salary slip', 'Bank transaction', 'Appointment letter'],
      meals: ['Lunch/Dinner', 'Breakfast', 'Evening Snacks/Tea'],
      partitionsMadeOf: ['Brick Wall', 'Wooden', 'Gypsum Board'],
      // wallsOfResidentials: [{ name: 'Well Plastere, Colored', value: 'Well Plastere, Colored' }, { name: 'distempered', value: 'distempered' }, { name: 'whitewashed', value: 'whitewashed' }],
      // floorOfTheResidentials: ['cemented, tiled', 'ceramic', 'hardwood', 'laminate', 'marbel'],
      menuList: this.menuListMen,
      areaAvailability: [{
        name: 'Yes',
        value: true
      }, {
        name: 'No',
        value: false
      }]
    }, {
        // onChange: this.onMenAvaliabilityChange.bind(this),
        // onCCTVChange: this.onCCTVChange.bind(this),
        // onChangeToilet: this.menToiletChange.bind(this),
        // onChangeBathRoom: this.menBathRoomChange.bind(this),
        // onChangeBathRoomCumToilet: this.menBathRoomCumToilet.bind(this),
        // onCleanlinessChange: this.menCleanlinessChange.bind(this),
        // availabilityOfFirstAidKitChange: this.menAvailabilityOfFirstAidKit.bind(this),
        // fireFightingEquipmentChange: this.menavailabilityOfFireFightingEquipment.bind(this),
        // biometricChange: this.menbiometricChange.bind(this),
        // availabilityOfDiningAreaChange: this.menavailabilityOfDiningAreaChange.bind(this),
        countOfDustbinDiningAreaRecreationalArea: this.menCountOfDustbinDiningAreaRecreational.bind(this),
        ceilingFanDiningRecreational: this.mencillingFanChangeDiningAreaRecreational.bind(this),
        wallMountedDiningRecreational: this.menwallFanChangeDiningAreaRecreational.bind(this),
        availabilityOfbulbDiningRecreational: this.menbulbChangeDiningAreaRecreational.bind(this),
        availabilityOfDiningAreaAndRecreationalAreaChange: this.menavailabilityOfDiningAreaAndRecreationalArea.bind(this),
        // mealsChange: this.menmealsChange.bind(this),
        // availabilityOfDustbinInDiningArea: this.menAvailabilityOfDustbinInDiningArea.bind(this),
        availabilityOfDustbinInDiningAreaRecreationalArea: this.menAvailabilityOfDustbinInDiningAreaRecreationalArea.bind(this),
        // countOfToiletChange: this.menCountOfToiletChange.bind(this),
        // countOfBathroomChange: this.menCountOfBathroomChange.bind(this),
        // countOfToiletCumBathroomChange: this.menCountOfToiletCumBathroomChange.bind(this),
        // diningAreaChange: this.mendiningAreaChange.bind(this),
        diningAreaRecreationalChange: this.mendiningAreaRecreationalChange.bind(this),
        // seperateEntranceChange: this.seperateEntranceChangeChange.bind(this),
        // totalAreaChange: this.menTotalAreaChange.bind(this),
        // totalResidentialCapacityChange: this.menTotalResidentialCapacityChange.bind(this)
      }, {
        label: 'Amenities',
        subLabel: 'Residential Area for Men:',
        cctvLabel: 'cctvMen',
        warden: {
          label: 'Male Warden:',
          placeholder: 'Select Male Warden',
        },
        hide: false,
        require: true,
        doctorLabel: 'Availability of Men Doctor on Call'
      })
  }

  womenFormCreation() {
    this.womenForm = getForms({
      typeOfConstructionBuilding:
        ['All walls of the Residential Facility should be well plastered,colored/distempered/whitewashed',
          'The floor should be cemented/tiled/mosaic/ceramic/hardwood/laminate/marble',
          'Walls/partition between rooms must connect the floor to the roof', 'There should not be any gap between the roof,the partition and the floor',
          'The rooms must be 100% covered by the roof'],
      meals: ['Lunch/Dinner', 'Breakfast', 'Evening Snacks/Tea'],
      houseKeepingStaff: ['Salary slip', 'Bank transaction', 'Appointment letter'],
      partitionsMadeOf: ['Brick Wall', 'Wooden', 'Gypsum Board'],
      // wallsOfResidentials: ['Well Plastere, Colored', 'distempered', 'whitewashed'],
      // floorOfTheResidentials: ['cemented, tiled', 'ceramic', 'hardwood', 'laminate', 'marbel'],
      menuList: this.menuListWoMen,
      areaAvailability: [{
        name: 'Yes',
        value: true
      }, {
        name: 'No',
        value: false
      }]
    }, {
        onChange: this.onWomenAvaliabilityChange.bind(this),
        onCCTVChange: this.onCCTVChange.bind(this),
        cctvChange: this.onCCTCDocumentChangeWoMen.bind(this),
        onCleanlinessChange: this.womenCleanlinessChange.bind(this),
        availabilityOfFirstAidKitChange: this.womenAvailabilityOfFirstAidKit.bind(this),
        fireFightingEquipmentChange: this.womenavailabilityOfFireFightingEquipment.bind(this),
        biometricChange: this.womenbiometricChange.bind(this),
        countOfDustbinChangeCleanandHygien: this.womenDustbinCleanandHygienChange.bind(this),
        //isMedicalContactChange:this.womenisMedicalContactChange.bind(this)

        // availabilityOfDiningAreaChange: this.womenavailabilityOfDiningAreaChange.bind(this),
        // availabilityOfDiningAreaAndRecreationalAreaChange: this.womenavailabilityOfDiningAreaAndRecreationalArea.bind(this),
        // mealsChange: this.womenmealsChange.bind(this),
        // availabilityOfDustbinInDiningArea:this.womenAvailabilityOfDustbinInDiningArea.bind(this),
        // availabilityOfDustbinInDiningAreaRecreationalArea: this.womenAvailabilityOfDustbinInDiningAreaRecreationalArea.bind(this),
        // countOfToiletChange: this.womenCountOfToiletChange.bind(this),
        // countOfBathroomChange: this.womenCountOfBathroomChang.bind(this),
        // countOfToiletCumBathroomChange: this.womenCountOfToiletCumBathroomChange.bind(this),
        // diningAreaChange: this.womendiningAreaChange.bind(this),
        // diningAreaRecreationalChange:this.womendiningAreaRecreationalChange.bind(this),
        // totalAreaChange:this.womenTotalAreaChange.bind(this),
        // totalResidentialCapacityChange:this.womenTotalResidentialCapacityChange.bind(this)
        //	onWomenAvaliabilityChange: this.onWomenAvaliabilityChange.bind(this)
      },
      {
        //	label: 'Residential Facilities for Women',
        subLabel: 'Residential Area for Women:',
        cctvLabel: 'cctvWomen',
        warden: {
          label: 'Female Warden:',
          placeholder: 'Select Female Warden',
        },
        hide: false,
        require: true,
        doctorLabel: 'Availability of Women Doctor on Call'
      });
    this.infraFormWomen.form = infraForms({
      typeOfConstructionBuilding:
        ['All walls of the Residential Facility should be well plastered,colored/distempered/whitewashed',
          'The floor should be cemented/tiled/mosaic/ceramic/hardwood/laminate/marble',
          'Walls/partition between rooms must connect the floor to the roof', 'There should not be any gap between the roof,the partition and the floor',
          'The rooms must be 100% covered by the roof'],
      meals: ['Lunch/Dinner', 'Breakfast', 'Evening Snacks/Tea'],
      houseKeepingStaff: ['Salary slip', 'Bank transaction', 'Appointment letter'],
      partitionsMadeOf: ['Brick Wall', 'Wooden', 'Gypsum Board'],
      // wallsOfResidentials: ['Well Plastere, Colored', 'distempered', 'whitewashed'],
      // floorOfTheResidentials: ['cemented, tiled', 'ceramic', 'hardwood', 'laminate', 'marbel'],
      menuList: this.menuListWoMen,
      areaAvailability: [{
        name: 'Yes',
        value: true
      }, {
        name: 'No',
        value: false
      }]
    }, {
        // onChange: this.onWomenAvaliabilityChange.bind(this),
        // onCCTVChange: this.onCCTVChange.bind(this),
        // onChangeToilet: this.womenToiletChange.bind(this),
        // onChangeBathRoom: this.womenBathRoomChange.bind(this),
        // onChangeBathRoomCumToilet: this.womenBathRoomCumToilet.bind(this),
        // onCleanlinessChange: this.womenCleanlinessChange.bind(this),
        // availabilityOfFirstAidKitChange: this.womenAvailabilityOfFirstAidKit.bind(this),
        // fireFightingEquipmentChange: this.womenavailabilityOfFireFightingEquipment.bind(this),
        // biometricChange: this.womenbiometricChange.bind(this),
        // availabilityOfDiningAreaChange: this.womenavailabilityOfDiningAreaChange.bind(this),
        // availabilityOfDiningAreaAndRecreationalAreaChange: this.womenavailabilityOfDiningAreaAndRecreationalArea.bind(this),
        // mealsChange: this.womenmealsChange.bind(this),
        // availabilityOfDustbinInDiningArea:this.womenAvailabilityOfDustbinInDiningArea.bind(this),
        // availabilityOfDustbinInDiningAreaRecreationalArea: this.womenAvailabilityOfDustbinInDiningAreaRecreationalArea.bind(this),
        // onChangeToilet: this.menToiletChange.bind(this),
        onChangeBathRoom: this.womenBathRoomChange.bind(this),
        onChangeBathRoomCumToilet: this.womenBathRoomCumToilet.bind(this),
        onChangeToilet: this.womenToiletChange.bind(this),
        countOfToiletChange: this.womenCountOfToiletChange.bind(this),
        countOfBathroomChange: this.womenCountOfBathroomChang.bind(this),
        countOfToiletCumBathroomChange: this.womenCountOfToiletCumBathroomChange.bind(this),
        // diningAreaChange: this.womendiningAreaChange.bind(this),
        // diningAreaRecreationalChange:this.womendiningAreaRecreationalChange.bind(this),
        // totalAreaChange:this.womenTotalAreaChange.bind(this),
        // totalResidentialCapacityChange:this.womenTotalResidentialCapacityChange.bind(this)
        //	onWomenAvaliabilityChange: this.onWomenAvaliabilityChange.bind(this)
      },
      {
        label: 'Residential Facilities for Women',
        subLabel: 'Residential Area for Women:',
        cctvLabel: 'cctvWomen',
        warden: {
          label: 'Female Warden:',
          placeholder: 'Select Female Warden',
        },
        hide: false,
        require: true,
        doctorLabel: 'Availability of Women Doctor on Call'
      });
    this.diningAreaFormsWomen.form = diningAreaForms({
      typeOfConstructionBuilding:
        ['All walls of the Residential Facility should be well plastered,colored/distempered/whitewashed',
          'The floor should be cemented/tiled/mosaic/ceramic/hardwood/laminate/marble',
          'Walls/partition between rooms must connect the floor to the roof', 'There should not be any gap between the roof,the partition and the floor',
          'The rooms must be 100% covered by the roof'],
      houseKeepingStaff: ['Salary slip', 'Bank transaction', 'Appointment letter'],
      meals: ['Lunch/Dinner', 'Breakfast', 'Evening Snacks/Tea'],
      partitionsMadeOf: ['Brick Wall', 'Wooden', 'Gypsum Board'],
      // wallsOfResidentials: [{ name: 'Well Plastere, Colored', value: 'Well Plastere, Colored' }, { name: 'distempered', value: 'distempered' }, { name: 'whitewashed', value: 'whitewashed' }],
      // floorOfTheResidentials: ['cemented, tiled', 'ceramic', 'hardwood', 'laminate', 'marbel'],
      menuList: this.menuListMen,
      areaAvailability: [{
        name: 'Yes',
        value: true
      }, {
        name: 'No',
        value: false
      }]
    }, {
        // onChange: this.onMenAvaliabilityChange.bind(this),
        // onCCTVChange: this.onCCTVChange.bind(this),

        // onCleanlinessChange: this.menCleanlinessChange.bind(this),
        // availabilityOfFirstAidKitChange: this.menAvailabilityOfFirstAidKit.bind(this),
        // fireFightingEquipmentChange: this.menavailabilityOfFireFightingEquipment.bind(this),
        // biometricChange: this.menbiometricChange.bind(this),
        cillingFanChangeDiningArea: this.womencillingFanChangeDiningArea.bind(this),
        wallFanChangeDiningArea: this.womenwallFanChangeDiningArea.bind(this),
        bulbChangeDiningArea: this.womenbulbChangeDiningArea.bind(this),
        availabilityOfDiningAreaChange: this.womenavailabilityOfDiningAreaChange.bind(this),
        // availabilityOfDiningAreaAndRecreationalAreaChange: this.menavailabilityOfDiningAreaAndRecreationalArea.bind(this),
        // mealsChange: this.menmealsChange.bind(this),
        availabilityOfDustbinInDiningArea: this.womenAvailabilityOfDustbinInDiningArea.bind(this),
        // availabilityOfDustbinInDiningAreaRecreationalArea: this.menAvailabilityOfDustbinInDiningAreaRecreationalArea.bind(this),
        // countOfToiletChange: this.menCountOfToiletChange.bind(this),
        // countOfBathroomChange: this.menCountOfBathroomChange.bind(this),
        // countOfToiletCumBathroomChange: this.menCountOfToiletCumBathroomChange.bind(this),
        diningAreaChange: this.womendiningAreaChange.bind(this),
        // diningAreaRecreationalChange: this.mendiningAreaRecreationalChange.bind(this),
        // seperateEntranceChange: this.seperateEntranceChangeChange.bind(this),
        // totalAreaChange: this.menTotalAreaChange.bind(this),
        // totalResidentialCapacityChange: this.menTotalResidentialCapacityChange.bind(this)
      }, {
        label: 'Residential Facilities for Women',
        subLabel: 'Residential Area for Women:',
        cctvLabel: 'cctvWomen',
        warden: {
          label: 'Female Warden:',
          placeholder: 'Select Female Warden',
        },
        hide: false,
        require: true,
        doctorLabel: 'Availability of Women Doctor on Call'
      })
    this.diningAreaRecreationalFormsWomen.form = diningAreaRecreationalForms({
      typeOfConstructionBuilding:
        ['All walls of the Residential Facility should be well plastered,colored/distempered/whitewashed',
          'The floor should be cemented/tiled/mosaic/ceramic/hardwood/laminate/marble',
          'Walls/partition between rooms must connect the floor to the roof', 'There should not be any gap between the roof,the partition and the floor',
          'The rooms must be 100% covered by the roof'],
      houseKeepingStaff: ['Salary slip', 'Bank transaction', 'Appointment letter'],
      meals: ['Lunch/Dinner', 'Breakfast', 'Evening Snacks/Tea'],
      partitionsMadeOf: ['Brick Wall', 'Wooden', 'Gypsum Board'],
      // wallsOfResidentials: [{ name: 'Well Plastere, Colored', value: 'Well Plastere, Colored' }, { name: 'distempered', value: 'distempered' }, { name: 'whitewashed', value: 'whitewashed' }],
      // floorOfTheResidentials: ['cemented, tiled', 'ceramic', 'hardwood', 'laminate', 'marbel'],
      menuList: this.menuListMen,
      areaAvailability: [{
        name: 'Yes',
        value: true
      }, {
        name: 'No',
        value: false
      }]
    }, {
        // onChange: this.onMenAvaliabilityChange.bind(this),
        // onCCTVChange: this.onCCTVChange.bind(this),
        // onChangeToilet: this.menToiletChange.bind(this),
        // onChangeBathRoom: this.menBathRoomChange.bind(this),
        // onChangeBathRoomCumToilet: this.menBathRoomCumToilet.bind(this),
        // onCleanlinessChange: this.menCleanlinessChange.bind(this),
        // availabilityOfFirstAidKitChange: this.menAvailabilityOfFirstAidKit.bind(this),
        // fireFightingEquipmentChange: this.menavailabilityOfFireFightingEquipment.bind(this),
        // biometricChange: this.menbiometricChange.bind(this),
        // availabilityOfDiningAreaChange: this.menavailabilityOfDiningAreaChange.bind(this),
        countOfDustbinDiningAreaRecreationalArea: this.womenCountOfDustbinDiningAreaRecreational.bind(this),
        ceilingFanDiningRecreational: this.womencillingFanChangeDiningAreaRecreational.bind(this),
        wallMountedDiningRecreational: this.womenwallFanChangeDiningAreaRecreational.bind(this),
        availabilityOfbulbDiningRecreational: this.womenbulbChangeDiningAreaRecreational.bind(this),
        // availabilityOfDiningAreaChange: this.menavailabilityOfDiningAreaChange.bind(this),
        availabilityOfDiningAreaAndRecreationalAreaChange: this.womenavailabilityOfDiningAreaAndRecreationalArea.bind(this),
        // mealsChange: this.menmealsChange.bind(this),
        // availabilityOfDustbinInDiningArea: this.menAvailabilityOfDustbinInDiningArea.bind(this),
        availabilityOfDustbinInDiningAreaRecreationalArea: this.womenAvailabilityOfDustbinInDiningAreaRecreationalArea.bind(this),
        // countOfToiletChange: this.menCountOfToiletChange.bind(this),
        // countOfBathroomChange: this.menCountOfBathroomChange.bind(this),
        // countOfToiletCumBathroomChange: this.menCountOfToiletCumBathroomChange.bind(this),
        // diningAreaChange: this.mendiningAreaChange.bind(this),
        diningAreaRecreationalChange: this.womendiningAreaRecreationalChange.bind(this),
        // seperateEntranceChange: this.seperateEntranceChangeChange.bind(this),
        // totalAreaChange: this.menTotalAreaChange.bind(this),
        // totalResidentialCapacityChange: this.menTotalResidentialCapacityChange.bind(this)
      }, {
        label: 'Residential Facilities for Women',
        subLabel: 'Residential Area for Women:',
        cctvLabel: 'cctvWomen',
        warden: {
          label: 'Female Warden:',
          placeholder: 'Select Female Warden',
        },
        hide: false,
        require: true,
        doctorLabel: 'Availability of Women Doctor on Call'
      })
  }

  mencillingFanChangeDiningArea(value) {
    this.diningAreaFormsMen['control'].hideFields(['numberOfCeilingFanDiningArea'], value == true ? false : true)
  }

  menwallFanChangeDiningArea(value) {
    this.diningAreaFormsMen['control'].hideFields(['numberOfWallMountedDiningArea'], value == true ? false : true)
  }
  menbulbChangeDiningArea(value) {
    this.diningAreaFormsMen['control'].hideFields(['numberOfBulbDiningArea'], value == false ? true : false);
    // if (value == true &&this.diningAreaFormsMen) {
    // 	let minimum;
    // 	let maximum;
    // //	this.diningAreaFormsMen['control'].patchValues({ numberOfBulbDiningArea: 70 })
    // 	this.calcualteBulbRequirement(this.diningAreaFormsMen,'diningArea','numberOfBulbDiningArea');
    // 	const  diningArea =this.diningAreaFormsMen['formData'].diningArea;
    // 	if ( diningArea == 70) {
    // 		//numberOFBulb = 1;
    // 		minimum = 1;
    // 		maximum = 1;

    // 	} else if (diningArea > 70 && diningArea <= 139) {
    // 		minimum = 2;
    // 		maximum = 2;
    // 		//numberOFBulb =  2;
    // 	} else if (diningArea >= 140 && diningArea <= 220) {
    // 		minimum = 3;
    // 		maximum = 3;
    // 	//	numberOFBulb =  3;
    // 	} else if (diningArea >= 221 && diningArea <= 279) {
    // 		minimum = 4;
    // 		maximum = 4;
    // 	//	numberOFBulb =  4;
    // 	} else if (diningArea >= 280) {
    // 		minimum = 5;
    // 		maximum = 5;
    // 		//numberOFBulb =  5;
    // 	}
    // 	this.diningAreaFormsMen['control'].updateFormValidation({
    // 		numberOfBulbDiningArea: {
    // 			min: minimum,
    // 			max:maximum
    // 		}
    // 	})
    // 	// this.diningAreaFormsMen['control'].makeFieldsReadOnly(['numberOfBulbDiningArea'],true)
    // }
    this.calculateBulbValidation(value, this.diningAreaFormsMen, 'diningArea', 'numberOfBulbDiningArea');
    console.log(this.diningAreaFormsMen['formData']);
  }
  calculateBulbValidation(availability, FormGroup, FormControlName, nameOfBulb) {
    if (availability == true) {
      let minimum;
      let maximum;
      //	this.diningAreaFormsMen['control'].patchValues({ numberOfBulbDiningArea: 70 })
      const diningArea = FormGroup['formData'][FormControlName];
      if (diningArea == 70) {
        //numberOFBulb = 1;
        minimum = 1;
        maximum = 1;

      } else if (diningArea > 70 && diningArea <= 139) {
        minimum = 2;
        maximum = 2;
        //numberOFBulb =  2;
      } else if (diningArea >= 140 && diningArea <= 220) {
        minimum = 3;
        maximum = 3;
        //	numberOFBulb =  3;
      } else if (diningArea >= 221 && diningArea <= 279) {
        minimum = 4;
        maximum = 4;
        //	numberOFBulb =  4;
      } else if (diningArea >= 280) {
        minimum = 5;
        maximum = 5;
        //numberOFBulb =  5;
      }
      //numberOfBulbDiningArea
      // FormGroup['control'].updateFormValidation({
      // 	[nameOfBulb]: {
      // 		min: minimum,
      // 		max:maximum
      // 	}
      // })
      //FormGroup['control'].makeFieldsReadOnly([nameOfBulb], true);
      FormGroup['control'].updateFormValidation({
        [nameOfBulb]: {
          max: maximum,
          min: minimum
        }
      })
      console.log(this.diningAreaFormsMen['formData']);
      // FormGroup['control'].makeFieldsReadOnly([nameOfBulb],true)
      // this.diningAreaFormsMen['control'].makeFieldsReadOnly(['numberOfBulbDiningArea'],true)
    }
  }
  typeOfMatressChange(value, idx, idxCotDtails) {
    if (value == 'Cotton') {
      this.roomFormGroup.get('cotType')['controls'][idx].get('cotDetails')['controls'][idxCotDtails].get('matressThickness').setValidators([Validators.required, Validators.min(3)])
      this.roomFormGroup.get('cotType')['controls'][idx].get('cotDetails')['controls'][idxCotDtails].get('matressThickness').updateValueAndValidity()
      this.roomFormGroup.get('cotType')['controls'][idx].get('cotDetails')['controls'][idxCotDtails].get('matressThickness').markAsTouched();

    } else {
      this.roomFormGroup.get('cotType')['controls'][idx].get('cotDetails')['controls'][idxCotDtails].get('matressThickness').setValidators([Validators.required, Validators.min(5)])
      this.roomFormGroup.get('cotType')['controls'][idx].get('cotDetails')['controls'][idxCotDtails].get('matressThickness').updateValueAndValidity()
      this.roomFormGroup.get('cotType')['controls'][idx].get('cotDetails')['controls'][idxCotDtails].get('matressThickness').markAsTouched()
    }
  }
  // calcualteBulbRequirement(value,nameOfarea,nameOfBulb) {
  // 	let numberOfBulbs = 0;
  // 	if (value['formData'][nameOfarea]>70) {
  // 		numberOfBulbs = value['formData'][nameOfarea] / 70;
  // 	}
  // 	const valueToPatch = { [nameOfBulb]: Math.trunc(numberOfBulbs) };
  // 	value['control'].patchValues(valueToPatch);
  // }
  mencillingFanChangeDiningAreaRecreational(value) {
    this.diningAreaRecreationalFormsMen['control'].hideFields(['numberOfCeilingDiningRecreationArea'], value == true ? false : true)
  }
  menwallFanChangeDiningAreaRecreational(value) {
    this.diningAreaRecreationalFormsMen['control'].hideFields(['numberOfMountedFanDiningRecreationalArea'], value == true ? false : true)
  }
  menbulbChangeDiningAreaRecreational(value) {
    this.diningAreaRecreationalFormsMen['control'].hideFields(['numberOfBulbDiningAreaRecreationalArea'], value == true ? false : true)
    if (value) {
      this.calculateBulbValidation(value, this.diningAreaRecreationalFormsMen, 'diningAreaAndRecreationalArea', 'numberOfBulbDiningAreaRecreationalArea');
      //this.calcualteBulbRequirement(this.diningAreaRecreationalFormsMen,'diningAreaAndRecreationalArea','numberOfBulbDiningAreaRecreationalArea');
    }
  }
  womencillingFanChangeDiningArea(value) {
    this.diningAreaFormsWomen['control'].hideFields(['numberOfCeilingFanDiningArea'], value == true ? false : true)
  }

  womenwallFanChangeDiningArea(value) {
    this.diningAreaFormsWomen['control'].hideFields(['numberOfWallMountedDiningArea'], value == true ? false : true)
  }
  womenbulbChangeDiningArea(value) {
    if (value) {
      this.calculateBulbValidation(value, this.diningAreaFormsWomen, 'diningArea', 'numberOfBulbDiningArea');
      //this.calcualteBulbRequirement(this.diningAreaFormsWomen,'diningArea','numberOfBulbDiningArea');
    }
    this.diningAreaFormsWomen['control'].hideFields(['numberOfBulbDiningArea'], value == true ? false : true)
  }
  womencillingFanChangeDiningAreaRecreational(value) {
    this.diningAreaRecreationalFormsWomen['control'].hideFields(['numberOfCeilingDiningRecreationArea'], value == true ? false : true)
  }
  womenwallFanChangeDiningAreaRecreational(value) {
    this.diningAreaRecreationalFormsWomen['control'].hideFields(['numberOfMountedFanDiningRecreationalArea'], value == true ? false : true)
  }
  womenbulbChangeDiningAreaRecreational(value) {
    if (value) {
      this.calculateBulbValidation(value, this.diningAreaRecreationalFormsWomen, 'diningAreaAndRecreationalArea', 'numberOfBulbDiningAreaRecreationalArea');

      //this.calcualteBulbRequirement(this.diningAreaRecreationalFormsWomen,'diningAreaAndRecreationalArea','numberOfBulbDiningAreaRecreationalArea');
    }
    this.diningAreaRecreationalFormsWomen['control'].hideFields(['numberOfBulbDiningAreaRecreationalArea'], value == true ? false : true)
  }
  transgendercillingFanChangeDiningArea(value) {
    this.diningAreaFormsTransgender['control'].hideFields(['numberOfCeilingFanDiningArea'], value == true ? false : true)
  }

  transgenderwallFanChangeDiningArea(value) {
    this.diningAreaFormsTransgender['control'].hideFields(['numberOfWallMountedDiningArea'], value == true ? false : true)
  }
  transgenderbulbChangeDiningArea(value) {
    if (value) {
      this.calculateBulbValidation(value, this.diningAreaFormsTransgender, 'diningArea', 'numberOfBulbDiningArea');
      //	this.calcualteBulbRequirement(this.diningAreaFormsTransgender,'diningArea','numberOfBulbDiningArea');
    }
    this.diningAreaFormsTransgender['control'].hideFields(['numberOfBulbDiningArea'], value == true ? false : true)
  }
  transgendercillingFanChangeDiningAreaRecreational(value) {
    this.diningAreaRecreationalFormsTransgender['control'].hideFields(['numberOfCeilingFanDiningAreaRecreationalArea'], value == true ? false : true)
  }
  transgenderwallFanChangeDiningAreaRecreational(value) {
    this.diningAreaRecreationalFormsTransgender['control'].hideFields(['numberOfWallMountedDiningAreaRecreationalArea'], value == true ? false : true)
  }
  transgenderbulbChangeDiningAreaRecreational(value) {
    if (value) {
      this.calculateBulbValidation(value, this.diningAreaRecreationalFormsTransgender, 'diningAreaAndRecreationalArea', 'numberOfBulbDiningAreaRecreationalArea');

      //this.calcualteBulbRequirement(this.diningAreaRecreationalFormsTransgender,'diningArea','numberOfBulbDiningAreaRecreationalArea');
    }
    this.diningAreaRecreationalFormsTransgender['control'].hideFields(['numberOfBulbDiningAreaRecreationalArea'], value == true ? false : true)
  }
  transgenderFormCreation() {
    this.transgenderForm = getForms({
      typeOfConstructionBuilding:
        ['All walls of the Residential Facility should be well plastered,colored/distempered/whitewashed',
          'The floor should be cemented/tiled/mosaic/ceramic/hardwood/laminate/marble',
          'Walls/partition between rooms must connect the floor to the roof', 'There should not be any gap between the roof,the partition and the floor',
          'The rooms must be 100% covered by the roof'],
      meals: ['Lunch/Dinner', 'Breakfast', 'Evening Snacks/Tea'],
      houseKeepingStaff: ['Salary slip', 'Bank transaction', 'Appointment letter'],
      partitionsMadeOf: ['Brick Wall', 'Wooden', 'Gypsum Board'],
      // wallsOfResidentials: ['Well Plastere, Colored', 'distempered', 'whitewashed'],
      // floorOfTheResidentials: ['cemented, tiled', 'ceramic', 'hardwood', 'laminate', 'marbel'],
      menuList: this.menuListTransgender,
      areaAvailability: [{
        name: 'Yes',
        value: true
      }, {
        name: 'No',
        value: false
      }]
    }, {
        onChange: this.onTransgenderAvaliabilityChange.bind(this),
        onCCTVChange: this.onCCTVChange.bind(this),
        cctvChange: this.onCCTCDocumentChangeTransgender.bind(this),
        onCleanlinessChange: this.transgenderCleanlinessChange.bind(this),
        availabilityOfFirstAidKitChange: this.transgenderAvailabilityOfFirstAidKit.bind(this),
        fireFightingEquipmentChange: this.transgenderavailabilityOfFireFightingEquipment.bind(this),
        biometricChange: this.transgenderbiometricChange.bind(this),
        countOfDustbinChangeCleanandHygien: this.transgenderDustbinCleanandHygienChange.bind(this),
        //isMedicalContactChange:this.transgenderisMedicalContactChange.bind(this)
        // availabilityOfDiningAreaChange: this.transgenderavailabilityOfDiningAreaChange.bind(this),
        // availabilityOfDiningAreaAndRecreationalAreaChange: this.transgenderavailabilityOfDiningAreaAndRecreationalArea.bind(this),
        // mealsChange: this.transgendermealsChange.bind(this),
        // availabilityOfDustbinInDiningArea:this.transgenderAvailabilityOfDustbinInDiningArea.bind(this),
        // //	onWomenAvaliabilityChange: this.onWomenAvaliabilityChange.bind(this)
        // availabilityOfDustbinInDiningAreaRecreationalArea: this.transgenderAvailabilityOfDustbinInDiningAreaRecreationalArea.bind(this),
        // countOfToiletChange: this.transgenderCountOfToiletChange.bind(this),
        // countOfBathroomChange: this.transgenderCountOfBathroomChang.bind(this),
        // countOfToiletCumBathroomChange: this.transgenderCountOfToiletCumBathroomChangee.bind(this),
        // diningAreaChange: this.transgenderdiningAreaChange.bind(this),
        // diningAreaRecreationalChange:this.transgenderdiningAreaRecreationalChange.bind(this),
        // totalAreaChange:this.transgenderTotalAreaChange.bind(this),
        // totalResidentialCapacityChange:this.transgenderTotalResidentialCapacityChange.bind(this)
      }, {
        //	label: 'Residential Facilities for Transgender',
        subLabel: 'Residential Area for Transgender:',
        cctvLabel: 'cctvTransgender',
        warden: {
          label: 'Transgender Warden:',
          placeholder: 'Select Transgender Warden'
        },
        hide: true,
        require: false,
        doctorLabel: 'Availability of Doctor on Call'
      });
    this.infraFormTransgender.form = infraForms({
      typeOfConstructionBuilding:
        ['All walls of the Residential Facility should be well plastered,colored/distempered/whitewashed',
          'The floor should be cemented/tiled/mosaic/ceramic/hardwood/laminate/marble',
          'Walls/partition between rooms must connect the floor to the roof', 'There should not be any gap between the roof,the partition and the floor',
          'The rooms must be 100% covered by the roof'],
      meals: ['Lunch/Dinner', 'Breakfast', 'Evening Snacks/Tea'],
      houseKeepingStaff: ['Salary slip', 'Bank transaction', 'Appointment letter'],
      partitionsMadeOf: ['Brick Wall', 'Wooden', 'Gypsum Board'],
      // wallsOfResidentials: ['Well Plastere, Colored', 'distempered', 'whitewashed'],
      // floorOfTheResidentials: ['cemented, tiled', 'ceramic', 'hardwood', 'laminate', 'marbel'],
      menuList: this.menuListWoMen,
      areaAvailability: [{
        name: 'Yes',
        value: true
      }, {
        name: 'No',
        value: false
      }]
    }, {
        // onChange: this.onWomenAvaliabilityChange.bind(this),
        // onCCTVChange: this.onCCTVChange.bind(this),
        // onChangeToilet: this.womenToiletChange.bind(this),
        // onChangeBathRoom: this.womenBathRoomChange.bind(this),
        // onChangeBathRoomCumToilet: this.womenBathRoomCumToilet.bind(this),
        // onCleanlinessChange: this.womenCleanlinessChange.bind(this),
        // availabilityOfFirstAidKitChange: this.womenAvailabilityOfFirstAidKit.bind(this),
        // fireFightingEquipmentChange: this.womenavailabilityOfFireFightingEquipment.bind(this),
        // biometricChange: this.womenbiometricChange.bind(this),
        // availabilityOfDiningAreaChange: this.womenavailabilityOfDiningAreaChange.bind(this),
        // availabilityOfDiningAreaAndRecreationalAreaChange: this.womenavailabilityOfDiningAreaAndRecreationalArea.bind(this),
        // mealsChange: this.womenmealsChange.bind(this),
        // availabilityOfDustbinInDiningArea:this.womenAvailabilityOfDustbinInDiningArea.bind(this),
        // availabilityOfDustbinInDiningAreaRecreationalArea: this.womenAvailabilityOfDustbinInDiningAreaRecreationalArea.bind(this),
        onChangeToilet: this.transgenderToiletChange.bind(this),
        onChangeBathRoom: this.transgenderBathRoomChange.bind(this),
        onChangeBathRoomCumToilet: this.transgenderBathRoomCumToilet.bind(this),
        countOfToiletChange: this.transgenderCountOfToiletChange.bind(this),
        countOfBathroomChange: this.transgenderCountOfBathroomChang.bind(this),
        countOfToiletCumBathroomChange: this.transgenderCountOfToiletCumBathroomChangee.bind(this),
        // diningAreaChange: this.womendiningAreaChange.bind(this),
        // diningAreaRecreationalChange:this.womendiningAreaRecreationalChange.bind(this),
        // totalAreaChange:this.womenTotalAreaChange.bind(this),
        // totalResidentialCapacityChange:this.womenTotalResidentialCapacityChange.bind(this)
        //	onWomenAvaliabilityChange: this.onWomenAvaliabilityChange.bind(this)
      },
      {
        //	label: 'Residential Facilities for Transgender',
        subLabel: 'Residential Area for Transgender:',
        cctvLabel: 'cctvTransgender',
        warden: {
          label: 'Transgender Warden:',
          placeholder: 'Select Transgender Warden'
        },
        hide: true,
        require: false,
        doctorLabel: 'Availability of Doctor on Call'
      });
    this.diningAreaFormsTransgender.form = diningAreaForms({
      typeOfConstructionBuilding:
        ['All walls of the Residential Facility should be well plastered,colored/distempered/whitewashed',
          'The floor should be cemented/tiled/mosaic/ceramic/hardwood/laminate/marble',
          'Walls/partition between rooms must connect the floor to the roof', 'There should not be any gap between the roof,the partition and the floor',
          'The rooms must be 100% covered by the roof'],
      houseKeepingStaff: ['Salary slip', 'Bank transaction', 'Appointment letter'],
      meals: ['Lunch/Dinner', 'Breakfast', 'Evening Snacks/Tea'],
      partitionsMadeOf: ['Brick Wall', 'Wooden', 'Gypsum Board'],
      // wallsOfResidentials: [{ name: 'Well Plastere, Colored', value: 'Well Plastere, Colored' }, { name: 'distempered', value: 'distempered' }, { name: 'whitewashed', value: 'whitewashed' }],
      // floorOfTheResidentials: ['cemented, tiled', 'ceramic', 'hardwood', 'laminate', 'marbel'],
      menuList: this.menuListMen,
      areaAvailability: [{
        name: 'Yes',
        value: true
      }, {
        name: 'No',
        value: false
      }]
    }, {
        // onChange: this.onMenAvaliabilityChange.bind(this),
        // onCCTVChange: this.onCCTVChange.bind(this),
        // onChangeToilet: this.menToiletChange.bind(this),
        // onChangeBathRoom: this.menBathRoomChange.bind(this),
        // onChangeBathRoomCumToilet: this.menBathRoomCumToilet.bind(this),
        // onCleanlinessChange: this.menCleanlinessChange.bind(this),
        // availabilityOfFirstAidKitChange: this.menAvailabilityOfFirstAidKit.bind(this),
        // fireFightingEquipmentChange: this.menavailabilityOfFireFightingEquipment.bind(this),
        // biometricChange: this.menbiometricChange.bind(this),
        availabilityOfDiningAreaChange: this.transgenderavailabilityOfDiningAreaChange.bind(this),
        cillingFanChangeDiningArea: this.transgendercillingFanChangeDiningArea.bind(this),
        wallFanChangeDiningArea: this.transgenderwallFanChangeDiningArea.bind(this),
        bulbChangeDiningArea: this.transgenderbulbChangeDiningArea.bind(this),
        //availabilityOfDiningAreaAndRecreationalAreaChange: this.menavailabilityOfDiningAreaAndRecreationalArea.bind(this),
        //mealsChange: this.menmealsChange.bind(this),
        availabilityOfDustbinInDiningArea: this.transgenderAvailabilityOfDustbinInDiningArea.bind(this),
        // availabilityOfDustbinInDiningAreaRecreationalArea: this.menAvailabilityOfDustbinInDiningAreaRecreationalArea.bind(this),
        // countOfToiletChange: this.menCountOfToiletChange.bind(this),
        // countOfBathroomChange: this.menCountOfBathroomChange.bind(this),
        // countOfToiletCumBathroomChange: this.menCountOfToiletCumBathroomChange.bind(this),
        diningAreaChange: this.transgenderdiningAreaChange.bind(this),
        // diningAreaRecreationalChange: this.mendiningAreaRecreationalChange.bind(this),
        // seperateEntranceChange: this.seperateEntranceChangeChange.bind(this),
        // totalAreaChange: this.menTotalAreaChange.bind(this),
        // totalResidentialCapacityChange: this.menTotalResidentialCapacityChange.bind(this)
      }, {
        //	label: 'Residential Facilities for Transgender',
        subLabel: 'Residential Area for Transgender:',
        cctvLabel: 'cctvTransgender',
        warden: {
          label: 'Transgender Warden:',
          placeholder: 'Select Transgender Warden'
        },
        hide: true,
        require: false,
        doctorLabel: 'Availability of Doctor on Call'
      })
    this.diningAreaRecreationalFormsTransgender.form = diningAreaRecreationalForms({
      typeOfConstructionBuilding:
        ['All walls of the Residential Facility should be well plastered,colored/distempered/whitewashed',
          'The floor should be cemented/tiled/mosaic/ceramic/hardwood/laminate/marble',
          'Walls/partition between rooms must connect the floor to the roof', 'There should not be any gap between the roof,the partition and the floor',
          'The rooms must be 100% covered by the roof'],
      houseKeepingStaff: ['Salary slip', 'Bank transaction', 'Appointment letter'],
      meals: ['Lunch/Dinner', 'Breakfast', 'Evening Snacks/Tea'],
      partitionsMadeOf: ['Brick Wall', 'Wooden', 'Gypsum Board'],
      // wallsOfResidentials: [{ name: 'Well Plastere, Colored', value: 'Well Plastere, Colored' }, { name: 'distempered', value: 'distempered' }, { name: 'whitewashed', value: 'whitewashed' }],
      // floorOfTheResidentials: ['cemented, tiled', 'ceramic', 'hardwood', 'laminate', 'marbel'],
      menuList: this.menuListMen,
      areaAvailability: [{
        name: 'Yes',
        value: true
      }, {
        name: 'No',
        value: false
      }]
    }, {
        // onChange: this.onMenAvaliabilityChange.bind(this),
        // onCCTVChange: this.onCCTVChange.bind(this),
        // onChangeToilet: this.menToiletChange.bind(this),
        // onChangeBathRoom: this.menBathRoomChange.bind(this),
        // onChangeBathRoomCumToilet: this.menBathRoomCumToilet.bind(this),
        // onCleanlinessChange: this.menCleanlinessChange.bind(this),
        // availabilityOfFirstAidKitChange: this.menAvailabilityOfFirstAidKit.bind(this),
        // fireFightingEquipmentChange: this.menavailabilityOfFireFightingEquipment.bind(this),
        // biometricChange: this.menbiometricChange.bind(this),
        // availabilityOfDiningAreaChange: this.menavailabilityOfDiningAreaChange.bind(this),
        countOfDustbinDiningAreaRecreationalArea: this.transgenderCountOfDustbinDiningAreaRecreational.bind(this),
        ceilingFanDiningRecreational: this.transgendercillingFanChangeDiningAreaRecreational.bind(this),
        wallMountedDiningRecreational: this.transgenderwallFanChangeDiningAreaRecreational.bind(this),
        availabilityOfbulbDiningRecreational: this.transgenderbulbChangeDiningAreaRecreational.bind(this),
        availabilityOfDiningAreaAndRecreationalAreaChange: this.transgenderavailabilityOfDiningAreaAndRecreationalArea.bind(this),
        // mealsChange: this.menmealsChange.bind(this),
        // availabilityOfDustbinInDiningArea: this.menAvailabilityOfDustbinInDiningArea.bind(this),
        availabilityOfDustbinInDiningAreaRecreationalArea: this.transgenderAvailabilityOfDustbinInDiningAreaRecreationalArea.bind(this),
        // countOfToiletChange: this.menCountOfToiletChange.bind(this),
        // countOfBathroomChange: this.menCountOfBathroomChange.bind(this),
        // countOfToiletCumBathroomChange: this.menCountOfToiletCumBathroomChange.bind(this),
        // diningAreaChange: this.mendiningAreaChange.bind(this),
        diningAreaRecreationalChange: this.transgenderdiningAreaRecreationalChange.bind(this),
        // seperateEntranceChange: this.seperateEntranceChangeChange.bind(this),
        // totalAreaChange: this.menTotalAreaChange.bind(this),
        // totalResidentialCapacityChange: this.menTotalResidentialCapacityChange.bind(this)
      }, {
        //	label: 'Residential Facilities for Transgender',
        subLabel: 'Residential Area for Transgender:',
        cctvLabel: 'cctvTransgender',
        warden: {
          label: 'Transgender Warden:',
          placeholder: 'Select Transgender Warden'
        },
        hide: true,
        require: false,
        doctorLabel: 'Availability of Doctor on Call'
      })
  }
  onFormLoaded() {
    this.formLoad = true;
    // if (this.buffer && this.buffer.length) {
    // 	for (const fn of this.buffer) {
    // 		if (typeof fn === 'function') {
    // 			fn();
    // 		}
    // 	}
    // }
  }
  patchDefaultValuesofHomePage(data) {
    if (data) {
      this.homePageFormGroup.get('totalArea').patchValue(data.totalArea);
      this.homePageFormGroup.get('totalCapacity').patchValue(data.totalCapacity);
      this.homePageFormGroup.get('nameOfResidentialFacility').patchValue(data.nameOfResidentialFacility);
      this.homePageFormGroup.get('availabilityOfDisplayBoardFrontBuild').patchValue(data.availabilityOfDisplayBoardFrontBuild);
    }
    // if (data && data.men && data.type.men == true) {
    // 	this.residentialFormGroup.get('menForm')
    // }
    // if (data && data.women &&data.type.women == true) {

    // }
    // if (data && data.transgender &&data.type.transgender == true) {

    // }

  }
  mycallBack(res) {
    //console.log('Hai i called');
    console.log(res);
  }
  getUserDetails(mycallBack: (result: any) => void) {
    this.activatedRoute.data.subscribe(res => {
      console.log(res, 'form Data');
      if (res.formData) {
        res = res.formData;
        this.userDetails = res
      }
      console.log(this.userDetails, '------------------');

      console.log(this.userService.getResidentialData(this.userDetails && this.userDetails.userName));
      this.residentialFacilitiesValidity = this.userService.getResidentialData(this.userDetails && this.userDetails.userName)
      this.patchDefaultValuesofHomePage(res && res.residentialFacilities);
      // if (res && res.general && res.general.tccompleted) {
      // 	this.incomingGeneraldata = {
      // 		tccompleted: res.general.tccompleted ? res.general.tccompleted : false,
      // 		trainingcenterphotos: res.general.trainingcenterphotos ? res.general.trainingcenterphotos : {}
      // 	}
      // }
      mycallBack(res)

      if (res && res.residentialFacilities && res.residentialFacilities.men && res.residentialFacilities.men.availability == true) {
        this.menRooms = res.residentialFacilities.men.rooms;
        if (this.menRooms && this.menRooms.length > 0) {
          this.validity['menRooms'] = true
        }
        if (res.residentialFacilities.men.address) {
          this.data.addressForMen = this.mapIncomingAddress(res.residentialFacilities.men.address);
        }
        if (res.residentialFacilities.men && res.residentialFacilities.men.cleanAndHygiene) {
          this.addDustbinSizeForMenCleanAndHygin(
            res.residentialFacilities.men.cleanAndHygiene.countOfDustbin
            , res.residentialFacilities.men.cleanAndHygiene.dustbinSize, 'dustbinSize', 'menForm')
        }
        this.addAreaOfToiletMen(res.residentialFacilities.men.countOfToilet, res.residentialFacilities.men.areaOfToilet, 'areaOfToilet', 'menForm')
        this.addAreaOfBathRoomMen(res.residentialFacilities.men.countOfBathroom, res.residentialFacilities.men.areaOfBathroom, 'areaOfBathroom', 'menForm')
        this.addAreaOfBathRoomCumToilet(res.residentialFacilities.men.countOfBathroomCumToilet, res.residentialFacilities.men.areaOfToiletCumBathroom, 'areaOfToiletCumBathroom', 'menForm')
        this.addAreaOfBathRoomCumToilet(res.residentialFacilities.men.countOfdustbinSizeInDiningAreaRecreationalArea, res.residentialFacilities.men.dustbinSizeInDiningAreaRecreationalArea, 'dustbinSizeInDiningAreaRecreationalArea', 'menForm')
        // this.addAreaOfBathRoomCumToilet(res.residentialFacilities.men.countOfDustbin,res.residentialFacilities.men.dustbinSize,'dustbinSize','menForm')
        this.residentialFormGroup.get('menForm').get('totalArea').patchValue(res.residentialFacilities.men.totalArea);
        this.residentialFormGroup.get('menForm').get('capacity').patchValue(res.residentialFacilities.men.capacity);
        this.residentialFormGroup.get('menForm').get('availabilityOfTransportSystem').patchValue(res.residentialFacilities.men.availabilityOfTransportSystem);
        // this.residentialFormGroup.get('menForm').get('seperateEntranceForMF').patchValue(res.residentialFacilities.men.capacity);
      }
      if (res && res.residentialFacilities && res.residentialFacilities.women && res.residentialFacilities.women.availability == true) {
        this.womenRooms = res.residentialFacilities.women.rooms ? res.residentialFacilities.women.rooms : [];
        if (this.womenRooms && this.womenRooms.length > 0) {
          this.validity['womenRooms'] = true

        }
        if (res.residentialFacilities.women.address) {
          this.data.addressForWomen = this.mapIncomingAddress(res.residentialFacilities.women.address);
        }
        if (res.residentialFacilities.women && res.residentialFacilities.women.cleanAndHygiene) {
          this.addDustbinSizeForMenCleanAndHygin(
            res.residentialFacilities.women.cleanAndHygiene.countOfDustbin
            , res.residentialFacilities.women.cleanAndHygiene.dustbinSize, 'dustbinSize', 'womenForm')
        }
        const disableLogic = () => {
          this.womenControl.hideFields(['cleanAndSafeDrinkingWater', 'countOfDustbin'], true);
          // this.menControl.disableFields(['capacity'],true)
          // this.womenControl.disableFields(['capacity'],true)
          // this.transgenderControl.makeFieldsReadOnly(['capacity'],true)
        };
        this.run(disableLogic);
        this.addAreaOfToiletWoMen(res.residentialFacilities.women.countOfToilet, res.residentialFacilities.women.areaOfToilet, 'areaOfToilet', 'womenForm')
        this.addAreaOfBathRoomWoMen(res.residentialFacilities.women.countOfBathroom, res.residentialFacilities.women.areaOfBathroom, 'areaOfBathroom', 'womenForm')
        this.addAreaOfBathRoomCumToiletWoMen(res.residentialFacilities.women.countOfBathroomCumToilet, res.residentialFacilities.women.areaOfToiletCumBathroom, 'areaOfToiletCumBathroom', 'womenForm')
        this.addAreaOfBathRoomCumToiletWoMen(res.residentialFacilities.women.countOfdustbinSizeInDiningAreaRecreationalArea, res.residentialFacilities.women.dustbinSizeInDiningAreaRecreationalArea, 'dustbinSizeInDiningAreaRecreationalArea', 'womenForm')
        // this.addAreaOfBathRoomCumToiletWoMen(res.residentialFacilities.women.countOfDustbin,res.residentialFacilities.women.dustbinSize,'dustbinSize','womenForm')
        this.residentialFormGroup.get('womenForm').get('totalArea').patchValue(res.residentialFacilities.women.totalArea);
        this.residentialFormGroup.get('womenForm').get('capacity').patchValue(res.residentialFacilities.women.capacity);
        //	this.residentialFormGroup.get('menForm').get('totalArea').patchValue(res.residentialFacilities.men.totalArea);
        //	this.residentialFormGroup.get('menForm').get('capacity').patchValue(res.residentialFacilities.men.capacity);
        this.residentialFormGroup.get('womenForm').get('availabilityOfTransportSystem').patchValue(res.residentialFacilities.women.availabilityOfTransportSystem);
        this.residentialFormGroup.get('womenForm').get('seperateEntranceForMF').patchValue(res.residentialFacilities.women.seperateEntranceForMF);
      }
      if (res && res.residentialFacilities && res.residentialFacilities.transgender && res.residentialFacilities.transgender.availability == true) {
        this.transngender = res.residentialFacilities.transgender.rooms ? res.residentialFacilities.transgender.rooms : [];
        if (this.transngender && this.transngender.length > 0) {
          this.validity['transgenderRooms'] = true
        }
        if (res.residentialFacilities.transgender.address) {
          this.data.addressForTransgender = this.mapIncomingAddress(res.residentialFacilities.transgender.address);
        }
        if (res.residentialFacilities.transgender && res.residentialFacilities.transgender.cleanAndHygiene) {
          this.addDustbinSizeForMenCleanAndHygin(
            res.residentialFacilities.transgender.cleanAndHygiene.countOfDustbin
            , res.residentialFacilities.transgender.cleanAndHygiene.dustbinSize, 'dustbinSize', 'transgenderForm')
        }

        this.addAreaOfToiletTransgender(res.residentialFacilities.transgender.countOfToilet, res.residentialFacilities.transgender.areaOfToilet, 'areaOfToilet', 'transgenderForm')
        this.addAreaOfBathRoomTransgender(res.residentialFacilities.transgender.countOfBathroom, res.residentialFacilities.transgender.areaOfBathroom, 'areaOfBathroom', 'transgenderForm')
        this.addAreaOfBathRoomCumToiletTransgender(res.residentialFacilities.transgender.countOfBathroomCumToilet, res.residentialFacilities.transgender.areaOfToiletCumBathroom, 'areaOfToiletCumBathroom', 'transgenderForm')
        this.addAreaOfBathRoomCumToiletTransgender(res.residentialFacilities.transgender.countOfdustbinSizeInDiningAreaRecreationalArea, res.residentialFacilities.transgender.dustbinSizeInDiningAreaRecreationalArea, 'dustbinSizeInDiningAreaRecreationalArea', 'transgenderForm')
        // this.addAreaOfBathRoomCumToiletTransgender(res.residentialFacilities.transgender.countOfDustbin,res.residentialFacilities.transgender.dustbinSize,'dustbinSize','transgenderForm')
        this.residentialFormGroup.get('transgenderForm').get('totalArea').patchValue(res.residentialFacilities.transgender.totalArea);
        this.residentialFormGroup.get('transgenderForm').get('capacity').patchValue(res.residentialFacilities.transgender.capacity);
        this.residentialFormGroup.get('transgenderForm').get('availabilityOfTransportSystem').patchValue(res.residentialFacilities.transgender.availabilityOfTransportSystem);
        this.residentialFormGroup.get('transgenderForm').get('seperateEntranceForMF').patchValue(res.residentialFacilities.transgender.seperateEntranceForMF);
      }

      if (res && res.residentialFacilities && res.residentialFacilities.men && res.residentialFacilities.men.availability == true) {
        this.menRooms = res.residentialFacilities.men.rooms ? res.residentialFacilities.men.rooms : [];
        const disableLogic = () => {
          this.menControl.hideFields(['cleanAndSafeDrinkingWater', 'countOfDustbin'], true);
          // this.menControl.disableFields(['capacity'],true)
          // this.womenControl.disableFields(['capacity'],true)
          // this.transgenderControl.makeFieldsReadOnly(['capacity'],true)
        };
        this.run(disableLogic);
      }

      // this.run(disableLogic);
      const disableLogic = () => {
        this.transgenderControl && this.transgenderControl.hideFields(['cleanAndSafeDrinkingWater', 'countOfDustbin'], true);
        this.menControl && this.menControl.hideFields(['cleanAndSafeDrinkingWater', 'countOfDustbin'], true);
        this.womenControl && this.womenControl.hideFields(['cleanAndSafeDrinkingWater', 'countOfDustbin'], true);
        this.facilityControl && this.facilityControl.disableFields(['liftIncaseOfFloors'], res.trainingCentreAreaDetails.isCenterAtGroundFloor);
        // this.menControl.disableFields(['capacity'],true)
        // this.womenControl.disableFields(['capacity'],true)
        // this.transgenderControl.makeFieldsReadOnly(['capacity'],true)
      };
      this.run(disableLogic);

      //this.assignDropDownValues(res);
      if (res && res.residentialFacilities) {
        this.generalFacilities = this.incomingMapDataGeneral(res);
        if (this.userDetails && this.userDetails.myFileUpload) {
          this.userDetails.myFileUpload['cctvCameraDocumentUrl'] = '';
        }
        //this.existingResidentialFacilities = this.incomingMapData(this.userDetails.residentialFacilities);
        this.existingResidentialFacilitiesForMen = this.incomingMapDataForMen(this.userDetails.residentialFacilities);
        this.existingResidentialFacilitiesForWomen = this.incomingMapDataForWomen(this.userDetails.residentialFacilities);
        this.existingResidentialFacilitiesForTransgender = this.incomingMapDataForTransgender(this.userDetails.residentialFacilities);
        this.typeOfResidentialInitialDefault = this.incomingForTypeOfResidential(this.userDetails.residentialFacilities);
        this.infraFormMen['defaultValue'] = this.incomingMapDataForMenInfra(this.userDetails.residentialFacilities);
        this.diningAreaFormsMen['defaultValue'] = this.incomingMapDataForMenDiningArea(this.userDetails.residentialFacilities);
        this.diningAreaRecreationalFormsMen['defaultValue'] = this.incomingMapDataForMenDiningAreaRecreationalArea(this.userDetails.residentialFacilities);
        this.infraFormWomen['defaultValue'] = this.incomingMapDataForWomenInfra(this.userDetails.residentialFacilities),
          this.diningAreaFormsWomen['defaultValue'] = this.incomingMapDataForWoMenDiningArea(this.userDetails.residentialFacilities),
          this.diningAreaRecreationalFormsWomen['defaultValue'] = this.incomingMapDataForWoMenDiningAreaRecreationalArea(this.userDetails.residentialFacilities),
          this.infraFormTransgender['defaultValue'] = this.incomingMapDataForTransgenderInfra(this.userDetails.residentialFacilities)
        this.diningAreaFormsTransgender['defaultValue'] = this.incomingMapDataForTransgenderDiningArea(this.userDetails.residentialFacilities)
        this.diningAreaRecreationalFormsTransgender['defaultValue'] = this.incomingMapDataForTransgenderDiningAreaRecreationalArea(this.userDetails.residentialFacilities)

      }

      this.formDataLoaded = true;
    }, err => {
      console.log(err);

    }
    );
    // this.facilities = this.incomingMapData(formData.facilities);
  }


  onMenAvaliabilityChange(menAvalibility) {
    if (menAvalibility == false) {
      this.validity['menRooms'] = true;
      this.menRooms = [];
      //this.validity['residentialMen'] = true;
    } else {
      if (this.menRooms.length <= 0) {
        this.validity['menRooms'] = false;
      }
    }
    this.menControlForm = DFormHelpers.forms(this.residentialFacilitiesForm);

    // const elementNames = [
    // 	'menTotalArea',
    // 	'menNumberOfRooms',
    // 	'menResidentialCapacity',
    // 	'menAreaEquipedWith',
    // 	'menRemarks',
    // 	'Warden'
    // ];
    const elementNames = [
      'totalArea',
      'capacity',
      'Warden',
      'equipedWith',
      'distanceFromTrainingCentre',
      'typeOfConstructionBuildingOfResidential',
      'seperateEntranceForMF',
      'availabilityOfToilet',
      'availabilityOfBathroom',
      'diningArea',
      // 'diningAreaAndRecreationalArea',
      'emailForGrievance',
      'codeOfConductDisplayed',
      'availabilityOfToiletCumBathRoom',
      'cleanHygineEquipedWith',
      'availabilityOfFirstAidKit',
      'availabilityOfFireFightingEquipment',
      'AEBS',
      'availabilityOfDiningArea',
      'availabilityOfDiningAreaAndRecreationalArea',
      'meals',
      'lunchTime',
      'remarks',
      'availabilityOfTransportSystem',
      //'countOfToilet',
      //'countOfBathroom',
      //'countOfBathroomCumToilet',
      //'houseKeepingStaffType',
      //'houseKeppingStaffUrl',
      //'dustbinSize',
      'equippedWith',
      'fireFightingEquipedWith',
      //'diningArea',
      //'diningAreaAndRecreationalArea',
      'foodMenu',
      'partitionMadeOf',
      // 'wallsOfResidential',
      // 'floorOfTheResidential'
    ];
    const toDisable = menAvalibility ? false : true;
    const disableLogic = () => {
      this.menControlForm.disableFields(elementNames, toDisable);
    };
    this.run(disableLogic);

  }

  run(fn) {
    this.buffer.push(fn);
  }

  onWomenAvaliabilityChange(womenAvaliablity) {
    if (womenAvaliablity == false) {
      this.validity['womenRooms'] = true;
      this.womenRooms = [];
      // this.validity['residentialWomen'] = true
    } else if (this.womenRooms.length <= 0) {
      this.validity['womenRooms'] = false;
    }
    this.womenControlForm = DFormHelpers.forms(this.womenForm);
    // const elementNames = [
    // 	'womenTotalArea',
    // 	'womenNumberOfRooms',
    // 	'womenResidentialFacility',
    // 	'womenAreaEquipedWith',
    // 	// 'femaleWarden',
    // 	'womenRemarks',
    // 	'equipedWith'
    // ];
    const elementNames = [
      'totalArea',
      'capacity',
      'womenAreaEquipedWith',
      'equipedWith',
      // 'cctvCameraDocumentUrl',
      'distanceFromTrainingCentre',
      'typeOfConstructionBuildingOfResidential',
      'seperateEntranceForMF',
      'availabilityOfToilet',
      'availabilityOfBathroom',
      'diningArea',
      // 'diningAreaAndRecreationalArea',
      'emailForGrievance',
      'codeOfConductDisplayed',
      'availabilityOfToiletCumBathRoom',
      'cleanHygineEquipedWith',
      'availabilityOfFirstAidKit',
      'availabilityOfFireFightingEquipment',
      'AEBS',
      'availabilityOfDiningArea',
      'availabilityOfDiningAreaAndRecreationalArea',
      'meals',
      'lunchTime',
      'remarks',
      'availabilityOfTransportSystem',
      //'countOfToilet',
      //'countOfBathroom',
      //'countOfBathroomCumToilet',
      //'houseKeepingStaffType',
      //'houseKeppingStaffUrl',
      //'dustbinSize',
      'equippedWith',
      'fireFightingEquipedWith',
      //'diningArea',
      //'diningAreaAndRecreationalArea',
      'foodMenu',
      'Warden',
      'partitionMadeOf',
      // 'wallsOfResidential',
      // 'floorOfTheResidential'
    ]
    const toDisable = womenAvaliablity ? false : true;
    const disableLogic = () => {
      this.womenControlForm.disableFields(elementNames, toDisable);
    };
    this.run(disableLogic);

  }

  onTransgenderAvaliabilityChange(transgenderAvaliablity) {
    if (transgenderAvaliablity == false) {
      this.validity['transgenderRooms'] = true;

      this.transngender = [];
      // this.validity['residentialTransgender'] = true;
    } else if (this.transngender.length <= 0) {
      this.validity['transgenderRooms'] = false;
    }
    this.transgenderControlForm = DFormHelpers.forms(this.transgenderForm);
    const elementNames = [
      'totalArea',
      'capacity',
      'femalewarden',
      'equipedWith',
      'cctvCameraDocumentUrl',
      'distanceFromTrainingCentre',
      'typeOfConstructionBuildingOfResidential',
      'seperateEntranceForMF',
      'availabilityOfToilet',
      'availabilityOfBathroom',
      'diningArea',
      // 'diningAreaAndRecreationalArea',
      'emailForGrievance',
      'codeOfConductDisplayed',
      'availabilityOfToiletCumBathRoom',
      'cleanHygineEquipedWith',
      'availabilityOfFirstAidKit',
      'availabilityOfFireFightingEquipment',
      'AEBS',
      'availabilityOfDiningArea',
      'availabilityOfDiningAreaAndRecreationalArea',
      'meals',
      'lunchTime',
      'remarks',
      'Warden',
      //'countOfToilet',
      //'countOfBathroom',
      //'countOfBathroomCumToilet',
      //'houseKeepingStaffType',
      //'houseKeppingStaffUrl',
      //'dustbinSize',
      'equippedWith',
      'fireFightingEquipedWith',
      'availabilityOfTransportSystem',
      //'diningArea',
      //'diningAreaAndRecreationalArea',
      'foodMenu',
      'partitionMadeOf',
      // 'wallsOfResidential',
      // 'floorOfTheResidential'
    ]

    const toDisable = transgenderAvaliablity ? false : true;
    const disableLogic = () => {
      this.transgenderControlForm.disableFields(elementNames, toDisable);
    };
    this.run(disableLogic);
    // if (womenAvaliablity) {
    // 	myForm.disableFields(elementNames, false);
    // } else {
    // 	myForm.disableFields(elementNames);
    // }
  }

  incomingMapData(facilities) {
    console.log(facilities);
    const mappedResidentialFacilities = {
      'menAvailability': facilities.men ? facilities.men.availability : null,
      'menTotalArea': facilities.men ? facilities.men.totalArea === 0 ? null : facilities.men.totalArea : null,
      'menNumberOfRooms': facilities.men ? facilities.men.numberOfRooms === 0 ? null : facilities.men.numberOfRooms : null,
      'menResidentialCapacity': facilities.men ? facilities.men.capacity === 0 ? null : facilities.men.capacity : null,
      'menAreaEquipedWith': facilities.men ? facilities.men.equipedWith === 0 ? null : facilities.men.equipedWith : null,
      'Warden': facilities.men ? facilities.men.equipedWith : null,
      'menRemarks': facilities.men ? facilities.men.remarks : null,
      'womenAvailability': facilities.women ? facilities.women.availability : null,
      'womenTotalArea': facilities.women ? facilities.women.totalArea === 0 ? null : facilities.women.totalArea : null,
      'womenNumberOfRooms': facilities.women ? facilities.women.numberOfRooms === 0 ? null : facilities.women.numberOfRooms : null,
      'womenResidentialFacility': facilities.women ? facilities.women.capacity === 0 ? null : facilities.women.capacity : null,
      'womenAreaEquipedWith': facilities.women ? facilities.women.equipedWith === 0 ? null : facilities.women.equipedWith : null,
      'equipedWith': facilities.women ? facilities.women.equipedWith === 0 ? null : facilities.women.equipedWith : null,
      'womenRemarks': facilities.women ? facilities.women.remarks : null
    };
    return mappedResidentialFacilities;
  }
  incomingMapDataForMen(facilities) {
    console.log(facilities);
    if (facilities && facilities.men && facilities.men.equipedWith) {
      facilities.men.equipedWith['cctvMen'] = facilities.men.equipedWith['cctv'];
    }
    const mappedResidentialFacilities = {
      // 'availability': facilities.men ? facilities.men.availability : null,
      // 'availabilityOfTransportSystem': facilities.men ? facilities.men.availabilityOfTransportSystem : null,
      // 'totalArea': facilities.men ? facilities.men.totalArea === 0 ? null : facilities.men.totalArea : null,
      // 'menNumberOfRooms': facilities.men ? facilities.men.numberOfRooms === 0 ? null : facilities.men.numberOfRooms : null,
      // 'capacity': facilities.men ? facilities.men.capacity === 0 ? null : facilities.men.capacity : null,
      'equipedWith': facilities.men && facilities.men.equipedWith ? facilities.men.equipedWith : { 'cctvMen': false, 'allTImeSecurity': false, 'backup': false },
      'Warden': facilities.men ? facilities.men.equipedWith ? facilities.men.equipedWith.warden : null : null,
      'cctvCameraDocumentUrl': facilities.men ? facilities.men.cctvCameraDocumentUrl == null ? '' : facilities.men.cctvCameraDocumentUrl : '',
      'previewcctvCameraDocumentUrl': facilities.men ? facilities.men.cctvCameraDocumentUrl : '',
      // facilities.men && facilities.men.firefightingequipment ? facilities.men.firefightingequipment.availabilityOfFireFightingequipment == true ?
      // 'distanceFromTrainingCentre': facilities.men ? facilities.men.distanceFromTrainingCentre === 0 ? null : facilities.men.distanceFromTrainingCentre : null,
      // 'typeOfConstructionBuildingOfResidential': facilities.men ? facilities.men.typeOfConstructionBuildingOfResidential : '',
      // 'seperateEntranceForMF': facilities.men ? facilities.men.seperateEntranceForMF : null,
      // 'availabilityOfToilet': facilities.men ? facilities.men.availabilityOfToilet : null,
      // 'countOfToilet': facilities.men ? facilities.men.countOfToilet : null,
      // 'availabilityOfBathroom': facilities.men ? facilities.men.availabilityOfBathroom : null,
      // 'countOfBathroom': facilities.men ? facilities.men.countOfBathroom : null,
      // 'availabilityOfToiletCumBathRoom': facilities.men ? facilities.men.availabilityOfToiletCumBathRoom : null,
      // 'countOfBathroomCumToilet': facilities.men ? facilities.men.countOfBathroomCumToilet : null,facilities.men && facilities.men.healthFacilities ? facilities.men.healthFacilities.equippedWith : null
      'cleanHygineEquipedWith': facilities.men && facilities.men.cleanAndHygiene ? facilities.men.cleanAndHygiene.equippedWith : null,
      // 'dustbinSize': facilities.men && facilities.men.cleanAndHygiene ? facilities.men.cleanAndHygiene.dustbinSize : null,
      'availabilityOfFirstAidKit': facilities.men && facilities.men.healthFacilities ? facilities.men.healthFacilities.availabilityOfFirstAidKit : null,
      'equippedWith': facilities.men && facilities.men.healthFacilities ? facilities.men.healthFacilities.equippedWith : null,
      // 	{
      // 		emergencyTelephoneNumber: true, sterileGauzePadsAvailability: true,
      // 		disinfectantslikeDettolSavlon: true, medicinesLikePainKiller: true,
      // 		rollerBandages: true, adhesiveBandages: true, scissorsAndTweezers: true,
      // 	antisepticWipesOrSoap: true, thermometer: true, doctor: true
      // }
      'availabilityOfFireFightingEquipment': facilities.men && facilities.men.firefightingequipment ? facilities.men.firefightingequipment.availabilityOfFireFightingequipment : null,
      'fireFightingEquipedWith': facilities.men && facilities.men.firefightingequipment ? facilities.men.firefightingequipment.equippedWith : null,
      'isMedicalContactNumberAvaliable': facilities.men && facilities.men.firefightingequipment ? facilities.men.firefightingequipment.isMedicalContactNumberAvaliable : null,
      //	'medicalContactNumber':facilities.men && facilities.men.firefightingequipment ?facilities.men.firefightingequipment.medicalContactNumber : null,
      'isEmergencyExitDirection': facilities.men && facilities.men.firefightingequipment ? facilities.men.firefightingequipment.isEmergencyExitDirection : null,
      'AEBS': facilities.men ? facilities.men.biometricAttendanceSystem : null,
      'countOfDustbin': facilities.men && facilities.men.cleanAndHygiene ? facilities.men.cleanAndHygiene.countOfDustbin : null,
      // 'biometricAttendanceSystemURL': facilities.men && facilities.men.biometricAttendanceSystemURL ? facilities.men.biometricAttendanceSystemURL : null,
      //'availabilityOfDiningArea': facilities.men ? facilities.men.availabilityOfDiningArea: null,
      //'diningArea': facilities.men ? facilities.men.diningArea === 0 ? null : facilities.men.diningArea : null,
      //'availabilityOfDiningAreaAndRecreationalArea': facilities.men ? facilities.men.availabilityOfDiningAreaAndRecreationalArea  : null,
      //'diningAreaAndRecreationalArea': facilities.men ? facilities.men.diningAreaAndRecreationalArea === 0 ? null : facilities.men.diningAreaAndRecreationalArea : null,
      //'emailForGrievance': facilities.men ? facilities.men.emailForGrievance : null,
      //'codeOfConductDisplayed': facilities.men ? facilities.men.codeOfConductDisplayed : null,
      //'meals': facilities.men && facilities.men.meals ? facilities.men.meals : null,
      //'foodMenu': facilities.men && facilities.men.menuOfFoodList ? facilities.men.menuOfFoodList : null,
      //'lunchTime': facilities.men ? facilities.men.lunchTime : null,
      //'remarks': facilities.men ? facilities.men.remarks : null,
      // 'wallsOfResidential': facilities.men && facilities.men.wallsOfResidential ? facilities.men.wallsOfResidential : null,
      // 'floorOfTheResidential': facilities.men && facilities.men.floorOfTheResidential ? facilities.men.floorOfTheResidential : null,
      //'partitionMadeOf': facilities.men && facilities.men.partitionMadeOf ? facilities.men.partitionMadeOf : null,
      // 'houseKeepingStaffType': facilities.men && facilities.men.cleanAndHygiene ? facilities.men.cleanAndHygiene.houseKeepingStaffType : null,
      // 'houseKeppingStaffUrl': facilities.men && facilities.men.cleanAndHygiene ? facilities.men.cleanAndHygiene.houseKeppingStaffUrl : null,
      'cleanAndSafeDrinkingWater': facilities.men ? facilities.men.availabilityOfSafeDrinkingWater : null,
      //'availabilityOfDustinAndDiningArea': facilities.men ? facilities.men.availabilityOfDustinAndDiningArea : null,
      //'dustbinSizeInDiningArea': facilities.men ? facilities.men.dustbinSize : null,
      //'availabilityOfDustinAndDiningAreaRecreationalArea':facilities.men ? facilities.men.availabilityOfDustinAndDiningAreaRecreationalArea:null,
      //'dustbinSizeInDiningAreaRecreationalArea':facilities.men ? facilities.men.dustbinSizeInDiningAreaRecreationalArea:null
      // 'address': facilities.men && facilities.men.address ? facilities.men.address : null,
      // 'address.addressLine': facilities.men && facilities.men.address ? facilities.men.address.address1 : null,
      // 'address.addressProof': {
      // 	type: facilities.men && facilities.men.address ? facilities.men.address.addressProofType : null,
      // 	locationURL: facilities.men && facilities.men.address ? facilities.men.address.locationURL : null
      // 'address.addressProof?locationURL'
      //	}			// 'address.district': facilities.men && facilities.men.address? facilities.men.address.address1 : null,

    };
    return mappedResidentialFacilities;
  }
  // incomingMapDataForMenAminity(facilities) {
  // 	return mappedResidentialFacilities;
  // }
  incomingMapDataForMenDiningArea(facilities) {
    const mappedResidentialFacilities = {
      'availabilityOfDiningArea': facilities.men ? facilities.men.availabilityOfDiningArea : null,
      'diningArea': facilities.men ? facilities.men.diningArea === 0 ? null : facilities.men.diningArea : null,
      'availabilityOfDustinAndDiningArea': facilities.men ? facilities.men.availabilityOfDustinAndDiningArea : null,
      'dustbinSizeInDiningArea': facilities.men ? facilities.men.dustbinSize : null,
      'numberOfCeilingFanDiningArea': facilities.men ? facilities.men.numberOfCeilingFanDiningArea : null,
      'numberOfWallMountedDiningArea': facilities.men ? facilities.men.numberOfWallMountedDiningArea : null,
      'numberOfBulbDiningArea': facilities.men ? facilities.men.numberOfBulbDiningArea : null,
      'availabilityOfWallMountedFanDiningArea': facilities.men ? facilities.men.availabilityOfWallMountedFanDiningArea : null,
      'availabilityOfBulbDiningArea': facilities.men ? facilities.men.availabilityOfBulbDiningArea : null,
      // 'dustbinSizeInDiningArea': facilities.men ? facilities.men.dustbinSize : null,
      'availabilityOfCeilingFanDiningArea': facilities.men ? facilities.men.availabilityOfCeilingFanDiningArea : null
    }
    return mappedResidentialFacilities;
  }
  incomingMapDataForMenDiningAreaRecreationalArea(facilities) {
    const mappedResidentialFacilities = {
      'availabilityOfDiningAreaAndRecreationalArea': facilities.men ? facilities.men.availabilityOfDiningAreaAndRecreationalArea : null,
      'diningAreaAndRecreationalArea': facilities.men ? facilities.men.diningAreaAndRecreationalArea === 0 ? null : facilities.men.diningAreaAndRecreationalArea : null,
      'availabilityOfDustinAndDiningArea': facilities.men ? facilities.men.availabilityOfDustinAndDiningArea : null,
      'availabilityOfDustinAndDiningAreaRecreationalArea': facilities.men ? facilities.men.availabilityOfDustinAndDiningAreaRecreationalArea : null,
      //	'dustbinSizeInDiningAreaRecreationalArea': facilities.men ? facilities.men.dustbinSizeInDiningAreaRecreationalArea : null,
      'countOfdustbinSizeInDiningAreaRecreationalArea': facilities.men ? facilities.men.countOfdustbinSizeInDiningAreaRecreationalArea : null,
      'availabilityOfCeilingFanDiningRecreationArea': facilities.men ? facilities.men.availabilityOfCeilingFanDiningRecreationArea : null,
      'availabilityOfBulbDiningAreaRecreationalArea': facilities.men ? facilities.men.availabilityOfBulbDiningAreaRecreationalArea : null,
      'availabilityOfWallMountedFanDiningRecreationalArea': facilities.men ? facilities.men.availabilityOfWallMountedFanDiningRecreationalArea : null,
      'numberOfCeilingDiningRecreationArea': facilities.men ? facilities.men.numberOfCeilingDiningRecreationArea : null,
      'numberOfMountedFanDiningRecreationalArea': facilities.men ? facilities.men.numberOfMountedFanDiningRecreationalArea : null,
      'numberOfBulbDiningAreaRecreationalArea': facilities.men ? facilities.men.numberOfBulbDiningAreaRecreationalArea : null,
    }
    return mappedResidentialFacilities;
  }
  incomingMapDataForMenInfra(facilities) {
    const mappedResidentialFacilities = {
      // 'availability': facilities.men ? facilities.men.availability : null,
      // 'availabilityOfTransportSystem': facilities.men ? facilities.men.availabilityOfTransportSystem : null,
      // 'totalArea': facilities.men ? facilities.men.totalArea === 0 ? null : facilities.men.totalArea : null,
      // 'menNumberOfRooms': facilities.men ? facilities.men.numberOfRooms === 0 ? null : facilities.men.numberOfRooms : null,
      // 'capacity': facilities.men ? facilities.men.capacity === 0 ? null : facilities.men.capacity : null,
      // 'equipedWith': facilities.men && facilities.men.equipedWith ? facilities.men.equipedWith : { 'cctvMen': false,  'allTImeSecurity': false, 'backup': false },
      // 'Warden': facilities.men ? facilities.men.equipedWith ? facilities.men.equipedWith.warden : null : null,
      // 'cctvCameraDocumentUrl': facilities.men ? facilities.men.cctvCameraDocumentUrl == null ? '' : facilities.men.cctvCameraDocumentUrl : '',
      // 'distanceFromTrainingCentre': facilities.men ? facilities.men.distanceFromTrainingCentre === 0 ? null : facilities.men.distanceFromTrainingCentre : null,
      'typeOfConstructionBuildingOfResidential': facilities.men ? facilities.men.typeOfConstructionBuildingOfResidential : '',
      // 'seperateEntranceForMF': facilities.men ? facilities.men.seperateEntranceForMF : null,
      'availabilityOfToilet': facilities.men ? facilities.men.availabilityOfToilet : null,
      'countOfToilet': facilities.men ? facilities.men.countOfToilet : null,
      'availabilityOfBathroom': facilities.men ? facilities.men.availabilityOfBathroom : null,
      'countOfBathroom': facilities.men ? facilities.men.countOfBathroom : null,
      'availabilityOfToiletCumBathRoom': facilities.men ? facilities.men.availabilityOfToiletCumBathRoom : null,
      'countOfBathroomCumToilet': facilities.men ? facilities.men.countOfBathroomCumToilet : null,
      // 'cleanHygineEquipedWith': facilities.men && facilities.men.cleanAndHygiene ? facilities.men.cleanAndHygiene.equippedWith : null,
      // 'dustbinSize': facilities.men && facilities.men.cleanAndHygiene ? facilities.men.cleanAndHygiene.dustbinSize : null,
      // 'availabilityOfFirstAidKit': facilities.men && facilities.men.healthFacilities ? facilities.men.healthFacilities.availabilityOfFirstAidKit : null,
      // 'equippedWith': facilities.men && facilities.men.healthFacilities ? facilities.men.healthFacilities.equippedWith : null,
      // 'availabilityOfFireFightingEquipment': facilities.men && facilities.men.firefightingequipment ? facilities.men.firefightingequipment.availabilityOfFireFightingequipment : null,
      // 'fireFightingEquipedWith': facilities.men && facilities.men.firefightingequipment ? facilities.men.firefightingequipment.equippedWith : null,
      // 'AEBS': {
      // 	aebs: facilities.men && facilities.men.biometricAttendanceSystem ? facilities.men.biometricAttendanceSystem : null
      // },
      // // 'biometricAttendanceSystemURL': facilities.men && facilities.men.biometricAttendanceSystemURL ? facilities.men.biometricAttendanceSystemURL : null,
      // 'availabilityOfDiningArea': facilities.men ? facilities.men.availabilityOfDiningArea: null,
      // 'diningArea': facilities.men ? facilities.men.diningArea === 0 ? null : facilities.men.diningArea : null,
      // 'availabilityOfDiningAreaAndRecreationalArea': facilities.men ? facilities.men.availabilityOfDiningAreaAndRecreationalArea  : null,
      // 'diningAreaAndRecreationalArea': facilities.men ? facilities.men.diningAreaAndRecreationalArea === 0 ? null : facilities.men.diningAreaAndRecreationalArea : null,
      'emailForGrievance': facilities.men ? facilities.men.emailForGrievance : null,
      'codeOfConductDisplayed': facilities.men ? facilities.men.codeOfConductDisplayed : null,
      // 'meals': facilities.men && facilities.men.meals ? facilities.men.meals : null,
      // 'foodMenu': facilities.men && facilities.men.menuOfFoodList ? facilities.men.menuOfFoodList : null,
      'lunchTime': facilities.men ? facilities.men.lunchTime : null,
      // 'remarks': facilities.men ? facilities.men.remarks : null,
      // 'wallsOfResidential': facilities.men && facilities.men.wallsOfResidential ? facilities.men.wallsOfResidential : null,
      // 'floorOfTheResidential': facilities.men && facilities.men.floorOfTheResidential ? facilities.men.floorOfTheResidential : null,
      'partitionMadeOf': facilities.men && facilities.men.partitionMadeOf ? facilities.men.partitionMadeOf : null,
      // 'houseKeepingStaffType': facilities.men && facilities.men.cleanAndHygiene ? facilities.men.cleanAndHygiene.houseKeepingStaffType : null,
      // 'houseKeppingStaffUrl': facilities.men && facilities.men.cleanAndHygiene ? facilities.men.cleanAndHygiene.houseKeppingStaffUrl : null,
      // 'cleanAndSafeDrinkingWater':facilities.men ? facilities.men.availabilityOfSafeDrinkingWater:null,
      // 'availabilityOfDustinAndDiningArea': facilities.men ? facilities.men.availabilityOfDustinAndDiningArea : null,
      // 'dustbinSizeInDiningArea': facilities.men ? facilities.men.dustbinSize : null,
      // 'availabilityOfDustinAndDiningAreaRecreationalArea':facilities.men ? facilities.men.availabilityOfDustinAndDiningAreaRecreationalArea:null,
      // 'dustbinSizeInDiningAreaRecreationalArea':facilities.men ? facilities.men.dustbinSizeInDiningAreaRecreationalArea:null
      // 'address': facilities.men && facilities.men.address ? facilities.men.address : null,
      // 'address.addressLine': facilities.men && facilities.men.address ? facilities.men.address.address1 : null,
      // 'address.addressProof': {
      // 	type: facilities.men && facilities.men.address ? facilities.men.address.addressProofType : null,
      // 	locationURL: facilities.men && facilities.men.address ? facilities.men.address.locationURL : null
      // 'address.addressProof?locationURL'
      //	}			// 'address.district': facilities.men && facilities.men.address? facilities.men.address.address1 : null,

    }
    return mappedResidentialFacilities;
  }
  // incomingMapDataForMenDiningArea(facilities) {
  // 	return mappedResidentialFacilities;
  // }
  // incomingMapDataForMenDiningAreaAndRecreational(facilities) {
  // 	return mappedResidentialFacilities;
  // }
  incomingMapDataForWomenInfra(facilities) {
    const mappedResidentialFacilities = {
      'typeOfConstructionBuildingOfResidential': facilities.women ? facilities.women.typeOfConstructionBuildingOfResidential : '',
      'availabilityOfToilet': facilities.women ? facilities.women.availabilityOfToilet : null,
      'countOfToilet': facilities.women ? facilities.women.countOfToilet : null,
      'availabilityOfBathroom': facilities.women ? facilities.women.availabilityOfBathroom : null,
      'countOfBathroom': facilities.women ? facilities.women.countOfBathroom : null,
      'availabilityOfToiletCumBathRoom': facilities.women ? facilities.women.availabilityOfToiletCumBathRoom : null,
      'countOfBathroomCumToilet': facilities.women ? facilities.women.countOfBathroomCumToilet : null,
      'emailForGrievance': facilities.women ? facilities.women.emailForGrievance : null,
      'codeOfConductDisplayed': facilities.women ? facilities.women.codeOfConductDisplayed : null,
      'lunchTime': facilities.women ? facilities.women.lunchTime : null,
      'partitionMadeOf': facilities.women && facilities.women.partitionMadeOf ? facilities.women.partitionMadeOf : null,
    }
    return mappedResidentialFacilities
  }
  incomingMapDataForWoMenDiningArea(facilities) {
    const mappedResidentialFacilities = {
      'availabilityOfDiningArea': facilities.women ? facilities.women.availabilityOfDiningArea : null,
      'diningArea': facilities.women ? facilities.women.diningArea === 0 ? null : facilities.women.diningArea : null,
      'availabilityOfDustinAndDiningArea': facilities.women ? facilities.women.availabilityOfDustinAndDiningArea : null,
      'dustbinSizeInDiningArea': facilities.women ? facilities.women.dustbinSize : null,
      'numberOfCeilingFanDiningArea': facilities.women ? facilities.women.numberOfCeilingFanDiningArea : null,
      'numberOfWallMountedDiningArea': facilities.women ? facilities.women.numberOfWallMountedDiningArea : null,
      'numberOfBulbDiningArea': facilities.women ? facilities.women.numberOfBulbDiningArea : null,
      'availabilityOfWallMountedFanDiningArea': facilities.women ? facilities.women.availabilityOfWallMountedFanDiningArea : null,
      'availabilityOfBulbDiningArea': facilities.women ? facilities.women.availabilityOfBulbDiningArea : null,
      // 'dustbinSizeInDiningArea': facilities.women ? facilities.women.dustbinSize : null,
      'availabilityOfCeilingFanDiningArea': facilities.women ? facilities.women.availabilityOfCeilingFanDiningArea : null
    }
    return mappedResidentialFacilities;
  }
  incomingMapDataForWoMenDiningAreaRecreationalArea(facilities) {
    const mappedResidentialFacilities = {
      'availabilityOfDiningAreaAndRecreationalArea': facilities.women ? facilities.women.availabilityOfDiningAreaAndRecreationalArea : null,
      'diningAreaAndRecreationalArea': facilities.women ? facilities.women.diningAreaAndRecreationalArea === 0 ? null : facilities.women.diningAreaAndRecreationalArea : null,
      'availabilityOfDustinAndDiningArea': facilities.women ? facilities.women.availabilityOfDustinAndDiningArea : null,
      'availabilityOfDustinAndDiningAreaRecreationalArea': facilities.women ? facilities.women.availabilityOfDustinAndDiningAreaRecreationalArea : null,
      //	'dustbinSizeInDiningAreaRecreationalArea': facilities.women ? facilities.women.dustbinSizeInDiningAreaRecreationalArea : null,
      'countOfdustbinSizeInDiningAreaRecreationalArea': facilities.women ? facilities.women.countOfdustbinSizeInDiningAreaRecreationalArea : null,
      'availabilityOfCeilingFanDiningRecreationArea': facilities.women ? facilities.women.availabilityOfCeilingFanDiningRecreationArea : null,
      'availabilityOfBulbDiningAreaRecreationalArea': facilities.women ? facilities.women.availabilityOfBulbDiningAreaRecreationalArea : null,
      'availabilityOfWallMountedFanDiningRecreationalArea': facilities.women ? facilities.women.availabilityOfWallMountedFanDiningRecreationalArea : null,
      'numberOfCeilingDiningRecreationArea': facilities.women ? facilities.women.numberOfCeilingDiningRecreationArea : null,
      'numberOfMountedFanDiningRecreationalArea': facilities.women ? facilities.women.numberOfMountedFanDiningRecreationalArea : null,
      'numberOfBulbDiningAreaRecreationalArea': facilities.women ? facilities.women.numberOfBulbDiningAreaRecreationalArea : null,
    }
    return mappedResidentialFacilities;
  }
  incomingMapDataForTransgenderInfra(facilities) {
    const mappedResidentialFacilities = {
      'typeOfConstructionBuildingOfResidential': facilities.transgender ? facilities.transgender.typeOfConstructionBuildingOfResidential : '',
      'availabilityOfToilet': facilities.transgender ? facilities.transgender.availabilityOfToilet : null,
      'countOfToilet': facilities.transgender ? facilities.transgender.countOfToilet : null,
      'availabilityOfBathroom': facilities.transgender ? facilities.transgender.availabilityOfBathroom : null,
      'countOfBathroom': facilities.transgender ? facilities.transgender.countOfBathroom : null,
      'availabilityOfToiletCumBathRoom': facilities.transgender ? facilities.transgender.availabilityOfToiletCumBathRoom : null,
      'countOfBathroomCumToilet': facilities.transgender ? facilities.transgender.countOfBathroomCumToilet : null,
      'emailForGrievance': facilities.transgender ? facilities.transgender.emailForGrievance : null,
      'codeOfConductDisplayed': facilities.transgender ? facilities.transgender.codeOfConductDisplayed : null,
      'lunchTime': facilities.transgender ? facilities.transgender.lunchTime : null,
      'partitionMadeOf': facilities.transgender && facilities.transgender.partitionMadeOf ? facilities.transgender.partitionMadeOf : null,
    }
    return mappedResidentialFacilities
  }
  incomingMapDataForTransgenderDiningArea(facilities) {
    const mappedResidentialFacilities = {
      'availabilityOfDiningArea': facilities.transgender ? facilities.transgender.availabilityOfDiningArea : null,
      'diningArea': facilities.transgender ? facilities.transgender.diningArea === 0 ? null : facilities.transgender.diningArea : null,
      'availabilityOfDustinAndDiningArea': facilities.transgender ? facilities.transgender.availabilityOfDustinAndDiningArea : null,
      'dustbinSizeInDiningArea': facilities.transgender ? facilities.transgender.dustbinSize : null,
      'numberOfCeilingFanDiningArea': facilities.transgender ? facilities.transgender.numberOfCeilingFanDiningArea : null,
      'numberOfWallMountedDiningArea': facilities.transgender ? facilities.transgender.numberOfWallMountedDiningArea : null,
      'numberOfBulbDiningArea': facilities.transgender ? facilities.transgender.numberOfBulbDiningArea : null,
      'availabilityOfWallMountedFanDiningArea': facilities.transgender ? facilities.transgender.availabilityOfWallMountedFanDiningArea : null,
      'availabilityOfBulbDiningArea': facilities.transgender ? facilities.transgender.availabilityOfBulbDiningArea : null,
      // 'dustbinSizeInDiningArea': facilities.transgender ? facilities.transgender.dustbinSize : null,
      'availabilityOfCeilingFanDiningArea': facilities.transgender ? facilities.transgender.availabilityOfCeilingFanDiningArea : null
    }
    return mappedResidentialFacilities;
  }
  incomingMapDataForTransgenderDiningAreaRecreationalArea(facilities) {
    const mappedResidentialFacilities = {
      'availabilityOfDiningAreaAndRecreationalArea': facilities.transgender ? facilities.transgender.availabilityOfDiningAreaAndRecreationalArea : null,
      'diningAreaAndRecreationalArea': facilities.transgender ? facilities.transgender.diningAreaAndRecreationalArea === 0 ? null : facilities.transgender.diningAreaAndRecreationalArea : null,
      'availabilityOfDustinAndDiningArea': facilities.transgender ? facilities.transgender.availabilityOfDustinAndDiningArea : null,
      'availabilityOfDustinAndDiningAreaRecreationalArea': facilities.transgender ? facilities.transgender.availabilityOfDustinAndDiningAreaRecreationalArea : null,
      //	'dustbinSizeInDiningAreaRecreationalArea': facilities.transgender ? facilities.transgender.dustbinSizeInDiningAreaRecreationalArea : null,
      'countOfdustbinSizeInDiningAreaRecreationalArea': facilities.transgender ? facilities.transgender.countOfdustbinSizeInDiningAreaRecreationalArea : null,
      'availabilityOfCeilingFanDiningRecreationArea': facilities.transgender ? facilities.transgender.availabilityOfCeilingFanDiningRecreationArea : null,
      'availabilityOfBulbDiningAreaRecreationalArea': facilities.transgender ? facilities.transgender.availabilityOfBulbDiningAreaRecreationalArea : null,
      'availabilityOfWallMountedFanDiningRecreationalArea': facilities.transgender ? facilities.transgender.availabilityOfWallMountedFanDiningRecreationalArea : null,
      'numberOfCeilingDiningRecreationArea': facilities.transgender ? facilities.transgender.numberOfCeilingDiningRecreationArea : null,
      'numberOfMountedFanDiningRecreationalArea': facilities.transgender ? facilities.transgender.numberOfMountedFanDiningRecreationalArea : null,
      'numberOfBulbDiningAreaRecreationalArea': facilities.transgender ? facilities.transgender.numberOfBulbDiningAreaRecreationalArea : null,
    }
    return mappedResidentialFacilities;
  }
  incomingMapDataForWomen(facilities) {
    console.log(facilities);
    if (facilities.women && facilities.women.equipedWith) {
      facilities.women.equipedWith['cctvWomen'] = facilities.women.equipedWith['cctv'];
    }
    const mappedResidentialFacilities = {
      // 'availability': facilities.women ? facilities.women.availability : null,
      // 'availabilityOfTransportSystem':facilities.women ? facilities.women.availabilityOfTransportSystem : null,
      // 'totalArea': facilities.women ? facilities.women.totalArea === 0 ? null : facilities.women.totalArea : null,
      // 'menNumberOfRooms': facilities.women ? facilities.women.numberOfRooms === 0 ? null : facilities.women.numberOfRooms : null,
      // 'capacity': facilities.women ? facilities.women.capacity === 0 ? null : facilities.women.capacity : null,
      'equipedWith': facilities.women && facilities.women.equipedWith ? facilities.women.equipedWith : { 'cctvWomen': false, 'allTImeSecurity': false, 'backup': false },
      'Warden': facilities.women ? facilities.women.equipedWith ? facilities.women.equipedWith.femaleWarden : null : null,
      'cctvCameraDocumentUrl': facilities.women ? facilities.women.cctvCameraDocumentUrl : '',
      'previewcctvCameraDocumentUrl': facilities.women ? facilities.women.cctvCameraDocumentUrl : '',
      // 'distanceFromTrainingCentre': facilities.women ? facilities.women.distanceFromTrainingCentre === 0 ? null : facilities.women.distanceFromTrainingCentre : null,
      // 'typeOfConstructionBuildingOfResidential': facilities.women ? facilities.women.typeOfConstructionBuildingOfResidential : '',
      // 'seperateEntranceForMF': facilities.women ? facilities.women.seperateEntranceForMF : null,
      // 'availabilityOfToilet': facilities.women ? facilities.women.availabilityOfToilet : null,
      // 'countOfToilet': facilities.women ? facilities.women.countOfToilet : null,
      // 'availabilityOfBathroom': facilities.women ? facilities.women.availabilityOfBathroom : null,
      // 'countOfBathroom': facilities.women ? facilities.women.countOfBathroom : null,
      // 'availabilityOfToiletCumBathRoom': facilities.women ? facilities.women.availabilityOfToiletCumBathRoom : null,
      // 'countOfBathroomCumToilet': facilities.women ? facilities.women.countOfBathroomCumToilet : null,
      'cleanHygineEquipedWith': facilities.women && facilities.women.cleanAndHygiene ? facilities.women.cleanAndHygiene.equippedWith : null,
      // 'dustbinSize': facilities.women && facilities.women.cleanAndHygiene ? facilities.women.cleanAndHygiene.dustbinSize : null,
      'availabilityOfFirstAidKit': facilities.women && facilities.women.healthFacilities ? facilities.women.healthFacilities.availabilityOfFirstAidKit : null,
      'equippedWith': facilities.women && facilities.women.healthFacilities ? facilities.women.healthFacilities.equippedWith : null,
      'availabilityOfFireFightingEquipment': facilities.women && facilities.women.firefightingequipment ? facilities.women.firefightingequipment.availabilityOfFireFightingequipment : null,
      'fireFightingEquipedWith': facilities.women && facilities.women.firefightingequipment ? facilities.women.firefightingequipment.equippedWith : null,
      'AEBS': facilities.women ? facilities.women.biometricAttendanceSystem : null,
      //'medicalContactNumber':facilities.women && facilities.women.firefightingequipment ?facilities.women.firefightingequipment.medicalContactNumber : null,
      'isMedicalContactNumberAvaliable': facilities.women && facilities.women.firefightingequipment ? facilities.women.firefightingequipment.isMedicalContactNumberAvaliable : null,
      'isEmergencyExitDirection': facilities.women && facilities.women.firefightingequipment ? facilities.women.firefightingequipment.isEmergencyExitDirection : null,
      'biometricAttendanceSystemURL': facilities.women && facilities.women.biometricAttendanceSystemURL ? facilities.women.biometricAttendanceSystemURL : null,
      'countOfDustbin': facilities.women && facilities.women.cleanAndHygiene ? facilities.women.cleanAndHygiene.countOfDustbin : null,

      // 'availabilityOfDiningArea': facilities.women ? facilities.women.availabilityOfDiningArea: null,
      // 'availabilityOfDiningAreaAndRecreationalArea': facilities.women  ? facilities.women.availabilityOfDiningAreaAndRecreationalArea : null,
      // 'meals': facilities.women && facilities.women.meals ? facilities.women.meals : null,
      // 'foodMenu': facilities.women && facilities.women.menuOfFoodList ? facilities.women.menuOfFoodList : null,
      // 'diningArea': facilities.women ? facilities.women.diningArea === 0 ? null : facilities.women.diningArea : null,
      // 'diningAreaAndRecreationalArea': facilities.women ? facilities.women.diningAreaAndRecreationalArea : null ,
      // 'emailForGrievance': facilities.women ? facilities.women.emailForGrievance : null,
      // 'codeOfConductDisplayed': facilities.women ? facilities.women.codeOfConductDisplayed : null,
      // 'lunchTime': facilities.women ? facilities.women.lunchTime : null,
      'womenAreaEquipedWith': facilities.women ? facilities.women.equipedWith : null,
      // 'remarks': facilities.women ? facilities.women.remarks : null,
      // 'wallsOfResidential': facilities.women && facilities.women.wallsOfResidential ? facilities.women.wallsOfResidential : null,
      // 'floorOfTheResidential': facilities.women && facilities.women.floorOfTheResidential ? facilities.women.floorOfTheResidential : null,
      // 'partitionMadeOf': facilities.women && facilities.women.partitionMadeOf ? facilities.women.partitionMadeOf : null,
      // 'houseKeepingStaffType': facilities.women && facilities.women.cleanAndHygiene ? facilities.women.cleanAndHygiene.houseKeepingStaffType : null,
      // 'houseKeppingStaffUrl': facilities.women && facilities.women.cleanAndHygiene ? facilities.women.cleanAndHygiene.houseKeppingStaffUrl : null,
      'cleanAndSafeDrinkingWater': facilities.women ? facilities.women.availabilityOfSafeDrinkingWater : null,
      // 'availabilityOfDustinAndDiningArea': facilities.women ? facilities.women.availabilityOfDustinAndDiningArea : null,
      // 'dustbinSizeInDiningArea': facilities.women ? facilities.women.dustbinSize : null,
      // 'availabilityOfDustinAndDiningAreaRecreationalArea':facilities.women ? facilities.women.availabilityOfDustinAndDiningAreaRecreationalArea:null,
      // 'dustbinSizeInDiningAreaRecreationalArea':facilities.women ? facilities.women.dustbinSizeInDiningAreaRecreationalArea:null

    };
    return mappedResidentialFacilities;
  }

  incomingMapDatatransgender(facilities) {
    console.log(facilities);
    const mappedResidentialFacilities = {
      //'availability': facilities.women ? facilities.women.availability : null,
      //'availabilityOfTransportSystem':facilities.women ? facilities.women.availabilityOfTransportSystem : null,
      //'totalArea': facilities.women ? facilities.women.totalArea === 0 ? null : facilities.women.totalArea : null,
      //'menNumberOfRooms': facilities.women ? facilities.women.numberOfRooms === 0 ? null : facilities.women.numberOfRooms : null,
      //'capacity': facilities.women ? facilities.women.capacity === 0 ? null : facilities.women.capacity : null,
      'equipedWith': facilities.women && facilities.women.equipedWith ? facilities.women.equipedWith : { 'cctvWomen': false, 'allTImeSecurity': false, 'backup': false },
      'Warden': facilities.women ? facilities.women.equipedWith ? facilities.women.equipedWith.femaleWarden : null : null,
      'cctvCameraDocumentUrl': facilities.women ? facilities.women.cctvCameraDocumentUrl : '',
      //'distanceFromTrainingCentre': facilities.women ? facilities.women.distanceFromTrainingCentre === 0 ? null : facilities.women.distanceFromTrainingCentre : null,
      //'typeOfConstructionBuildingOfResidential': facilities.women ? facilities.women.typeOfConstructionBuildingOfResidential : '',
      //'seperateEntranceForMF': facilities.women ? facilities.women.seperateEntranceForMF : null,
      //'availabilityOfToilet': facilities.women ? facilities.women.availabilityOfToilet : null,
      //'countOfToilet': facilities.women ? facilities.women.countOfToilet : null,
      //'availabilityOfBathroom': facilities.women ? facilities.women.availabilityOfBathroom : null,
      //'countOfBathroom': facilities.women ? facilities.women.countOfBathroom : null,
      //'availabilityOfToiletCumBathRoom': facilities.women ? facilities.women.availabilityOfToiletCumBathRoom : null,
      //'countOfBathroomCumToilet': facilities.women ? facilities.women.countOfBathroomCumToilet : null,
      'cleanHygineEquipedWith': facilities.women && facilities.women.cleanAndHygiene ? facilities.women.cleanAndHygiene.equippedWith : null,
      //'dustbinSize': facilities.women && facilities.women.cleanAndHygiene ? facilities.women.cleanAndHygiene.dustbinSize : null,
      'availabilityOfFirstAidKit': facilities.women && facilities.women.healthFacilities ? facilities.women.healthFacilities.availabilityOfFirstAidKit : null,
      'equippedWith': facilities.women && facilities.women.healthFacilities ? facilities.women.healthFacilities.equippedWith : null,
      'availabilityOfFireFightingEquipment': facilities.women && facilities.women.firefightingequipment ? facilities.women.firefightingequipment.availabilityOfFireFightingequipment : null,
      'fireFightingEquipedWith': facilities.women && facilities.women.firefightingequipment ? facilities.women.firefightingequipment.equippedWith : null,
      'AEBS': facilities.women ? facilities.women.biometricAttendanceSystem : null,

      // 'AEBS': facilities.men && facilities.men.biometricAttendanceSystem ? facilities.men.biometricAttendanceSystem : null,
      'countOfDustbin': facilities.women && facilities.women.cleanAndHygiene ? facilities.women.cleanAndHygiene.countOfDustbin : null,
      // 'biometricAttendanceSystemURL': facilities.women && facilities.women.biometricAttendanceSystemURL ? facilities.women.biometricAttendanceSystemURL : null,
      //'availabilityOfDiningArea': facilities.women ? facilities.women.availabilityOfDiningArea: null,
      // 'availabilityOfDiningAreaAndRecreationalArea': facilities.women  ? facilities.women.availabilityOfDiningAreaAndRecreationalArea : null,
      // 'meals': facilities.women && facilities.women.meals ? facilities.women.meals : null,
      // 'foodMenu': facilities.women && facilities.women.menuOfFoodList ? facilities.women.menuOfFoodList : null,
      // 'diningArea': facilities.women ? facilities.women.diningArea === 0 ? null : facilities.women.diningArea : null,
      // 'diningAreaAndRecreationalArea': facilities.women ? facilities.women.diningAreaAndRecreationalArea : null ,
      // 'emailForGrievance': facilities.women ? facilities.women.emailForGrievance : null,
      // 'codeOfConductDisplayed': facilities.women ? facilities.women.codeOfConductDisplayed : null,
      // 'lunchTime': facilities.women ? facilities.women.lunchTime : null,
      // 'womenAreaEquipedWith': facilities.women ? facilities.women.equipedWith : null,
      // 'remarks': facilities.women ? facilities.women.remarks : null,
      // 'wallsOfResidential': facilities.women && facilities.women.wallsOfResidential ? facilities.women.wallsOfResidential : null,
      // 'floorOfTheResidential': facilities.women && facilities.women.floorOfTheResidential ? facilities.women.floorOfTheResidential : null,
      //'partitionMadeOf': facilities.women && facilities.women.partitionMadeOf ? facilities.women.partitionMadeOf : null,
      // 'houseKeepingStaffType': facilities.women && facilities.women.cleanAndHygiene ? facilities.women.cleanAndHygiene.houseKeepingStaffType : null,
      // 'houseKeppingStaffUrl': facilities.women && facilities.women.cleanAndHygiene ? facilities.women.cleanAndHygiene.houseKeppingStaffUrl : null,
      'cleanAndSafeDrinkingWater': facilities.women ? facilities.women.availabilityOfSafeDrinkingWater : null,
      // 'availabilityOfDustinAndDiningArea': facilities.women ? facilities.women.availabilityOfDustinAndDiningArea : null,
      // 'dustbinSizeInDiningArea': facilities.women ? facilities.women.dustbinSize : null,
      // 'availabilityOfDustinAndDiningAreaRecreationalArea':facilities.women ? facilities.women.availabilityOfDustinAndDiningAreaRecreationalArea:null,
      // 'dustbinSizeInDiningAreaRecreationalArea':facilities.women ? facilities.women.dustbinSizeInDiningAreaRecreationalArea:null

    };
    return mappedResidentialFacilities;
  }

  incomingMapDataForTransgender(facilities) {
    console.log(facilities);
    if (facilities && facilities.transgender && facilities.transgender.equipedWith) {
      facilities.transgender.equipedWith['cctvTransgender'] = facilities.transgender.equipedWith['cctv'];
    }
    const mappedResidentialFacilities = {
      // 'availability': facilities.transgender ? facilities.transgender.availability : null,
      // 'availabilityOfTransportSystem': facilities.transgender ? facilities.transgender.availabilityOfTransportSystem : null,
      // 'totalArea': facilities.transgender ? facilities.transgender.totalArea === 0 ? null : facilities.transgender.totalArea : null,
      // 'menNumberOfRooms': facilities.transgender ? facilities.transgender.numberOfRooms === 0 ? null : facilities.transgender.numberOfRooms : null,
      // 'capacity': facilities.transgender ? facilities.transgender.capacity === 0 ? null : facilities.transgender.capacity : null,
      'equipedWith': facilities.transgender && facilities.transgender.equipedWith ? facilities.transgender.equipedWith : { 'cctvTransgender': false, 'allTImeSecurity': false, 'backup': false },
      'Warden': facilities.transgender ? facilities.transgender.equipedWith ? facilities.transgender.equipedWith.warden : null : null,
      'cctvCameraDocumentUrl': facilities.transgender ? facilities.transgender.cctvCameraDocumentUrl == null ? '' : facilities.transgender.cctvCameraDocumentUrl : '',
      'previewcctvCameraDocumentUrl': facilities.transgender ? facilities.transgender.cctvCameraDocumentUrl : '',
      // 'distanceFromTrainingCentre': facilities.transgender ? facilities.transgender.distanceFromTrainingCentre === 0 ? null : facilities.transgender.distanceFromTrainingCentre : null,
      // 'typeOfConstructionBuildingOfResidential': facilities.transgender ? facilities.transgender.typeOfConstructionBuildingOfResidential : '',
      // 'seperateEntranceForMF': facilities.transgender ? facilities.transgender.seperateEntranceForMF : null,
      // 'availabilityOfToilet': facilities.transgender ? facilities.transgender.availabilityOfToilet : false,
      // 'countOfToilet': facilities.transgender ? facilities.transgender.countOfToilet : null,
      // 'availabilityOfBathroom': facilities.transgender ? facilities.transgender.availabilityOfBathroom : false,
      // 'countOfBathroom': facilities.transgender ? facilities.transgender.countOfBathroom : null,
      // 'availabilityOfToiletCumBathRoom': facilities.transgender ? facilities.transgender.availabilityOfToiletCumBathRoom : null,
      // 'countOfBathroomCumToilet': facilities.transgender ? facilities.transgender.countOfBathroomCumToilet : null,
      'cleanHygineEquipedWith': facilities.transgender && facilities.transgender.cleanAndHygiene ? facilities.transgender.cleanAndHygiene.equippedWith : null,
      'dustbinSize': facilities.transgender && facilities.transgender.cleanAndHygiene ? facilities.transgender.cleanAndHygiene.dustbinSize : null,
      'availabilityOfFirstAidKit': facilities.transgender && facilities.transgender.healthFacilities ? facilities.transgender.healthFacilities.availabilityOfFirstAidKit : null,
      'equippedWith': facilities.transgender && facilities.transgender.healthFacilities ? facilities.transgender.healthFacilities.equippedWith : null,
      'availabilityOfFireFightingEquipment': facilities.transgender && facilities.transgender.firefightingequipment ? facilities.transgender.firefightingequipment.availabilityOfFireFightingequipment : null,
      'fireFightingEquipedWith': facilities.transgender && facilities.transgender.firefightingequipment ? facilities.transgender.firefightingequipment.equippedWith : null,
      'AEBS': facilities.transgender ? facilities.transgender.biometricAttendanceSystem : null,
      //'medicalContactNumber':facilities.transgender && facilities.transgender.firefightingequipment ?facilities.transgender.firefightingequipment.medicalContactNumber : null,
      'isMedicalContactNumberAvaliable': facilities.transgender && facilities.transgender.firefightingequipment ? facilities.transgender.firefightingequipment.isMedicalContactNumberAvaliable : null,
      'isEmergencyExitDirection': facilities.transgender && facilities.transgender.firefightingequipment ? facilities.transgender.firefightingequipment.isEmergencyExitDirection : null,
      // 'AEBS': facilities.men && facilities.men.biometricAttendanceSystem ? facilities.men.biometricAttendanceSystem : null,
      'countOfDustbin': facilities.transgender && facilities.transgender.cleanAndHygiene ? facilities.transgender.cleanAndHygiene.countOfDustbin : null,

      // 'biometricAttendanceSystemURL': facilities.transgender && facilities.transgender.biometricAttendanceSystemURL ? facilities.transgender.biometricAttendanceSystemURL : null,
      // 'availabilityOfDiningArea': facilities.transgender ?facilities.transgender.availabilityOfDiningArea  : null,
      // 'availabilityOfDiningAreaAndRecreationalArea': facilities.transgender ? facilities.transgender.availabilityOfDiningAreaAndRecreationalArea : null,
      // 'meals': facilities.transgender && facilities.transgender.meals ? facilities.transgender.meals : null,
      // 'foodMenu': facilities.transgender && facilities.transgender.menuOfFoodList ? facilities.transgender.menuOfFoodList : null,
      //'availabilityOfBathroom': facilities.transgender ? facilities.transgender.availabilityOfBathroom : null,
      // 'diningArea': facilities.transgender ? facilities.transgender.diningArea === 0 ? null : facilities.transgender.diningArea : null,
      // 'diningAreaAndRecreationalArea': facilities.transgender ? facilities.transgender.diningAreaAndRecreationalArea  : null,
      // 'emailForGrievance': facilities.transgender ? facilities.transgender.emailForGrievance : null,
      // 'codeOfConductDisplayed': facilities.transgender ? facilities.transgender.codeOfConductDisplayed : null,
      // 'lunchTime': facilities.transgender ? facilities.transgender.lunchTime : null,
      // 'remarks': facilities.transgender ? facilities.transgender.remarks : null,
      // 'wallsOfResidential': facilities.transgender && facilities.transgender.wallsOfResidential ? facilities.transgender.wallsOfResidential : null,
      // 'floorOfTheResidential': facilities.transgender && facilities.transgender.floorOfTheResidential ? facilities.transgender.floorOfTheResidential : null,
      // 'partitionMadeOf': facilities.transgender && facilities.transgender.partitionMadeOf ? facilities.transgender.partitionMadeOf : null,
      // 'houseKeepingStaffType': facilities.transgender && facilities.transgender.cleanAndHygiene ? facilities.transgender.cleanAndHygiene.houseKeepingStaffType : null,
      // 'houseKeppingStaffUrl': facilities.transgender && facilities.transgender.cleanAndHygiene ? facilities.transgender.cleanAndHygiene.houseKeppingStaffUrl : null,
      'cleanAndSafeDrinkingWater': facilities.transgender ? facilities.transgender.availabilityOfSafeDrinkingWater : null,
      // 'availabilityOfDustinAndDiningArea': facilities.transgender ? facilities.transgender.availabilityOfDustinAndDiningArea : null,
      // 'dustbinSizeInDiningArea': facilities.transgender ? facilities.transgender.dustbinSize : null,
      // 'availabilityOfDustinAndDiningAreaRecreationalArea':facilities.transgender ? facilities.transgender.availabilityOfDustinAndDiningAreaRecreationalArea:null,
      // 'dustbinSizeInDiningAreaRecreationalArea':facilities.transgender ? facilities.transgender.dustbinSizeInDiningAreaRecreationalArea:null
    };
    return mappedResidentialFacilities;
  }
  incomingForTypeOfResidential(residential) {
    const mappedType = { 'type': residential.type }
    return mappedType;
  }
  incomingMapDataGeneral(gentrainingCentreFacilities) {
    const genralDetails = {
      'trainingCentreFacilities': gentrainingCentreFacilities['trainingCentreFacilities'],
      'trainingCentreFacilities1': gentrainingCentreFacilities['trainingCentreFacilities'],
      'trainingCentreFacilities2': gentrainingCentreFacilities['trainingCentreFacilities']
    }
    return genralDetails;
  }
  saveAndNext(valueGender, saveAsDraft?) {
    // console.log(this.valid);
    //if (this.valid) {
    const men = 'men';
    const women = 'women';
    const transgender = 'transgender';
    if (valueGender == men) {

        const dataToUpdate = this.mapOutgoing(this.residentialFacilities, this.infraFormMen, this.diningAreaFormsMen,
          this.diningAreaRecreationalFormsMen);
        this.updateDetails(dataToUpdate, 'men', saveAsDraft);


    }
    if (valueGender == women) {

        const dataToUpdate = this.mapOutgoingForWoMen(this.residentialFacilitiesWomen, this.infraFormWomen, this.diningAreaFormsWomen, this.diningAreaRecreationalFormsWomen);
        this.updateDetails(dataToUpdate, 'women', saveAsDraft);

    }
    if (valueGender == transgender) {

        const dataToUpdate = this.mapOutgoingForTransgender(this.residentialFacilitiesTransgender, this.infraFormTransgender, this.diningAreaFormsTransgender, this.diningAreaRecreationalFormsTransgender);
        this.updateDetails(dataToUpdate, 'transgender', saveAsDraft);

    }

  }

  canDisplay() {
    this.sweetAlert = {
      one: 'Please Complete Mobile App',
      two: ``,
      text: 'Ok',
      text1: 'Cancel',
      textClass: Colors.COLOR_PRIMARY,
      text1Class: Colors.COLOR_PRIMARY
    };

  }
  mapOutgoingForWoMen(women, infraFormWomen, diningAreaFormsWomen, diningAreaRecreationalFormsWomen) {
    if (women && women.equipedWith) {
      women.equipedWith['femaleWarden'] = women['Warden'];
      women.equipedWith['cctv'] = women.equipedWith['cctvWomen'];
    }
    let outgoingMapped = {
      'residentialFacilities': {
        'type': this.typeOfResidencialData.type,
        // 'men': { 'availability': false },
        // 'women': { 'availability': false },
        'women': { 'availability': false },
        'submitForApproval': false
      }
    }
    outgoingMapped = this.addAvailabilityBasedOnTypeWomen(outgoingMapped, women, infraFormWomen, diningAreaFormsWomen, diningAreaRecreationalFormsWomen);
    outgoingMapped['residentialFacilities'] = Object.assign(outgoingMapped['residentialFacilities'], this.patchOugoingofHomePage());
    return outgoingMapped;
  }
  mapOutgoingForTransgender(transgender,
    infraFormTransgender, diningAreaFormsTransgender, diningAreaRecreationalFormsTransgender) {
    if (transgender && transgender.equipedWith) {
      transgender.equipedWith['warden'] = transgender['Warden'];
      transgender.equipedWith['cctv'] = transgender.equipedWith['cctvTransgender'];
    }
    let outgoingMapped = {
      'residentialFacilities': {
        'type': this.typeOfResidencialData.type,
        // 'men': { 'availability': false },
        // 'women': { 'availability': false },
        'transgender': { 'availability': false },
        'submitForApproval': false
      }
    }
    outgoingMapped = this.addAvailabilityBasedOnTypeTransgender(outgoingMapped, transgender,
      infraFormTransgender, diningAreaFormsTransgender, diningAreaRecreationalFormsTransgender);
    outgoingMapped['residentialFacilities'] = Object.assign(outgoingMapped['residentialFacilities'], this.patchOugoingofHomePage());
    return outgoingMapped;
  }
  mapOutgoing(resfacilities, infraFormMen, diningAreaFormsMen, diningAreaRecreationalFormsMen
  ) {
    console.log(resfacilities);

    if (resfacilities && resfacilities.equipedWith) {
      resfacilities.equipedWith['warden'] = resfacilities['Warden'];
      resfacilities.equipedWith['cctv'] = resfacilities.equipedWith['cctvMen'];
    }
    let outgoingMapped = {
      'residentialFacilities': {
        'type': this.typeOfResidencialData.type,
        'men': { 'availability': false },
        // 'women': { 'availability': false },
        // 'transgender': { 'availability': false },
        'submitForApproval': false
      }
    }
    outgoingMapped = this.addAvailabilityBasedOnType(outgoingMapped, resfacilities, infraFormMen, diningAreaFormsMen, diningAreaRecreationalFormsMen);
    outgoingMapped['residentialFacilities'] = Object.assign(this.userDetails && this.userDetails.residentialFacilities && this.userDetails.residentialFacilities ? this.userDetails.residentialFacilities : {}, outgoingMapped['residentialFacilities'], this.patchOugoingofHomePage());
    return outgoingMapped;
  }
  addAvailabilityBasedOnTypeWomen(value, women, infraFormWomen, diningAreaFormsWomen, diningAreaRecreationalFormsWomen) {
    if (this.typeOfResidencialData && this.typeOfResidencialData.type.women == true) {
      //women.cleanHygineEquipedWith = Object.assign(women.cleanHygineEquipedWith ? women.cleanHygineEquipedWith : {},{dustbinSize:this.residentialFormGroup.get('womenForm').get('dustbinSize').value})
      value['residentialFacilities'].women = {
        'availability': true,
        'totalArea': this.residentialFormGroup.get('womenForm').get('totalArea').value,
        'capacity': this.residentialFormGroup.get('womenForm').get('capacity').value,
        'cctvCameraDocumentUrl': (women && women.cctvCameraDocumentUrl) ? women.cctvCameraDocumentUrl : undefined,
        'distanceFromTrainingCentre': women ? women.distanceFromTrainingCentre : null,
        'typeOfConstructionBuildingOfResidential': infraFormWomen['formData'] ? infraFormWomen['formData'].typeOfConstructionBuildingOfResidential : null,
        'seperateEntranceForMF': this.residentialFormGroup.get('womenForm').get('seperateEntranceForMF').value,
        'availabilityOfTransportSystem': this.residentialFormGroup.get('womenForm').get('availabilityOfTransportSystem').value,
        'availabilityOfBathroom': infraFormWomen['formData'] ? infraFormWomen['formData'].availabilityOfBathroom : null,
        'emailForGrievance': infraFormWomen['formData'] ? infraFormWomen['formData'].emailForGrievance : null,
        'codeOfConductDisplayed': infraFormWomen['formData'] ? infraFormWomen['formData'].codeOfConductDisplayed : null,
        'availabilityOfToilet': infraFormWomen['formData'] ? infraFormWomen['formData'].availabilityOfToilet : null,
        'partitionMadeOf': infraFormWomen['formData'] ? infraFormWomen['formData'].partitionMadeOf : null,
        'lunchTime': infraFormWomen['formData'] ? infraFormWomen['formData'].lunchTime : null,
        'diningAreaAndRecreationalArea': diningAreaRecreationalFormsWomen['formData'] ? diningAreaRecreationalFormsWomen['formData'].diningAreaAndRecreationalArea : null,
        'diningArea': diningAreaFormsWomen['formData'] ? diningAreaFormsWomen['formData'].diningArea : null,
        'rooms': this.womenRooms,
        'equipedWith': women ? women.equipedWith === null ? { 'cctv': false, 'warden': false, 'allTImeSecurity': false, 'backup': false } :
          women.equipedWith : null,
        'countOfToilet': infraFormWomen['formData'] ? infraFormWomen['formData'].countOfToilet : null,
        'countOfBathroom': infraFormWomen['formData'] ? infraFormWomen['formData'].countOfBathroom : null,
        'availabilityOfToiletCumBathRoom': infraFormWomen['formData'] ? infraFormWomen['formData'].availabilityOfToiletCumBathRoom : null,
        'countOfBathroomCumToilet': infraFormWomen['formData'] ? infraFormWomen['formData'].countOfBathroomCumToilet : null,
        'cleanAndHygiene': {
          // 'houseKeepingStaffType': women ? women.houseKeepingStaffType : null,
          // 'houseKeppingStaffUrl': women ? women.houseKeppingStaffUrl : null,
          'countOfDustbin': women ? women.countOfDustbin : null,
          'dustbinSize': this.residentialFormGroup.get('womenForm').get('dustbinSize').value,
          'equippedWith': women ? women.cleanHygineEquipedWith : null
        },
        'healthFacilities': {
          'availabilityOfFirstAidKit': women ? women.availabilityOfFirstAidKit : null,
          "equippedWith": women ? women.equippedWith : null
        },
        "firefightingequipment": {
          'availabilityOfFireFightingequipment': women ? women.availabilityOfFireFightingEquipment : null,
          "equippedWith": women ? women.fireFightingEquipedWith : null,
          'isMedicalContactNumberAvaliable': women ? women.isMedicalContactNumberAvaliable : null,
          //'medicalContactNumber':women ? women.medicalContactNumber : null,
          'isEmergencyExitDirection': women ? women.isEmergencyExitDirection : null,
        },
        'biometricAttendanceSystem': women && women.AEBS ? women.AEBS : null,
        // 'biometricAttendanceSystemURL': women ? women.biometricAttendanceSystemURL : null,
        'availabilityOfDiningArea': diningAreaFormsWomen['formData'] ? diningAreaFormsWomen['formData'].availabilityOfDiningArea : null,
        'availabilityOfDiningAreaAndRecreationalArea': diningAreaRecreationalFormsWomen['formData'] ? diningAreaRecreationalFormsWomen['formData'].availabilityOfDiningAreaAndRecreationalArea : null,
        'meals': women ? women.meals : null,
        'menuOfFoodList': women ? women.foodMenu : null,
        'remarks': women ? women.remarks : null,
        'areaOfToilet': this.residentialFormGroup.get('womenForm').get('areaOfToilet').value,
        'areaOfBathroom': this.residentialFormGroup.get('womenForm').get('areaOfBathroom').value,
        'areaOfToiletCumBathroom': this.residentialFormGroup.get('womenForm').get('areaOfToiletCumBathroom').value,
        // 'wallsOfResidential': women ? women.wallsOfResidential : null,
        // 'floorOfTheResidential': women ? women.floorOfTheResidential : null,
        // 'partitionMadeOf': infraFormWomen['formData'] ? infraFormWomen['formData'].partitionMadeOf : null,
        'availabilityOfSafeDrinkingWater': women ? women.cleanAndSafeDrinkingWater : null,
        'availabilityOfDustinAndDiningArea': diningAreaFormsWomen['formData'] ? diningAreaFormsWomen['formData'].availabilityOfDustinAndDiningArea : null,
        'dustbinSize': diningAreaFormsWomen['formData'] ? diningAreaFormsWomen['formData'].dustbinSizeInDiningArea : null,
        'availabilityOfCeilingFanDiningArea': diningAreaFormsWomen['formData'] ? diningAreaFormsWomen['formData'].availabilityOfCeilingFanDiningArea : null,
        'numberOfCeilingFanDiningArea': diningAreaFormsWomen['formData'] ? diningAreaFormsWomen['formData'].numberOfCeilingFanDiningArea : null,
        'availabilityOfWallMountedFanDiningArea': diningAreaFormsWomen['formData'] ? diningAreaFormsWomen['formData'].availabilityOfWallMountedFanDiningArea : null,
        'numberOfWallMountedDiningArea': diningAreaFormsWomen['formData'] ? diningAreaFormsWomen['formData'].numberOfWallMountedDiningArea : null,
        'numberOfBulbDiningArea': diningAreaFormsWomen['formData'] ? diningAreaFormsWomen['formData'].numberOfBulbDiningArea : null,
        'availabilityOfBulbDiningArea': diningAreaFormsWomen['formData'] ? diningAreaFormsWomen['formData'].availabilityOfBulbDiningArea : null,
        'address': this.data.addressForWomen ? this.data.addressForWomen : null,
        'availabilityOfDustinAndDiningAreaRecreationalArea': diningAreaRecreationalFormsWomen['formData'] ? diningAreaRecreationalFormsWomen['formData'].availabilityOfDustinAndDiningAreaRecreationalArea : null,
        'dustbinSizeInDiningAreaRecreationalArea': this.residentialFormGroup.get('womenForm').get('dustbinSizeInDiningAreaRecreationalArea').value,
        'availabilityOfCeilingFanDiningRecreationArea': diningAreaRecreationalFormsWomen['formData'] ? diningAreaRecreationalFormsWomen['formData'].availabilityOfCeilingFanDiningRecreationArea : null,
        'availabilityOfBulbDiningAreaRecreationalArea': diningAreaRecreationalFormsWomen['formData'] ? diningAreaRecreationalFormsWomen['formData'].availabilityOfBulbDiningAreaRecreationalArea : null,
        'availabilityOfWallMountedFanDiningRecreationalArea': diningAreaRecreationalFormsWomen['formData'] ? diningAreaRecreationalFormsWomen['formData'].availabilityOfWallMountedFanDiningRecreationalArea : null,
        'numberOfCeilingDiningRecreationArea': diningAreaRecreationalFormsWomen['formData'] ? diningAreaRecreationalFormsWomen['formData'].numberOfCeilingDiningRecreationArea : null,
        'numberOfMountedFanDiningRecreationalArea': diningAreaRecreationalFormsWomen['formData'] ? diningAreaRecreationalFormsWomen['formData'].numberOfMountedFanDiningRecreationalArea : null,
        'numberOfBulbDiningAreaRecreationalArea': diningAreaRecreationalFormsWomen['formData'] ? diningAreaRecreationalFormsWomen['formData'].numberOfBulbDiningAreaRecreationalArea : null,
        'countOfdustbinSizeInDiningAreaRecreationalArea': diningAreaRecreationalFormsWomen['formData'] ? diningAreaRecreationalFormsWomen['formData'].countOfdustbinSizeInDiningAreaRecreationalArea : null,
        //'diningAreaAndRecreationalArea':diningAreaRecreationalFormsWomen['formData']?diningAreaRecreationalFormsWomen['formData'].countOfdustbinSizeInDiningAreaRecreationalArea:null,
        // 'availabilityOfTransportSystem':this.residentialFormGroup.get('womenForm').get('availabilityOfTransportSystem').value,
      }
      value['residentialFacilities']['women']['address']['addressLine'] = this.data.addressForWomen ? this.data.addressForWomen.address1 : null;
      value['residentialFacilities']['women']['address']['addressProof'] = {
        type: this.data.addressForWomen ? this.data.addressForWomen.addressProofType : null,
        locationURL: this.data.addressForWomen ? typeof this.data.addressForWomen.addressProof === "string" ? this.data.addressForWomen.addressProof : this.data.addressForWomen.addressProof && this.data.addressForWomen.addressProof.locationURL : null
        // this.data.addressForWomen ? this.data.addressForWomen.addressProof : null
      }
      value['residentialFacilities'] = Object.assign(this.userDetails && this.userDetails.residentialFacilities && this.userDetails.residentialFacilities ? this.userDetails.residentialFacilities : {}, value['residentialFacilities'])

    }
    return value;
  }
  addAvailabilityBasedOnTypeTransgender(value, transgender, infraFormTransgender, diningAreaFormsTransgender, diningAreaRecreationalFormsTransgender) {
    if (this.typeOfResidencialData && this.typeOfResidencialData.type.transgender == true) {
      //	transgender.cleanHygineEquipedWith = Object.assign(transgender.cleanHygineEquipedWith ? transgender.cleanHygineEquipedWith : {},{dustbinSize:this.residentialFormGroup.get('transgenderForm').get('dustbinSize').value})
      value['residentialFacilities'].transgender = {
        'availability': true,
        'availabilityOfTransportSystem': this.residentialFormGroup.get('transgenderForm').get('availabilityOfTransportSystem').value,
        'totalArea': this.residentialFormGroup.get('transgenderForm').get('totalArea').value,
        'capacity': this.residentialFormGroup.get('transgenderForm').get('capacity').value,
        'cctvCameraDocumentUrl': (transgender && transgender.cctvCameraDocumentUrl) ? transgender.cctvCameraDocumentUrl : undefined,
        'distanceFromTrainingCentre': transgender ? transgender.distanceFromTrainingCentre : null,
        'typeOfConstructionBuildingOfResidential': infraFormTransgender['formData'] ? infraFormTransgender['formData'].typeOfConstructionBuildingOfResidential : null,
        'seperateEntranceForMF': this.residentialFormGroup.get('transgenderForm').get('seperateEntranceForMF').value,
        'availabilityOfBathroom': infraFormTransgender['formData'] ? infraFormTransgender['formData'].availabilityOfBathroom : null,
        'emailForGrievance': infraFormTransgender['formData'] ? infraFormTransgender['formData'].emailForGrievance : null,
        'codeOfConductDisplayed': infraFormTransgender['formData'] ? infraFormTransgender['formData'].codeOfConductDisplayed : null,
        'availabilityOfToilet': infraFormTransgender['formData'] ? infraFormTransgender['formData'].availabilityOfToilet : null,
        'lunchTime': infraFormTransgender['formData'] ? infraFormTransgender['formData'].lunchTime : null,
        'diningAreaAndRecreationalArea': diningAreaRecreationalFormsTransgender['formData'] ? diningAreaRecreationalFormsTransgender['formData'].diningAreaAndRecreationalArea : null,
        'diningArea': diningAreaFormsTransgender['formData'] ? diningAreaFormsTransgender['formData'].diningArea : null,
        'rooms': this.transngender,
        'equipedWith': transgender ? transgender.equipedWith === null ? { 'cctv': false, 'warden': false, 'allTImeSecurity': false, 'backup': false } :
          transgender.equipedWith : null,
        'countOfToilet': infraFormTransgender['formData'] ? infraFormTransgender['formData'].countOfToilet : null,
        'countOfBathroom': infraFormTransgender['formData'] ? infraFormTransgender['formData'].countOfBathroom : null,
        'availabilityOfToiletCumBathRoom': infraFormTransgender['formData'] ? infraFormTransgender['formData'].availabilityOfToiletCumBathRoom : null,
        'countOfBathroomCumToilet': infraFormTransgender['formData'] ? infraFormTransgender['formData'].countOfBathroomCumToilet : null,
        'cleanAndHygiene': {
          // 'houseKeepingStaffType': transgender ? transgender.houseKeepingStaffType : null,
          // 'houseKeppingStaffUrl': transgender ? transgender.houseKeppingStaffUrl : null,
          'countOfDustbin': transgender ? transgender.countOfDustbin : null,
          'dustbinSize': this.residentialFormGroup.get('transgenderForm').get('dustbinSize').value,
          'equippedWith': transgender ? transgender.cleanHygineEquipedWith : null
        },
        'healthFacilities': {
          'availabilityOfFirstAidKit': transgender ? transgender.availabilityOfFirstAidKit : null,
          "equippedWith": transgender ? transgender.equippedWith : null
        },
        "firefightingequipment": {
          'availabilityOfFireFightingequipment': transgender ? transgender.availabilityOfFireFightingEquipment : null,
          "equippedWith": transgender ? transgender.fireFightingEquipedWith : null,
          'isMedicalContactNumberAvaliable': transgender ? transgender.isMedicalContactNumberAvaliable : null,
          //'medicalContactNumber':transgender ? transgender.medicalContactNumber : null,
          'isEmergencyExitDirection': transgender ? transgender.isEmergencyExitDirection : null,
        },
        'biometricAttendanceSystem': transgender && transgender.AEBS ? transgender.AEBS : null,
        // 'biometricAttendanceSystemURL': transgender ? transgender.biometricAttendanceSystemURL : null,
        'availabilityOfDiningArea': diningAreaFormsTransgender['formData'] ? diningAreaFormsTransgender['formData'].availabilityOfDiningArea : null,
        'availabilityOfDiningAreaAndRecreationalArea': diningAreaRecreationalFormsTransgender['formData'] ? diningAreaRecreationalFormsTransgender['formData'].availabilityOfDiningAreaAndRecreationalArea : null,
        'meals': transgender ? transgender.meals : null,
        'menuOfFoodList': transgender ? transgender.foodMenu : null,
        'remarks': transgender ? transgender.remarks : null,
        // 'wallsOfResidential': transgender ? transgender.wallsOfResidential : null,
        // 'floorOfTheResidential': transgender ? transgender.floorOfTheResidential : null,
        'partitionMadeOf': infraFormTransgender['formData'] ? infraFormTransgender['formData'].partitionMadeOf : null,
        'areaOfToilet': this.residentialFormGroup.get('transgenderForm').get('areaOfToilet').value,
        'areaOfBathroom': this.residentialFormGroup.get('transgenderForm').get('areaOfBathroom').value,
        'areaOfToiletCumBathroom': this.residentialFormGroup.get('transgenderForm').get('areaOfToiletCumBathroom').value,
        'availabilityOfSafeDrinkingWater': transgender ? transgender.cleanAndSafeDrinkingWater : null,
        'address': this.data.addressForTransgender ? this.data.addressForTransgender : null,
        'availabilityOfDustinAndDiningArea': diningAreaFormsTransgender['formData'] ? diningAreaFormsTransgender['formData'].availabilityOfDustinAndDiningArea : null,
        'dustbinSize': diningAreaFormsTransgender['formData'] ? diningAreaFormsTransgender['formData'].dustbinSizeInDiningArea : null,
        'availabilityOfDustinAndDiningAreaRecreationalArea': diningAreaRecreationalFormsTransgender['formData'] ? diningAreaRecreationalFormsTransgender['formData'].availabilityOfDustinAndDiningAreaRecreationalArea : null,
        'dustbinSizeInDiningAreaRecreationalArea': this.residentialFormGroup.get('transgenderForm').get('dustbinSizeInDiningAreaRecreationalArea').value,
        'availabilityOfCeilingFanDiningArea': diningAreaFormsTransgender['formData'] ? diningAreaFormsTransgender['formData'].availabilityOfCeilingFanDiningArea : null,
        'numberOfCeilingFanDiningArea': diningAreaFormsTransgender['formData'] ? diningAreaFormsTransgender['formData'].numberOfCeilingFanDiningArea : null,
        'availabilityOfWallMountedFanDiningArea': diningAreaFormsTransgender['formData'] ? diningAreaFormsTransgender['formData'].availabilityOfWallMountedFanDiningArea : null,
        'numberOfWallMountedDiningArea': diningAreaFormsTransgender['formData'] ? diningAreaFormsTransgender['formData'].numberOfWallMountedDiningArea : null,
        'numberOfBulbDiningArea': diningAreaFormsTransgender['formData'] ? diningAreaFormsTransgender['formData'].numberOfBulbDiningArea : null,
        'availabilityOfBulbDiningArea': diningAreaFormsTransgender['formData'] ? diningAreaFormsTransgender['formData'].availabilityOfBulbDiningArea : null,
        'availabilityOfCeilingFanDiningRecreationArea': diningAreaRecreationalFormsTransgender['formData'] ? diningAreaRecreationalFormsTransgender['formData'].availabilityOfCeilingFanDiningRecreationArea : null,
        'availabilityOfBulbDiningAreaRecreationalArea': diningAreaRecreationalFormsTransgender['formData'] ? diningAreaRecreationalFormsTransgender['formData'].availabilityOfBulbDiningAreaRecreationalArea : null,
        'availabilityOfWallMountedFanDiningRecreationalArea': diningAreaRecreationalFormsTransgender['formData'] ? diningAreaRecreationalFormsTransgender['formData'].availabilityOfWallMountedFanDiningRecreationalArea : null,
        'numberOfCeilingDiningRecreationArea': diningAreaRecreationalFormsTransgender['formData'] ? diningAreaRecreationalFormsTransgender['formData'].numberOfCeilingDiningRecreationArea : null,
        'numberOfMountedFanDiningRecreationalArea': diningAreaRecreationalFormsTransgender['formData'] ? diningAreaRecreationalFormsTransgender['formData'].numberOfMountedFanDiningRecreationalArea : null,
        'numberOfBulbDiningAreaRecreationalArea': diningAreaRecreationalFormsTransgender['formData'] ? diningAreaRecreationalFormsTransgender['formData'].numberOfBulbDiningAreaRecreationalArea : null,
        'countOfdustbinSizeInDiningAreaRecreationalArea': diningAreaRecreationalFormsTransgender['formData'] ? diningAreaRecreationalFormsTransgender['formData'].countOfdustbinSizeInDiningAreaRecreationalArea : null,
      }
      value['residentialFacilities']['transgender']['address']['addressLine'] = this.data.addressForTransgender ? this.data.addressForTransgender.address1 : null;
      value['residentialFacilities']['transgender']['address']['addressProof'] = {
        type: this.data.addressForTransgender ? this.data.addressForTransgender.addressProofType : null,
        locationURL: this.data.addressForTransgender ? typeof this.data.addressForTransgender.addressProof === "string" ? this.data.addressForTransgender.addressProof : this.data.addressForTransgender.addressProof && this.data.addressForTransgender.addressProof.locationURL : null
        // this.data.addressForTransgender ? this.data.addressForTransgender.addressProof : null
      }
      value['residentialFacilities'] = Object.assign(this.userDetails && this.userDetails.residentialFacilities && this.userDetails.residentialFacilities ? this.userDetails.residentialFacilities : {}, value['residentialFacilities'])
      // if (value['residentialFacilities'].trasgender.hasOwnProperty('dustbinSizeInDiningAreaRecreationalArea')) {
      // 	delete value['residentialFacilities'].trasgender.dustbinSizeInDiningAreaRecreationalArea;
      // }
    }
    return value;
  }
  //women, infraFormWomen, diningAreaFormsWomen, diningAreaRecreationalFormsWomen, transgender,infraFormTransgender,diningAreaFormsTransgender,diningAreaRecreationalFormsTransgender
  addAvailabilityBasedOnType(value, resfacilities, infraFormMen, diningAreaFormsMen, diningAreaRecreationalFormsMen,
  ) {
    if (this.typeOfResidencialData && this.typeOfResidencialData.type.men == true) {
      //	resfacilities.cleanHygineEquipedWith = Object.assign(resfacilities.cleanHygineEquipedWith ? resfacilities.cleanHygineEquipedWith : {},{dustbinSize:this.residentialFormGroup.get('menForm').get('dustbinSize').value})

      value['residentialFacilities']['men'] = {
        'availability': true,

        'totalArea': this.residentialFormGroup.get('menForm').get('totalArea').value,
        'capacity': this.residentialFormGroup.get('menForm').get('capacity').value,
        'cctvCameraDocumentUrl': resfacilities ? resfacilities.cctvCameraDocumentUrl : undefined,
        'distanceFromTrainingCentre': resfacilities ? resfacilities.distanceFromTrainingCentre : null,
        'typeOfConstructionBuildingOfResidential': infraFormMen['formData'] ? infraFormMen['formData'].typeOfConstructionBuildingOfResidential : null,
        'seperateEntranceForMF': resfacilities ? resfacilities.seperateEntranceForMF : null,
        'availabilityOfBathroom': infraFormMen['formData'] ? infraFormMen['formData'].availabilityOfBathroom : null,
        'emailForGrievance': infraFormMen['formData'] ? infraFormMen['formData'].emailForGrievance : null,
        'codeOfConductDisplayed': infraFormMen['formData'] ? infraFormMen['formData'].codeOfConductDisplayed : null,
        'availabilityOfToilet': infraFormMen['formData'] ? infraFormMen['formData'].availabilityOfToilet : null,
        'lunchTime': infraFormMen['formData'] ? infraFormMen['formData'].lunchTime : null,
        'diningAreaAndRecreationalArea': diningAreaRecreationalFormsMen['formData'] ? diningAreaRecreationalFormsMen['formData'].diningAreaAndRecreationalArea : null,
        'diningArea': diningAreaFormsMen['formData'] ? diningAreaFormsMen['formData'].diningArea : null,
        'rooms': this.menRooms,
        'equipedWith': resfacilities ?
          resfacilities.equipedWith === null ? { 'cctv': false, 'warden': false, 'allTImeSecurity': false, 'backup': false } :
            resfacilities.equipedWith : null,
        'countOfToilet': infraFormMen['formData'] ? infraFormMen['formData'].countOfToilet : null,
        'countOfBathroom': infraFormMen['formData'] ? infraFormMen['formData'].countOfBathroom : null,
        'availabilityOfToiletCumBathRoom': infraFormMen['formData'] ? infraFormMen['formData'].availabilityOfToiletCumBathRoom : null,
        'countOfBathroomCumToilet': infraFormMen['formData'] ? infraFormMen['formData'].countOfBathroomCumToilet : null,
        'cleanAndHygiene': {
          // 'houseKeepingStaffType': resfacilities ? resfacilities.houseKeepingStaffType : null,
          // 'houseKeppingStaffUrl': resfacilities ? resfacilities.houseKeppingStaffUrl : null,
          'countOfDustbin': resfacilities ? resfacilities.countOfDustbin : null,
          'dustbinSize': this.residentialFormGroup.get('menForm').get('dustbinSize').value,
          'equippedWith': resfacilities ? resfacilities.cleanHygineEquipedWith : null,

        },
        'healthFacilities': {
          'availabilityOfFirstAidKit': resfacilities ? resfacilities.availabilityOfFirstAidKit : null,
          "equippedWith": resfacilities ? resfacilities.equippedWith : null
        },
        "firefightingequipment": {
          'availabilityOfFireFightingequipment': resfacilities ? resfacilities.availabilityOfFireFightingEquipment : null,
          "equippedWith": resfacilities ? resfacilities.fireFightingEquipedWith : null,
          'isMedicalContactNumberAvaliable': resfacilities ? resfacilities.isMedicalContactNumberAvaliable : null,
          //'medicalContactNumber':resfacilities ? resfacilities.medicalContactNumber : null,
          'isEmergencyExitDirection': resfacilities ? resfacilities.isEmergencyExitDirection : null,
        },
        'biometricAttendanceSystem': resfacilities ? resfacilities.AEBS : null,
        // 'biometricAttendanceSystemURL': resfacilities ? resfacilities.biometricAttendanceSystemURL : null,
        'availabilityOfDiningArea': diningAreaFormsMen['formData'] ? diningAreaFormsMen['formData'].availabilityOfDiningArea : null,
        'availabilityOfCeilingFanDiningArea': diningAreaFormsMen['formData'] ? diningAreaFormsMen['formData'].availabilityOfCeilingFanDiningArea : null,
        'numberOfCeilingFanDiningArea': diningAreaFormsMen['formData'] ? diningAreaFormsMen['formData'].numberOfCeilingFanDiningArea : null,
        'availabilityOfWallMountedFanDiningArea': diningAreaFormsMen['formData'] ? diningAreaFormsMen['formData'].availabilityOfWallMountedFanDiningArea : null,
        'numberOfWallMountedDiningArea': diningAreaFormsMen['formData'] ? diningAreaFormsMen['formData'].numberOfWallMountedDiningArea : null,
        'numberOfBulbDiningArea': diningAreaFormsMen['formData'] ? diningAreaFormsMen['formData'].numberOfBulbDiningArea : null,
        'availabilityOfBulbDiningArea': diningAreaFormsMen['formData'] ? diningAreaFormsMen['formData'].availabilityOfBulbDiningArea : null,
        'availabilityOfDiningAreaAndRecreationalArea': diningAreaRecreationalFormsMen['formData'] ? diningAreaRecreationalFormsMen['formData'].availabilityOfDiningAreaAndRecreationalArea : null,
        'meals': resfacilities ? resfacilities.meals : null,
        'menuOfFoodList': resfacilities ? resfacilities.foodMenu : null,
        'remarks': resfacilities ? resfacilities.remarks : null,
        // 'wallsOfResidential': resfacilities ? resfacilities.wallsOfResidential : null,
        // 'floorOfTheResidential': resfacilities ? resfacilities.floorOfTheResidential : null,
        'partitionMadeOf': infraFormMen['formData'] ? infraFormMen['formData'].partitionMadeOf : null,
        'availabilityOfSafeDrinkingWater': resfacilities ? resfacilities.cleanAndSafeDrinkingWater : null,
        'availabilityOfDustinAndDiningArea': diningAreaFormsMen['formData'] ? diningAreaFormsMen['formData'].availabilityOfDustinAndDiningArea : null,
        'availabilityOfCeilingFanDiningRecreationArea': diningAreaRecreationalFormsMen['formData'] ? diningAreaRecreationalFormsMen['formData'].availabilityOfCeilingFanDiningRecreationArea : null,
        'availabilityOfBulbDiningAreaRecreationalArea': diningAreaRecreationalFormsMen['formData'] ? diningAreaRecreationalFormsMen['formData'].availabilityOfBulbDiningAreaRecreationalArea : null,
        'availabilityOfWallMountedFanDiningRecreationalArea': diningAreaRecreationalFormsMen['formData'] ? diningAreaRecreationalFormsMen['formData'].availabilityOfWallMountedFanDiningRecreationalArea : null,
        'numberOfCeilingDiningRecreationArea': diningAreaRecreationalFormsMen['formData'] ? diningAreaRecreationalFormsMen['formData'].numberOfCeilingDiningRecreationArea : null,
        'numberOfMountedFanDiningRecreationalArea': diningAreaRecreationalFormsMen['formData'] ? diningAreaRecreationalFormsMen['formData'].numberOfMountedFanDiningRecreationalArea : null,
        'numberOfBulbDiningAreaRecreationalArea': diningAreaRecreationalFormsMen['formData'] ? diningAreaRecreationalFormsMen['formData'].numberOfBulbDiningAreaRecreationalArea : null,
        'dustbinSize': diningAreaFormsMen['formData'] ? diningAreaFormsMen['formData'].dustbinSizeInDiningArea : null,
        'address': this.data.addressForMen ? this.data.addressForMen : null,
        'areaOfToilet': this.residentialFormGroup.get('menForm').get('areaOfToilet').value,
        'areaOfBathroom': this.residentialFormGroup.get('menForm').get('areaOfBathroom').value,
        'areaOfToiletCumBathroom': this.residentialFormGroup.get('menForm').get('areaOfToiletCumBathroom').value,
        'countOfdustbinSizeInDiningAreaRecreationalArea': diningAreaRecreationalFormsMen['formData'] ? diningAreaRecreationalFormsMen['formData'].countOfdustbinSizeInDiningAreaRecreationalArea : null,
        'availabilityOfDustinAndDiningAreaRecreationalArea': diningAreaRecreationalFormsMen['formData'] ? diningAreaRecreationalFormsMen['formData'].availabilityOfDustinAndDiningAreaRecreationalArea : null,
        'dustbinSizeInDiningAreaRecreationalArea': this.residentialFormGroup.get('menForm').get('dustbinSizeInDiningAreaRecreationalArea').value,
        'availabilityOfTransportSystem': this.residentialFormGroup.get('menForm').get('availabilityOfTransportSystem').value
        // 'address''addressLine':  this.data.addressForMen   ?  this.data.addressForMen.address1 : null,
        // 'address.addressProof': {
        // 	type: this.data.addressForMen ? this.data.addressForMen.addressProofType : null,
        // 	locationURL: this.data.addressForMen?this.data.addressForMen.addressProof : null
        // }			// 'address.district': facilities.men && facilities.men.address? facilities.men.address.address1 : null,
      }
      value['residentialFacilities']['men']['address']['addressLine'] = this.data.addressForMen ? this.data.addressForMen.address1 : null;
      value['residentialFacilities']['men']['address']['addressProof'] = {
        type: this.data.addressForMen && this.data.addressForMen.addressProofType ? this.data.addressForMen.addressProofType : null,
        locationURL: this.data.addressForMen ? (typeof this.data.addressForMen.addressProof === "string") && (this.data.addressForMen.addressProof != null) ? this.data.addressForMen.addressProof : this.data.addressForMen.addressProof && this.data.addressForMen.addressProof.locationURL : null
      }
      value['residentialFacilities']['men'] = Object.assign(this.userDetails && this.userDetails.residentialFacilities && this.userDetails.residentialFacilities.men ? this.userDetails.residentialFacilities.men : {}, value['residentialFacilities']['men'])
    }
    return value;
  }


  updateDetails(dataToUpdate, value, saveAsDraft?) {
    // let newObj = Object.assign(dataToUpdate);
    if (dataToUpdate.hasOwnProperty('residentialFacilities')) {
      const x = {
        residentialphotos: this.incomingrfdata
      }
      dataToUpdate.residentialFacilities = Object.assign(dataToUpdate.residentialFacilities, x);
    }
    this.navigateTo(value, dataToUpdate.residentialFacilities, saveAsDraft);

    // this.userService.residentialTCUpdate(dataToUpdate).subscribe(res => {

    //   this.tcRegistrationService.setWithProperty(dataToUpdate.residentialFacilities, 'residentialFacilities');
    //   // this.tcRegistrationService.setWithProperty(dataToUpdate.facilities, 'facilities');
    //   // this.tcRegistrationService.setWithProperty(dataToUpdate.general, 'general');
    //   // this.tcRegistrationService.setWithProperty(this.commendationsAndInternationalAffiliations, 'commendationsAndInternationalAffiliations');
    //   // this.tcRegistrationService.setWithProperty(dataToUpdate.trainingCentreFacilities, 'trainingCentreFacilities');
    //   //toastr.success('Facility is updated successfully');
    // });

  }

  // autoSaved() {
  // 	// this.residentialData = this.homePageFormGroup.value;
  // 	this.homePageFormGroup.valueChanges.auditTime(2000).subscribe(formData =>

  // 	{
  // 		console.log(formData)
  // 		this.userService.tcUpdateForm(formData)
  // 		.subscribe(res => {
  // 			console.log(res);

  // 		})
  // 	}

  // 	);

  // 	this.roomFormGroup.valueChanges.auditTime(2000).subscribe(formData =>

  // 		{
  // 			console.log(formData)
  // 			this.userService.tcUpdateForm(formData)
  // 			.subscribe(res => {
  // 				console.log(res);

  // 			})
  // 		}
  // 	)
  // 	this.residentialFormGroup.valueChanges.auditTime(2000).subscribe(formData =>

  // 		{
  // 			console.log(formData)
  // 			this.userService.tcUpdateForm(formData)
  // 			.subscribe(res => {
  // 				console.log(res);

  // 			})
  // 		}

  // 		);



  // }
  setResidentialData(residentialData) {
    this.residentialFacilitiesValidity = this.userService.getResidentialData(this.userDetails && this.userDetails.userName);
    const ObjValidity = Object.assign(this.residentialFacilitiesValidity ? JSON.parse(this.residentialFacilitiesValidity) : {}, residentialData)
    console.log(ObjValidity);
    this.userService.setResidentialData(this.userDetails && this.userDetails.userName, ObjValidity)
  }
  mobilAppContionAndPostDataSaving(data, gender) {
    // const routerUrl = this.router.url;
    const currentURl = this.routingService.getRootURL();
    if (currentURl == 'inspectionagency') {
      this.router.navigate(['/inspectionagency/view-all-appeal-requests'])
    } else if (currentURl=='desktopassessor') {
      this.router.navigate(['/desktopassessor/assessment-requests'])
    } else if (currentURl=='pmkkspoc') {
      this.router.navigate(['/pmkkspoc/assessment-requests'])
    } else if (currentURl == 'qualitycontrol') {
      this.router.navigate(['/qualitycontrol/assessment-requests'])
    }

    // swal({
    // 	// title: 'Registration Fee is INR ' ,
    // 	text: 'Please Complete Mobile App',
    // 	type: 'info',
    // 	showCancelButton: true,
    // 	cancelButtonText: 'Cancel',
    // 	cancelButtonColor: '#d33',
    // }).then((action: any) => {

    // 	// if (action.value) {
    // 	// 	this.userService.tcUpdateDetails(this.jobRole)
    // 	// 		.subscribe(res => {
    // 	// 			if (res) {
    // 	// 				if (environment.functionalities.payments.TCPayment) {
    // 	// 					if (res.tokenId) {
    // 	// 						const tokenId = res.tokenId;
    // 	// 						const redirectUrl = res.redirectUrl;
    // 	// 						this.paymentService.makePaymentDoneRefact(tokenId, redirectUrl);
    // 	// 					}
    // 	// 				} else {
    // 	// 					this.navigateTo();
    // 	// 				}
    // 	// 			} else {

    // 	// 			}
    // 	// 		})
    // 	// }
    // })
    // if (currentURl == 'trainingcentre') {
    //   this.router.navigate(['/trainingcentre/training-of-trainers/tc-edit-caaf/re-request/declaration-payment-residential'])
    // }
    // this.userService.residentialPostSavingForm(data).subscribe(res => {
    // 	if (data[gender].hasOwnProperty('tccompleted') && data[gender]['tccompleted'] == true) {
    // 		if (this.userDetails && this.userDetails['residentialFacilities'] && this.userDetails['residentialFacilities'][gender]) {
    // 			if (JSON.stringify(this.userDetails['residentialFacilities'][gender]) !== JSON.stringify(this.userDetails['residentialFacilities'][gender])) {
    // 				data[gender]['tccompleted'] = false;
    // 				this.canDisplay()
    // 			} else {
    // 				this.router.navigate(['/tc-registration/'])
    // 			}
    // 		}
    // 	} else {
    // 		this.canDisplay()
    // 	}
    // });
  }
  navigateTo(value, residential, saveAsDraft?) {
    //Save As Next Three Condition Navigation
    if (value == 'men' && residential.type.women == true && saveAsDraft !== 'saveAsDraft') {
      this.womenTab.nativeElement.click();
      window.scroll(600, 600);
    } else if (value == 'men' && residential.type.women == false && saveAsDraft !== 'saveAsDraft' && residential.type.transgender == true) {
      this.transgenderTab.nativeElement.click()
      window.scroll(600, 600);
    } else if (value == 'men' && residential.type.women == false && saveAsDraft !== 'saveAsDraft' && residential.type.transgender == false) {
      this.setResidentialData(residential.type);
      this.mobilAppContionAndPostDataSaving(residential, value);
      // this.canDisplay();
      // this.router.navigate(['/tc-registration/'])
      window.scroll(600, 600);
    }
    //Save As Draft
    // else if (value == 'men' && saveAsDraft=='saveAsDraft') {
    // 	toastr.success('Facility is updated successfully');
    // }
    //Save As Next two Condition Navigation
    if (value == 'women' && residential.type.transgender == true && saveAsDraft !== 'saveAsDraft') {
      this.transgenderTab.nativeElement.click()
      window.scroll(600, 600);
    } else if (value == 'women' && residential.type.transgender == false && saveAsDraft !== 'saveAsDraft') {
      this.setResidentialData(residential.type);
      this.mobilAppContionAndPostDataSaving(residential, value);
      // this.canDisplay();
      // this.router.navigate(['/tc-registration/'])
      //Save As Draft
    }
    // else if (value == 'women' && saveAsDraft == 'saveAsDraft') {
    // 	toastr.success('Facility is updated successfully');
    // }
    //Save And
    if (value == 'transgender' && saveAsDraft !== 'saveAsDraft') {
      //this.canDisplay();
      //this.router.navigate(['/tc-registration/'])
      this.setResidentialData(residential.type);
      this.mobilAppContionAndPostDataSaving(residential, value);
      //Save As Draft
    }
    // else if (value == 'transgender' && saveAsDraft == 'saveAsDraft') {
    // 	toastr.success('Facility is updated successfully');
    // }
  }

  isMenValid() {
    const validCheck = this.typeOfResidencialData && this.typeOfResidencialData.type && this.typeOfResidencialData.type.men;
    if (validCheck == true && this.getMenValidity() == true) {
      this.menTab.nativeElement.click();
      return
    }
  }

  isWomenValid() {
    const validCheck = this.typeOfResidencialData && this.typeOfResidencialData.type && this.typeOfResidencialData.type.women;
    if (validCheck == true && this.getWoMenValidity() == true) {
      this.womenTab.nativeElement.click();
      return
    }
  }
  responseMessageFromAlert(event) {
    if (event === 'Ok') {
      this.sweetAlert = undefined;
    } else if (event === 'Cancel') {
      // this.saveData();
      this.sweetAlert = undefined;
    } else {
      this.sweetAlert = undefined;
    }
  }
  // getDropDownData() {
  // 	const getJsonDataUrl = 'assets/tccaaf.json';
  // 	this.apiService.get(getJsonDataUrl).subscribe(
  // 		res => {
  // 			this.selectList = res.tcList;
  // 			let buildingStatusOption = this.selectList.buildingStatus;
  // 			buildingStatusOption = buildingStatusOption.map(op => {
  // 				return {
  // 					name: op, value: op
  // 				};
  // 			});
  // 			Helpers.copyArray(this.dropDownData.buildingStatus, buildingStatusOption);

  // 			let constructionOfBuilding = this.selectList.typeOfConstructionBuilding;
  // 			constructionOfBuilding = constructionOfBuilding.map(op => {
  // 				return {
  // 					name: op, value: op
  // 				};
  // 			});
  // 			Helpers.copyArray(this.dropDownData.typeOfConstructionBuilding, constructionOfBuilding);

  // 			let proximityPublicTransport = this.selectList.proximityToPublicTransport;
  // 			proximityPublicTransport = proximityPublicTransport.map(op => {
  // 				return {
  // 					name: op, value: op
  // 				};
  // 			});
  // 			Helpers.copyArray(this.dropDownData.proximityToPublicTransport, proximityPublicTransport);

  // 			let frontFace = this.selectList.frontFaceBuilding;
  // 			frontFace = frontFace.map(op => {
  // 				return {
  // 					name: op, value: op
  // 				};
  // 			});
  // 			Helpers.copyArray(this.dropDownData.frontFaceBuilding, frontFace);

  // 			let previousState = this.selectList.previousStateOfBuilding;
  // 			previousState = previousState.map(op => {
  // 				return {
  // 					name: op, value: op
  // 				};
  // 			});
  // 			Helpers.copyArray(this.dropDownData.previousStateOfBuilding, previousState);

  // 			let areaClassification = this.selectList.areaClassificationOfTheCentre;
  // 			areaClassification = areaClassification.map(op => {
  // 				return {
  // 					name: op, value: op
  // 				};
  // 			});
  // 			Helpers.copyArray(this.dropDownData.areaClassificationOfTheCentre, areaClassification);
  // 			let availabilityOfInternet = this.selectList.availabilityOfInternet;
  // 			availabilityOfInternet = availabilityOfInternet.map(op => {
  // 				return {
  // 					name: op, value: op
  // 				};
  // 			});
  // 			Helpers.copyArray(this.dropDownData.availabilityOfInternet, availabilityOfInternet);
  // 			let safeDrinkingWater = this.selectList.safeDrinkingWater;
  // 			safeDrinkingWater = safeDrinkingWater.map(op => {
  // 				return {
  // 					name: op, value: op
  // 				};
  // 			});
  // 			Helpers.copyArray(this.dropDownData.safeDrinkingWater, safeDrinkingWater);
  // 			console.log(this.dropDownData.safeDrinkingWater);
  // 			let typeOfCentreFloor = this.selectList.typeOfCentreFloor;
  // 			typeOfCentreFloor = typeOfCentreFloor.map(op => {
  // 				return {
  // 					name: op, value: op
  // 				};
  // 			});
  // 			Helpers.copyArray(this.dropDownData.typeOfCentreFloor, typeOfCentreFloor);
  // 			console.log(this.dropDownData.typeOfCentreFloor);
  // 			let typeOfTrainingCentreWalls = this.selectList.typeOfTrainingCentreWalls;
  // 			typeOfTrainingCentreWalls = typeOfTrainingCentreWalls.map(op => {
  // 				return {
  // 					name: op, value: op
  // 				};
  // 			});
  // 			Helpers.copyArray(this.dropDownData.typeOfTrainingCentreWalls, typeOfTrainingCentreWalls);
  // 			console.log(this.dropDownData.typeOfTrainingCentreWalls);
  // 		},
  // 		err => { }
  // 	);
  // }

  // assignDropDownValues(res) {
  // 	this.basicInfoForm = basicIfo({
  // 		buildingStatus: this.dropDownData.buildingStatus,
  // 		typeOfConstructionBuilding: this.dropDownData.typeOfConstructionBuilding,
  // 		proximityToPublicTransport: this.dropDownData.proximityToPublicTransport,
  // 		frontFaceBuilding: this.dropDownData.frontFaceBuilding,
  // 		previousStateOfBuilding: this.dropDownData.previousStateOfBuilding,
  // 		availabilityOfInternet : this.dropDownData.availabilityOfInternet,
  // 		safeDrinkinWater :  this.dropDownData.safeDrinkingWater,
  // 		typeOfCentreFloor: this.dropDownData.typeOfCentreFloor,
  // 		typeOfTrainingCentreWalls:  this.dropDownData.typeOfTrainingCentreWalls
  // 	}, res, {
  // 			onPowerAdequate: this.onPowerAdequate.bind(this),
  // 			onAdharChange:this.onAdharChange.bind(this),
  // 		buildingStatusChange:this.buildingStatusChange.bind(this)
  // 	});



  // }
  get valid() {
    for (const key in this.validity) {
      // console.log('Men', this.menControl.getInvalidIds());
      // console.log('WoMen', this.womenControl.getInvalidIds());
      // console.log('TransMen',this.transgenderControl.getInvalidIds());
      if (!this.validity[key]) {
        // 	console.log('Key', key);
        // 	console.log('Validity', this.validity);
        // if (this.facityValidity) {
        // 	this.facityValidity['facility'] = false;
        // 	this.tcRegistrationService.setformValidity(this.facityValidity);
        // }

        return false;
      }
    }
		/*if (this.commendationsAndInternationalAffiliations === undefined || this.commendationsAndInternationalAffiliations.length < 0) {
			return false;
		}*/
    // if (this.facityValidity) {
    // 	this.facityValidity['facility'] = true;
    // 	this.tcRegistrationService.setformValidity(this.facityValidity);
    // }
    return true;
  }
  // get validForMen() {
  // 	for (const key in this.validityFormMen) {
  // 		if (!this.validForMen[key]) {
  // 			return false
  // 		}
  // 	}
  // 	return true;
  // }

  // get validForWomen() {
  // 	for (const key in this.validityForWomen) {
  // 		if (!this.validityForWomen[key]) {
  // 			return false
  // 		}
  // 	}
  // 	return true;
  // }

  // get validForTransgender() {
  // 	for (const key in this.validityFormMen) {
  // 		if (!this.validForMen[key]) {
  // 			return false
  // 		}
  // 	}
  // 	return true;
  // }
  checkAddRoom(value) {
    if (value) {
      this.selectedResidential = value;
    }
  }
  addRoom(index?) {
    if (this.roomDetails['doorHeight'] && this.roomDetails['doorWidth']) {
      this.roomDetails['doorHeight'] = Number(this.roomDetails['doorHeight']);
      this.roomDetails['doorWidth'] = Number(this.roomDetails['doorWidth']);
    }
    if (this.selectedResidential == 'Men') {
      this.roomDetails['areaEquippedWith'] = Object.assign(
        this.roomDetails['areaEquippedWith'],
        {
          numberOfCeillingFan: this.roomDetails.numberOfCeillingFan,
          numberOfWallMountedFan: this.roomDetails.numberOfWallMountedFan,
          dustbinSize: this.roomDetails.dustbinSize,
          numberOfbulb: this.roomDetails.numberOfbulb,
          power: this.roomDetails.power,
          numberOfPlugPoint: this.roomDetails.numberOfPlugPoint
        })
      this.roomDetails['cotType'] = this.roomFormGroup.get('cotType').value;
      this.roomDetails['cupBoardType'] = this.roomFormGroup.get('cupBordType').value;
      this.roomDetails['serialNumber'] = uuid();
      if (index !== null && index >= 0) {
        this.menRooms[index] = this.roomDetails;
      } else {
        this.menRooms.push(this.roomDetails);
      }
      //transgenderRooms: true,
      this.validity['menRooms'] = true,
        Helpers.closeModal('addRoomForm');
      this.residentialFormGroup.get('menForm').get('totalArea').patchValue(this.totalAreaCalculations(this.menRooms,
        this.diningAreaFormsMen['formData'] && this.diningAreaFormsMen['formData'].diningArea,
        this.diningAreaRecreationalFormsMen['formData'] && this.diningAreaRecreationalFormsMen['formData'].diningAreaAndRecreationalArea,
        this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfToilet').value,
        this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfBathroom').value,
        this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfToiletCumBathroom').value
      )
      );
      this.residentialFormGroup.get('menForm').get('capacity').patchValue(this.residentialCapacity(this.menRooms))

      this.roomControl.reset();
    } else if (this.selectedResidential == 'Women') {
      this.roomDetails['areaEquippedWith'] = Object.assign(
        this.roomDetails['areaEquippedWith'],
        {
          numberOfCeillingFan: this.roomDetails.numberOfCeillingFan,
          numberOfWallMountedFan: this.roomDetails.numberOfWallMountedFan,
          dustbinSize: this.roomDetails.dustbinSize,
          numberOfbulb: this.roomDetails.numberOfbulb,
          power: this.roomDetails.power,
          numberOfPlugPoint: this.roomDetails.numberOfPlugPoint
        })

      this.roomDetails['cotType'] = this.roomFormGroup.get('cotType').value;
      this.roomDetails['cupBoardType'] = this.roomFormGroup.get('cupBordType').value;
      this.roomDetails['serialNumber'] = uuid();
      if (index !== null && index >= 0) {
        this.womenRooms[index] = this.roomDetails;
      } else {
        this.womenRooms.push(this.roomDetails);
      }
      this.validity['womenRooms'] = true,
        Helpers.closeModal('addRoomForm');
      this.residentialFormGroup.get('womenForm').get('totalArea').patchValue(
        this.totalAreaCalculations(this.womenRooms,
          this.diningAreaFormsWomen['formData'] && this.diningAreaFormsWomen['formData'].diningArea,
          this.diningAreaRecreationalFormsWomen['formData'] && this.diningAreaRecreationalFormsWomen['formData'].diningAreaAndRecreationalArea,
          this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfToilet').value,
          this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfBathroom').value,
          this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfToiletCumBathroom').value
        )
      );
      this.residentialFormGroup.get('womenForm').get('capacity').patchValue(
        this.residentialCapacity(this.womenRooms)
      );
      this.roomControl.reset();
    } else if (this.selectedResidential == 'TransGender') {
      this.roomDetails['areaEquippedWith'] = Object.assign(
        this.roomDetails['areaEquippedWith'],
        {
          numberOfCeillingFan: this.roomDetails.numberOfCeillingFan,
          numberOfWallMountedFan: this.roomDetails.numberOfWallMountedFan,
          dustbinSize: this.roomDetails.dustbinSize,
          numberOfbulb: this.roomDetails.numberOfbulb,
          power: this.roomDetails.power,
          numberOfPlugPoint: this.roomDetails.numberOfPlugPoint
        })
      this.roomDetails['cotType'] = this.roomFormGroup.get('cotType').value;
      this.roomDetails['cupBoardType'] = this.roomFormGroup.get('cupBordType').value;
      this.roomDetails['serialNumber'] = uuid();
      if (index != null && index >= 0) {
        this.transngender[index] = this.roomDetails
      } else {
        this.transngender.push(this.roomDetails)

      }
      // this.transngender.push(this.roomDetails)
      index = null;
      this.residentialFormGroup.get('transgenderForm').get('totalArea').patchValue(
        this.totalAreaCalculations(this.transngender,
          this.diningAreaFormsTransgender['formData'] && this.diningAreaFormsTransgender['formData'].diningArea,
          this.diningAreaRecreationalFormsTransgender['formData'] && this.diningAreaRecreationalFormsTransgender['formData'].diningAreaAndRecreationalArea,
          this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfToilet').value,
          this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfBathroom').value,
          this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfToiletCumBathroom').value
        )
      );
      this.residentialFormGroup.get('transgenderForm').get('capacity').patchValue(
        this.residentialCapacity(this.transngender)
      );
      this.validity['transgenderRooms'] = true;
      this.roomControl.reset();
    }
    if (this.residentialFacilities && this.residentialFacilities.availability == true && this.menRooms.length > 0) {
      this.validity['menRooms'] = true;
    }
    if (this.residentialFacilitiesWomen && this.residentialFacilitiesWomen.availability == true && this.womenRooms.length > 0) {
      this.validity['womenRooms'] = true;
    }
    if (this.residentialFacilitiesTransgender && this.residentialFacilitiesTransgender.availability == true && this.transngender.length > 0) {
      this.validity['transgenderRooms'] = true;
    }
    Helpers.closeModal('addRoomForm');
    this.roomIndex = null;
    this.roomFormGroup.setControl('cupBordType', this.formBuilder.array([this.createcupBordType()]))
    this.roomFormGroup.setControl('cotType', this.formBuilder.array([this.createCotType()]))
  }
  closeModal() {
    //this.selectedResidential = null;
    // this.roomIndex = null;
    // this.roomControl.reset();
    Helpers.closeModal('addRoomForm');
    // this.roomFormGroup.setControl('cupBordType', this.formBuilder.array([this.createcupBordType()]))
    // this.roomFormGroup.setControl('cotType', this.formBuilder.array([this.createCotType()]))

    // Helpers.closeModal('addRoomForm');
  }
  removeRooom(index, value) {
    if (value == 'Men') {
      this.menRooms.splice(index, 1);
      const totalArea = this.totalAreaCalculations(this.menRooms,
        this.diningAreaFormsMen['formData'] && this.diningAreaFormsMen['formData'].diningArea,
        this.diningAreaRecreationalFormsMen['formData'] && this.diningAreaRecreationalFormsMen['formData'].diningAreaAndRecreationalArea,
        this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfToilet').value,
        this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfBathroom').value,
        this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfToiletCumBathroom').value

      );
      this.residentialFormGroup.get('menForm').get('totalArea').patchValue(
        totalArea
      )
      this.residentialFormGroup.get('menForm').get('capacity').patchValue(this.residentialCapacity(this.menRooms))

      this.menControl.patchValues({
        'capacity': this.residentialCapacity(this.menRooms)
      });
    } else if (value == 'Women') {
      this.womenRooms.splice(index, 1)
      this.residentialFormGroup.get('womenForm').get('totalArea').patchValue(
        this.totalAreaCalculations(this.womenRooms,
          this.diningAreaFormsWomen['formData'] && this.diningAreaFormsWomen['formData'].diningArea,
          this.diningAreaRecreationalFormsWomen['formData'] && this.diningAreaRecreationalFormsWomen['formData'].diningAreaAndRecreationalArea,
          this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfToilet').value,
          this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfBathroom').value,
          this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfToiletCumBathroom').value

        ));
      this.residentialFormGroup.get('womenForm').get('capacity').patchValue(this.residentialCapacity(this.womenRooms))

      this.womenControl.patchValues({
        'capacity': this.residentialCapacity(this.womenRooms)
      });
    } else if (value == 'TransGender') {
      this.transngender.splice(index, 1)
      this.residentialFormGroup.get('transgenderForm').get('totalArea').patchValue(
        this.totalAreaCalculations(this.transngender,
          this.diningAreaFormsTransgender['formData'] && this.diningAreaFormsTransgender['formData'].diningArea,
          this.diningAreaRecreationalFormsWomen['formData'] && this.diningAreaRecreationalFormsWomen['formData'].diningAreaAndRecreationalArea,
          this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfToilet').value,
          this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfBathroom').value,
          this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfToiletCumBathroom').value
        )
      );
      this.residentialFormGroup.get('transgenderForm').get('capacity').patchValue(this.residentialCapacity(this.transngender))

      this.transgenderControl.patchValues({
        'capacity': this.residentialCapacity(this.transngender)
      });
    }
    if ((this.typeOfResidencialData && this.typeOfResidencialData.type && this.typeOfResidencialData.type.men == true) && this.menRooms.length <= 0) {
      this.validity['menRooms'] = false;
    }
    if ((this.typeOfResidencialData && this.typeOfResidencialData.type && this.typeOfResidencialData.type.women == true) && this.womenRooms.length <= 0) {
      this.validity['womenRooms'] = false;
    }
    if ((this.typeOfResidencialData && this.typeOfResidencialData.type && this.typeOfResidencialData.type.transgender == true) && this.transngender.length <= 0) {
      this.validity['transgenderRooms'] = false;
    }
  }
  editRooom(index, value) {
    this.roomIndex = index;
    let dataToPatch;
    if (value == 'Men') {
      if (index > -1) {
        dataToPatch = this.menRooms[index]
      }
    } else if (value == 'Women') {
      if (index > -1) {
        dataToPatch = this.womenRooms[index]
      }
    } else if (value == 'TransGender') {
      if (index > -1) {
        dataToPatch = this.transngender[index]
      }
    }
    this.roomControl.patchValues({
      roomArea: dataToPatch.roomArea,
      capacity: dataToPatch.capacity,
      ceilingHeight: dataToPatch.ceilingHeight,
      availabilityOfWindowCrossVentilation: dataToPatch.availabilityOfWindowCrossVentilation,
      availabilityOfDoorAtEntrance: dataToPatch.availabilityOfDoorAtEntrance,
      windowHeight: dataToPatch.windowHeight,
      windowWidth: dataToPatch.windowWidth,
      windowDoorWorkingLocks: dataToPatch.windowDoorWorkingLocks,
      doorWorkingLocks: dataToPatch.doorWorkingLocks,
      doorHeight: Number(dataToPatch.doorHeight),
      doorWidth: Number(dataToPatch.doorWidth),
      availabilityOfAC: dataToPatch.availabilityOfAC,
      numberOfTonsAC: dataToPatch.numberOfTonsAC,
      areaEquippedWith: dataToPatch.areaEquippedWith,
      numberOfbulb: dataToPatch.numberOfbulb || dataToPatch.areaEquippedWith.numberOfbulb,
      numberOfCeillingFan: dataToPatch.numberOfCeillingFan || dataToPatch.areaEquippedWith.numberOfCeillingFan,
      numberOfWallMountedFan: dataToPatch.numberOfWallMountedFan,
      dustbinSize: dataToPatch.dustbinSize || dataToPatch.areaEquippedWith.dustbinSize,
      numberOfPlugPoint: dataToPatch.numberOfPlugPoint || dataToPatch.areaEquippedWith.numberOfPlugPoint
    });
    this.roomFormGroup.setControl('cotType', this.formBuilder.array([]));
    if (dataToPatch && dataToPatch.cotType && dataToPatch.cotType.length > 0) {
      dataToPatch.cotType.forEach((cotTy, index) => {
        this.addCotDetails(cotTy);
        this.roomFormGroup.get('cotType')['controls'][index].setControl('cotDetails', this.formBuilder.array([]));
        let cotDetails = <FormArray>this.roomFormGroup.get('cotType')['controls'][index].get('cotDetails');
        for (let i = 0; i < cotTy.cotDetails.length; i++) {
          cotDetails.push(this.createCotDetails(cotTy.cotDetails[i]));
        }
      })
    }
    this.roomFormGroup.setControl('cupBordType', this.formBuilder.array([]));
    if (dataToPatch && dataToPatch.cupBoardType && dataToPatch.cupBoardType.length > 0) {
      dataToPatch.cupBoardType.forEach((cupBoardTy, index) => {
        this.addCupBoard(cupBoardTy);
      })
    }

  }
  // setSerialNumber(index,gender) {
  // 	if (gender == 'Male') {
  // 		if (this.menRooms[index]) {
  // 			index = index + 1;
  // 			this.menRooms[index].serialNumber = 'Room_' + (index);
  // 		}
  // 	} else if (gender == 'Female') {
  // 		if (this.womenRooms[index]) {
  // 			index = index + 1;
  // 			this.womenRooms[index].serialNumber = 'Room_' + (index);
  // 		}
  // 	} else if (gender == 'Transgender') {
  // 		if (this.transngender[index]) {
  // 			index = index + 1;
  // 			this.transngender[index].serialNumber = 'Room_' + (index);
  // 		}

  // 	}
  // 	return 'Room_' + (index);
  // }
  onPowerAdequate(value) {
    if (!value.adequatePowerBackup) {
      this.basicFormControl.hideFields(['adequatePowerBackupUrl'], true);
    } else {
      this.basicFormControl.hideFields(['adequatePowerBackupUrl'], false);
    }

  }
  next(value) {
    const men = 'men';
    if (value == men) {
      this.womenTab.nativeElement.click();
      window.scroll(600, 600)
    } else {
      this.transgenderTab.nativeElement.click();
    }
  }
  onCCTVChange(value) {
    if (value.hasOwnProperty('cctvMen') && value.cctvMen == false) {
      this.menControl.hideFields(['cctvCameraDocumentUrl'], true);
    } else if (value.hasOwnProperty('cctvMen') && value.cctvMen == true) {
      this.menControl.hideFields(['cctvCameraDocumentUrl'], false);
    }
    if (value.hasOwnProperty('cctvWomen') && value.cctvWomen == false) {
      this.womenControl.hideFields(['cctvCameraDocumentUrl'], true);
    } else if (value.hasOwnProperty('cctvWomen') && value.cctvWomen == true) {
      this.womenControl.hideFields(['cctvCameraDocumentUrl'], false);
    }
    if (value.hasOwnProperty('cctvTransgender') && value.cctvTransgender == false) {
      this.transgenderControl.hideFields(['cctvCameraDocumentUrl'], true);
    } else if (value.hasOwnProperty('cctvTransgender') && value.cctvTransgender == true) {
      this.transgenderControl.hideFields(['cctvCameraDocumentUrl'], false);
    }
  }
  buildingStatusChange(value) {
    if (value == 'Industry premises with MoU') {
      this.basicFormControl.hideFields(['buildingStatusDocumnet'], false)
    } else {
      this.basicFormControl.hideFields(['buildingStatusDocumnet'], true)
    }
  }
  liftChange(value) {
    if (value.liftIncaseOfFloors == true) {
      this.facilityControl.hideFields(['differentlyAbledUrl'], false);
    } else {
      this.facilityControl.hideFields(['differentlyAbledUrl'], true);
    }
  }
  // houseKeepingStaffChange(value) {
  // 	if(value.dedicatedHouseKeepingStaff ==true){
  // 		this.facilityControl.hideFields(['houseKeepingStaffType','houseKeppingStaffUrl'],false);
  // 	} else {
  // 		this.facilityControl.hideFields(['houseKeepingStaffType','houseKeppingStaffUrl'],true);
  // 	}
  // }

  availabilityOfWindowChange(value) {
    this.roomControl.hideFields(['windowDoorWorkingLocks', 'windowHeight', 'windowWidth'], value == false ? true : false)

  }
  availabilityOfDoorChange(value) {
    this.roomControl.hideFields(['doorWorkingLocks', 'doorWidth', 'doorHeight'], value == false ? true : false)
  }
  availabilityOfAC(value) {
    this.roomControl.disableFields(['numberOfTonsAC'], value == false ? true : false)
  }
  areaEquippedWithRoomChange(value) {
    if (value.cot == true) {
      const cotType = <FormArray>this.roomFormGroup.get('cotType');
      cotType.push(this.createCotType());
    }
    this.roomControl.hideFields(['cotSize', 'frameOfCot'], value.cot == false ? true : false);
    this.roomControl.hideFields(['matressType', 'matressSize'], value.matress == false ? true : false);
    this.roomControl.hideFields(['noOfTrunk'], value.trunkWithLock == false ? true : false);
    this.roomControl.hideFields(['numberOfCupboardAndAlmirah'], value.cupboardLockingArrangement == false ? true : false);
    this.roomControl.hideFields(['power'], value.ledCFLIncandentLight == false ? true : false);
    this.roomControl.hideFields(['numberOfbulb'], value.ledCFLIncandentLight == false ? true : false);
    this.roomControl.hideFields(['numberOfCeillingFan'], value.ceilingFan == false ? true : false);
    this.roomControl.hideFields(['numberOfPlugPoint'], value.plugPoint == false ? true : false);
    this.roomControl.hideFields(['numberOfWallMountedFan'], value.wallMountedFan == false ? true : false);
    this.roomControl.hideFields(['dustbinSize'], value.dustbin == false ? true : false);
    let roomArea;

    if (value.ledCFLIncandentLight) {
      this.roomAreaChange(this.roomDetails && this.roomDetails.roomArea);
      this.roomControl.makeFieldsReadOnly(['numberOfbulb'], true);
      // if (this.roomDetails &&this.roomDetails.roomArea>=70 ) {
      // 	roomArea	= this.roomDetails.roomArea / 70;
      // }
      // this.roomControl.patchValues({numberOfbulb:Math.trunc(roomArea)})
    }

  }
  // createFormGroupObject(formElements: any[]) {
  // 	const group = {};
  // 	for (const formElement of formElements) {
  // 		const validations = DFormHelpers.createValidations(
  // 			formElement,
  // 			// this.formElement.disabled
  // 		);
  // 		group[formElement.name] = [null, validations];
  // 	}
  // 	return group;
  // }
  // private _createFormGroup(formElements: any[]) {
  // 	const group = this.createFormGroupObject(formElements);
  // 	return this.formBuilder.group(group);
  // }
  menToiletChange(value) {
    // this.residentialFacilitiesForm.forms[0].formElements.push({ Number: { formGroup: this._createFormGroup([{ temp: {} };
    this.infraFormMen['control'].hideFields(['countOfToilet'], value == true ? false : true)
    if (value == false) {
      this.setControls(this.residentialFormGroup, 'menForm', 'areaOfToilet');
      this.residentialFormGroup.get('menForm').get('totalArea').patchValue(
        this.totalAreaCalculations(this.menRooms,
          this.diningAreaFormsMen['formData'] && this.diningAreaFormsMen['formData'].diningArea,
          this.diningAreaRecreationalFormsMen && this.diningAreaRecreationalFormsMen['formData'].diningAreaAndRecreationalArea,
          0,
          this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfBathroom').value,
          this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfToiletCumBathroom').value
        )
      );
    }
    // else {
    // 	this.setControls(this.residentialFormGroup,'menForm','areaOfToilet');
    // 	this.addAreaOfToiletMen(this.infraFormMen['formData'].countOfToilet,undefined,'areaOfToilet','menForm');
    // }
  }
  setControls(formGroup, fromGroupName, formControlName) {
    formGroup.get(fromGroupName).setControl(formControlName, this.formBuilder.array([]))
  }
  menBathRoomChange(value) {
    this.infraFormMen['control'].hideFields(['countOfBathroom'], value == true ? false : true)
    if (value == false) {
      this.setControls(this.residentialFormGroup, 'menForm', 'areaOfBathroom');
      this.residentialFormGroup.get('menForm').get('totalArea').patchValue(
        this.totalAreaCalculations(this.menRooms,
          this.diningAreaFormsMen['formData'] && this.diningAreaFormsMen['formData'].diningArea,
          this.diningAreaRecreationalFormsMen && this.diningAreaRecreationalFormsMen['formData'].diningAreaAndRecreationalArea,
          this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfToilet').value,
          0,
          this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfToiletCumBathroom').value
        )
      );
    }
  }
  menBathRoomCumToilet(value) {
    this.infraFormMen['control'].hideFields(['countOfBathroomCumToilet'], value == true ? false : true)
    if (value == false) {
      this.setControls(this.residentialFormGroup, 'menForm', 'areaOfToiletCumBathroom');
      this.residentialFormGroup.get('menForm').get('totalArea').patchValue(
        this.totalAreaCalculations(this.menRooms,
          this.diningAreaFormsMen['formData'] && this.diningAreaFormsMen['formData'].diningArea,
          this.diningAreaRecreationalFormsMen['formData'] && this.diningAreaRecreationalFormsMen['formData'].diningAreaAndRecreationalArea,
          this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfToilet').value,
          this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfBathroom').value,
          0
        )
      );
    }

  }
  menCleanlinessChange(value) {
    // this.menControl.hideFields(['houseKeepingStaffType', 'houseKeppingStaffUrl'], value.dedicatedHouseKeepingStaff == true ? false : true)
    this.menControl.hideFields(['countOfDustbin'], value.dustbin == false ? true : false)
    if (value.dustbin == false) {
      this.setControls(this.residentialFormGroup, 'menForm', 'dustbinSize');
    }
    this.menControl.hideFields(['cleanAndSafeDrinkingWater'], value.drinkingWater == false ? true : false)
  }
  menAvailabilityOfFirstAidKit(value) {
    this.menControl.hideFields(['equippedWith'], value == true ? false : true)
    if (value == true) {
      // this.menControl.patchValues({equippedWith:{emergencyTelephoneNumber:true,sterileGauzePadsAvailability:true,
      // 	disinfectantslikeDettolSavlon:true,medicinesLikePainKiller:true,rollerBandages:true,adhesiveBandages:true,
      // 	scissorsAndTweezers:true,antisepticWipesOrSoap:true,thermometer:true,doctor:true}})
    }
  }
  menavailabilityOfFireFightingEquipment(value) {
    this.menControl.hideFields(['fireFightingEquipedWith'], value == true ? false : true)
  }
  menbiometricChange(value) {
    // this.menControl.hideFields(['biometricAttendanceSystemURL'],value.aebs==true?false:true)
  }
  menavailabilityOfDiningAreaChange(value) {
    this.diningAreaFormsMen['control'].hideFields(['diningArea', 'availabilityOfDustinAndDiningArea',
      'numberOfCeilingFanDiningArea', 'availabilityOfWallMountedFanDiningArea', 'availabilityOfCeilingFanDiningArea',
      'numberOfWallMountedDiningArea', 'availabilityOfBulbDiningArea', 'numberOfBulbDiningArea',
      'availabilityOfDustinAndDiningArea', 'dustbinSizeInDiningArea', 'diningAreaAndRecreationalArea'], value == true ? false : true)
    if (value == false) {
      this.residentialFormGroup.get('menForm').get('totalArea').patchValue(
        this.totalAreaCalculations(this.menRooms,
          0,
          this.diningAreaRecreationalFormsMen && this.diningAreaRecreationalFormsMen['formData'].diningAreaAndRecreationalArea,
          this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfToilet').value,
          this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfBathroom').value,
          this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfToiletCumBathroom').value
        )
      );
    }
    //this.calculateBulbValidation(value, this.diningAreaFormsMen, 'diningArea', 'numberOfBulbDiningArea');

    // this.residentialFormGroup.get('womenForm').get('totalArea').patchValue(
    // 	this.totalAreaCalculations(this.womenRooms,
    // 		this.residentialFacilitiesWomen && this.residentialFacilitiesWomen.diningArea,
    // 		this.residentialFacilitiesWomen && this.residentialFacilitiesWomen.diningAreaAndRecreationalArea,
    // 		this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfToilet').value,
    // 		this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfBathroom').value,
    // 		this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfToiletCumBathroom').value
    // 	)
    // )
    // this.diningAreaFormsMen['control'].hideFields(['diningArea'],value==true?false:true),
    // this.diningAreaFormsMen['control'].hideFields(['availabilityOfDustinAndDiningArea'], value == true ? false : true)
    // this.diningAreaFormsMen['control'].hideFields(['numberOfCeilingFanDiningArea'], value == true ? false : true)
    // this.diningAreaFormsMen['control'].hideFields(['availabilityOfWallMountedFanDiningArea'], value == true ? false : true)
    // this.diningAreaFormsMen['control'].hideFields(['numberOfWallMountedDiningArea'], value == true ? false : true)
    // this.diningAreaFormsMen['control'].hideFields(['availabilityOfBulbDiningArea'], value == true ? false : true)
    // this.diningAreaFormsMen['control'].hideFields(['numberOfBulbDiningArea'], value == true ? false : true)
    // this.diningAreaFormsMen['control'].hideFields(['availabilityOfDustinAndDiningArea'], value == true ? false : true)
    // this.diningAreaFormsMen['control'].hideFields(['dustbinSizeInDiningArea'], value == true ? false : true)
  }
  menavailabilityOfDiningAreaAndRecreationalArea(value) {
    // this.diningAreaRecreationalFormsMen['control'].hideFields(['availabilityOfDustinAndDiningAreaRecreationalArea'],value==true?false:true)
    // this.diningAreaRecreationalFormsMen['control'].hideFields(['diningAreaAndRecreationalArea'],value==true?false:true)
    // this.diningAreaRecreationalFormsMen['control'].hideFields(['countOfdustbinSizeInDiningAreaRecreationalArea'],value==true?false:true)
    this.diningAreaRecreationalFormsMen['control'].hideFields(['availabilityOfDustinAndDiningAreaRecreationalArea',
      'diningAreaAndRecreationalArea', 'countOfdustbinSizeInDiningAreaRecreationalArea', 'numberOfBulbDiningAreaRecreationalArea',
      'countOfdustbinSizeInDiningAreaRecreationalArea', 'availabilityOfBulbDiningAreaRecreationalArea',
      'numberOfMountedFanDiningRecreationalArea', 'availabilityOfWallMountedFanDiningRecreationalArea',
      'availabilityOfCeilingFanDiningRecreationArea', 'numberOfCeilingDiningRecreationArea'], value == true ? false : true)
    if (value == false) {
      this.residentialFormGroup.get('menForm').get('totalArea').patchValue(
        this.totalAreaCalculations(this.menRooms,
          this.diningAreaFormsMen['formData'] && this.diningAreaFormsMen['formData'].diningArea,
          0,
          this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfToilet').value,
          this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfBathroom').value,
          this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfToiletCumBathroom').value
        )
      );
      this.setControls(this.residentialFormGroup, 'menForm', 'dustbinSizeInDiningAreaRecreationalArea');

    }
  }
  menAvailabilityOfDustbinInDiningAreaRecreationalArea(value) {
    this.diningAreaRecreationalFormsMen['control'].hideFields(['countOfdustbinSizeInDiningAreaRecreationalArea'], value == true ? false : true)
    if (value == false) {
      this.setControls(this.residentialFormGroup, 'menForm', 'dustbinSizeInDiningAreaRecreationalArea');
    }
  }
  menmealsChange(value) {
    if (value == 'Lunch/Dinner') {
      let lunch = [{ name: 'Dal/Sambhar/Rasam', value: 'Dal/Sambhar/Rasam' }, { name: 'Seasonal Vegetable', value: 'Seasonal Vegetable' }, { name: 'Rice/pulao', value: 'Rice/pulao' }, { name: 'Chappaties/Parathas/Puries', value: 'Chappaties/Parathas/Puries' }]
      lunch = lunch.map(d => {
        d.value = d.name;
        return d;
      });
      //this.menuListMen = [];
      this.copyArray(this.menuListMen, lunch);
      // this.menuListMen =['Dal/Sambhar/Rasam','Seasonal Vegetable','Rice/pulao','Chappaties/Parathas/Puries']
    } else if (value == 'Breakfast') {
      let Breakfast = [{ name: 'Continental as well as Indian foods', value: 'Continental as well as Indian foods' }, { name: 'Tea/Coffee/Milk/Curd or any other milk product', value: 'Tea/Coffee/Milk/Curd or any other milk product' }]
      Breakfast = Breakfast.map(d => {
        d.value = d.name;
        return d;
      });
      //this.menuListMen = [];
      this.copyArray(this.menuListMen, Breakfast);
    }
    this.menControl.hideFields(['foodMenu'], value === 'Evening Snacks/Tea' ? true : false);

  }

  womenToiletChange(value) {
    this.infraFormWomen['control'].hideFields(['countOfToilet'], value == true ? false : true)
    if (value == false) {
      this.residentialFormGroup.get('womenForm').get('totalArea').patchValue(
        this.totalAreaCalculations(this.womenRooms,
          this.residentialFacilitiesWomen && this.residentialFacilitiesWomen.diningArea,
          this.residentialFacilitiesWomen && this.residentialFacilitiesWomen.diningAreaAndRecreationalArea,
          this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfToilet').value,
          this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfBathroom').value,
          this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfToiletCumBathroom').value
        )
      )
      this.setControls(this.residentialFormGroup, 'womenForm', 'areaOfToilet');
    }
  }
  womenBathRoomChange(value) {
    this.infraFormWomen['control'].hideFields(['countOfBathroom'], value == true ? false : true)
    if (value == false) {
      this.setControls(this.residentialFormGroup, 'womenForm', 'areaOfBathroom');
      this.residentialFormGroup.get('womenForm').get('totalArea').patchValue(
        this.totalAreaCalculations(this.womenRooms,
          this.residentialFacilitiesWomen && this.residentialFacilitiesWomen.diningArea,
          this.residentialFacilitiesWomen && this.residentialFacilitiesWomen.diningAreaAndRecreationalArea,
          this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfToilet').value,
          0,
          this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfToiletCumBathroom').value
        )
      )
    }
  }
  womenBathRoomCumToilet(value) {
    this.infraFormWomen['control'].hideFields(['countOfBathroomCumToilet'], value == true ? false : true)
    if (value == false) {
      this.setControls(this.residentialFormGroup, 'womenForm', 'areaOfToiletCumBathroom');
      this.residentialFormGroup.get('womenForm').get('totalArea').patchValue(
        this.totalAreaCalculations(this.womenRooms,
          this.residentialFacilitiesWomen && this.residentialFacilitiesWomen.diningArea,
          this.residentialFacilitiesWomen && this.residentialFacilitiesWomen.diningAreaAndRecreationalArea,
          this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfToilet').value,
          this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfBathroom').value,
          0
        )
      )
    }
  }
  womenCleanlinessChange(value) {
    // this.womenControl.hideFields(['houseKeepingStaffType', 'houseKeppingStaffUrl'], value.dedicatedHouseKeepingStaff == true ? false : true)
    this.womenControl.hideFields(['countOfDustbin'], value.dustbin == false ? true : false)
    if (value == false) {
      this.setControls(this.residentialFormGroup, 'womenForm', 'dustbinSize');
    }
    this.womenControl.hideFields(['cleanAndSafeDrinkingWater'], value.drinkingWater == false ? true : false)
  }
  womenAvailabilityOfFirstAidKit(value) {
    this.womenControl.hideFields(['equippedWith'], value == true ? false : true)
  }
  womenavailabilityOfFireFightingEquipment(value) {
    this.womenControl.hideFields(['fireFightingEquipedWith'], value == true ? false : true)
  }
  womenbiometricChange(value) {
    // this.womenControl.hideFields(['biometricAttendanceSystemURL'],value.aebs==true?false:true)
  }
  // menisMedicalContactChange(value) {
  // 	this.menControl.hideFields(['medicalContactNumber'],value==true?false:true)
  // }
  // womenisMedicalContactChange(value) {
  // 	this.womenControl.hideFields(['medicalContactNumber'],value==true?false:true)
  // }
  // transgenderisMedicalContactChange(value) {
  // 	this.transgenderControl.hideFields(['medicalContactNumber'],value==true?false:true)
  // }
  womenavailabilityOfDiningAreaChange(value) {
    this.diningAreaFormsWomen['control'].hideFields(['diningArea', 'availabilityOfDustinAndDiningArea',
      'numberOfCeilingFanDiningArea', 'availabilityOfWallMountedFanDiningArea',
      'numberOfWallMountedDiningArea', 'availabilityOfBulbDiningArea', 'numberOfBulbDiningArea',
      'availabilityOfDustinAndDiningArea', 'dustbinSizeInDiningArea', 'availabilityOfCeilingFanDiningArea', 'diningAreaAndRecreationalArea'], value == true ? false : true)
    if (value == false) {
      this.residentialFormGroup.get('womenForm').get('totalArea').patchValue(
        this.totalAreaCalculations(this.womenRooms,
          0,
          this.residentialFacilitiesWomen && this.residentialFacilitiesWomen.diningAreaAndRecreationalArea,
          this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfToilet').value,
          this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfBathroom').value,
          this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfToiletCumBathroom').value
        )
      )
    }
    //this.calculateBulbValidation(value,this.diningAreaFormsWomen,'diningArea','numberOfBulbDiningArea');
    // this.diningAreaFormsWomen['control'].hideFields(['diningArea'], value == true ? false : true)
    // this.diningAreaFormsWomen['control'].hideFields(['availabilityOfDustinAndDiningArea'],value==true?false:true)
    // this.diningAreaFormsWomen['control'].hideFields(['numberOfCeilingFanDiningArea'],value==true?false:true)
    // this.diningAreaFormsWomen['control'].hideFields(['availabilityOfWallMountedFanDiningArea'],value==true?false:true)
    // this.diningAreaFormsWomen['control'].hideFields(['numberOfWallMountedDiningArea'],value==true?false:true)
    // this.diningAreaFormsWomen['control'].hideFields(['availabilityOfBulbDiningArea'],value==true?false:true)
    // this.diningAreaFormsWomen['control'].hideFields(['numberOfBulbDiningArea'], value == true ? false : true)
    // this.diningAreaFormsWomen['control'].hideFields(['availabilityOfDustinAndDiningArea'],value==true?false:true)
    // this.diningAreaFormsWomen['control'].hideFields(['dustbinSizeInDiningArea'],value==true?false:true)
  }
  womenavailabilityOfDiningAreaAndRecreationalArea(value) {
    // this.diningAreaRecreationalFormsWomen['control'].hideFields(['availabilityOfDustinAndDiningAreaRecreationalArea'], value == true ? false : true)
    // this.diningAreaRecreationalFormsWomen['control'].hideFields(['diningAreaAndRecreationalArea'],value==true?false:true)
    // this.diningAreaRecreationalFormsWomen['control'].hideFields(['countOfdustbinSizeInDiningAreaRecreationalArea'],value==true?false:true)
    this.diningAreaRecreationalFormsWomen['control'].hideFields(['availabilityOfDustinAndDiningAreaRecreationalArea',
      'diningAreaAndRecreationalArea', 'countOfdustbinSizeInDiningAreaRecreationalArea', 'numberOfBulbDiningAreaRecreationalArea',
      'countOfdustbinSizeInDiningAreaRecreationalArea', 'availabilityOfBulbDiningAreaRecreationalArea',
      'numberOfMountedFanDiningRecreationalArea', 'availabilityOfWallMountedFanDiningRecreationalArea',
      'availabilityOfCeilingFanDiningRecreationArea', 'numberOfCeilingDiningRecreationArea'], value == true ? false : true)
    if (value == false) {
      this.residentialFormGroup.get('womenForm').get('totalArea').patchValue(
        this.totalAreaCalculations(this.womenRooms,
          this.residentialFacilitiesWomen && this.residentialFacilitiesWomen.diningArea,
          0,
          this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfToilet').value,
          this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfBathroom').value,
          this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfToiletCumBathroom').value
        )
      )
      this.setControls(this.residentialFormGroup, 'womenForm', 'dustbinSizeInDiningAreaRecreationalArea');
    }
  }
  womenAvailabilityOfDustbinInDiningAreaRecreationalArea(value) {
    this.diningAreaRecreationalFormsWomen['control'].hideFields(['countOfdustbinSizeInDiningAreaRecreationalArea'], value == true ? false : true)
    if (value == false) {
      this.setControls(this.residentialFormGroup, 'womenForm', 'dustbinSizeInDiningAreaRecreationalArea');
    }
  }
  womenmealsChange(value) {
    if (value == 'Lunch/Dinner') {
      let lunch = [{ name: 'Dal/Sambhar/Rasam', value: 'Dal/Sambhar/Rasam' }, { name: 'Seasonal Vegetable', value: 'Seasonal Vegetable' }, { name: 'Rice/pulao', value: 'Rice/pulao' }, { name: 'Chappaties/Parathas/Puries', value: 'Chappaties/Parathas/Puries' }]
      lunch = lunch.map(d => {
        d.value = d.name;
        return d;
      });
      //this.menuListMen = [];
      this.copyArray(this.menuListWoMen, lunch);
      // this.menuListMen =['Dal/Sambhar/Rasam','Seasonal Vegetable','Rice/pulao','Chappaties/Parathas/Puries']
    } else if (value == 'Breakfast') {
      let Breakfast = [{ name: 'Continental as well as Indian foods', value: 'Continental as well as Indian foods' }, { name: 'Tea/Coffee/Milk/Curd or any other milk product', value: 'Tea/Coffee/Milk/Curd or any other milk product' }]
      Breakfast = Breakfast.map(d => {
        d.value = d.name;
        return d;
      });
      //this.menuListMen = [];
      this.copyArray(this.menuListWoMen, Breakfast);
    }
    this.womenControl.hideFields(['foodMenu'], value ? false : true)
  }
  transgenderToiletChange(value) {
    this.infraFormTransgender['control'].hideFields(['countOfToilet'], value == true ? false : true)
    if (value == false) {
      this.residentialFormGroup.get('transgenderForm').get('totalArea').patchValue(
        this.totalAreaCalculations(this.transngender,
          this.residentialFacilitiesTransgender && this.residentialFacilitiesTransgender.diningArea,
          this.residentialFacilitiesTransgender && this.residentialFacilitiesTransgender.diningAreaAndRecreationalArea,
          0,
          this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfBathroom').value,
          this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfToiletCumBathroom').value
        )
      )
      this.setControls(this.residentialFormGroup, 'transgenderForm', 'areaOfToilet');
    }
  }
  transgenderBathRoomChange(value) {
    this.infraFormTransgender['control'].hideFields(['countOfBathroom'], value == true ? false : true)
    if (value == false) {
      this.setControls(this.residentialFormGroup, 'transgenderForm', 'areaOfBathroom');
      this.residentialFormGroup.get('transgenderForm').get('totalArea').patchValue(
        this.totalAreaCalculations(this.transngender,
          this.residentialFacilitiesTransgender && this.residentialFacilitiesTransgender.diningArea,
          this.residentialFacilitiesTransgender && this.residentialFacilitiesTransgender.diningAreaAndRecreationalArea,
          this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfToilet').value,
          0,
          this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfToiletCumBathroom').value
        )
      )
    }
  }
  transgenderBathRoomCumToilet(value) {
    this.infraFormTransgender['control'].hideFields(['countOfBathroomCumToilet'], value == true ? false : true)
    if (value == false) {
      this.setControls(this.residentialFormGroup, 'transgenderForm', 'areaOfToiletCumBathroom');
      this.residentialFormGroup.get('transgenderForm').get('totalArea').patchValue(
        this.totalAreaCalculations(this.transngender,
          this.residentialFacilitiesTransgender && this.residentialFacilitiesTransgender.diningArea,
          this.residentialFacilitiesTransgender && this.residentialFacilitiesTransgender.diningAreaAndRecreationalArea,
          this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfToilet').value,
          this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfBathroom').value,
          0
        )
      )
    }
  }
  transgenderCleanlinessChange(value) {
    // this.transgenderControl.hideFields(['houseKeepingStaffType', 'houseKeppingStaffUrl'], value.dedicatedHouseKeepingStaff == true ? false : true)
    this.transgenderControl.hideFields(['countOfDustbin'], value.dustbin == false ? true : false)
    if (value == false) {
      this.setControls(this.residentialFormGroup, 'transgenderForm', 'dustbinSize');

    }
    this.transgenderControl.hideFields(['cleanAndSafeDrinkingWater'], value.drinkingWater == false ? true : false)
  }
  transgenderAvailabilityOfFirstAidKit(value) {
    this.transgenderControl.hideFields(['equippedWith'], value == true ? false : true)

  }
  transgenderavailabilityOfFireFightingEquipment(value) {
    this.transgenderControl.hideFields(['fireFightingEquipedWith'], value == true ? false : true)

  }
  transgenderbiometricChange(value) {
    // this.transgenderControl.hideFields(['biometricAttendanceSystemURL'],value.aebs==true?false:true)

  }
  transgenderavailabilityOfDiningAreaChange(value) {
    this.diningAreaFormsTransgender['control'].hideFields(['diningArea', 'availabilityOfDustinAndDiningArea',
      'numberOfCeilingFanDiningArea', 'availabilityOfWallMountedFanDiningArea',
      'numberOfWallMountedDiningArea', 'availabilityOfBulbDiningArea', 'numberOfBulbDiningArea',
      'availabilityOfDustinAndDiningArea', 'dustbinSizeInDiningArea', 'availabilityOfCeilingFanDiningArea', 'diningAreaAndRecreationalArea'], value == true ? false : true)
    if (value == false) {
      this.residentialFormGroup.get('transgenderForm').get('totalArea').patchValue(
        this.totalAreaCalculations(this.transngender,
          0,
          this.residentialFacilitiesTransgender && this.residentialFacilitiesTransgender.diningAreaAndRecreationalArea,
          this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfToilet').value,
          this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfBathroom').value,
          this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfToiletCumBathroom').value
        )
      )
    }
    //this.calculateBulbValidation(value,this.diningAreaFormsTransgender,'diningArea','numberOfBulbDiningArea');

    // this.diningAreaFormsTransgender['control'].hideFields(['availabilityOfDustinAndDiningArea'],value==true?false:true)
    // this.diningAreaFormsTransgender['control'].hideFields(['numberOfCeilingFanDiningArea'], value == true ? false : true)
    // this.diningAreaFormsTransgender['control'].hideFields(['availabilityOfWallMountedFanDiningArea'],value==true?false:true)
    // this.diningAreaFormsTransgender['control'].hideFields(['numberOfWallMountedDiningArea'], value == true ? false : true)
    // this.diningAreaFormsTransgender['control'].hideFields(['availabilityOfBulbDiningArea'],value==true?false:true)
    // this.diningAreaFormsTransgender['control'].hideFields(['numberOfBulbDiningArea'],value==true?false:true)
    // this.diningAreaFormsTransgender['control'].hideFields(['availabilityOfDustinAndDiningArea'], value == true ? false : true)
    // this.diningAreaFormsTransgender['control'].hideFields(['dustbinSizeInDiningArea'],value==true?false:true)
  }
  transgenderavailabilityOfDiningAreaAndRecreationalArea(value) {
    this.diningAreaRecreationalFormsTransgender['control'].hideFields(['availabilityOfDustinAndDiningAreaRecreationalArea',
      'diningAreaAndRecreationalArea', 'countOfdustbinSizeInDiningAreaRecreationalArea', 'numberOfBulbDiningAreaRecreationalArea',
      'countOfdustbinSizeInDiningAreaRecreationalArea', 'availabilityOfBulbDiningAreaRecreationalArea',
      'numberOfMountedFanDiningRecreationalArea', 'availabilityOfWallMountedFanDiningRecreationalArea',
      'availabilityOfCeilingFanDiningRecreationArea', 'numberOfCeilingDiningRecreationArea'], value == true ? false : true)
    if (value == false) {
      this.residentialFormGroup.get('transgenderForm').get('totalArea').patchValue(
        this.totalAreaCalculations(this.transngender,
          this.residentialFacilitiesTransgender && this.residentialFacilitiesTransgender.diningArea,
          0,
          this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfToilet').value,
          this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfBathroom').value,
          this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfToiletCumBathroom').value
        )
      )
      this.setControls(this.residentialFormGroup, 'transgenderForm', 'dustbinSizeInDiningAreaRecreationalArea');
    }
    // this.diningAreaRecreationalFormsTransgender['control'].hideFields(['availabilityOfDustinAndDiningAreaRecreationalArea'],value==true?false:true)
    // this.diningAreaRecreationalFormsTransgender['control'].hideFields(['diningAreaAndRecreationalArea'],value==true?false:true)
    // this.diningAreaRecreationalFormsTransgender['control'].hideFields(['countOfdustbinSizeInDiningAreaRecreationalArea'],value==true?false:true)
  }
  transgendermealsChange(value) {
    if (value == 'Lunch/Dinner') {
      let lunch = [{ name: 'Dal/Sambhar/Rasam', value: 'Dal/Sambhar/Rasam' }, { name: 'Seasonal Vegetable', value: 'Seasonal Vegetable' }, { name: 'Rice/pulao', value: 'Rice/pulao' }, { name: 'Chappaties/Parathas/Puries', value: 'Chappaties/Parathas/Puries' }]
      lunch = lunch.map(d => {
        d.value = d.name;
        return d;
      });
      //this.menuListMen = [];
      this.copyArray(this.menuListTransgender, lunch);
      // this.menuListMen =['Dal/Sambhar/Rasam','Seasonal Vegetable','Rice/pulao','Chappaties/Parathas/Puries']
    } else if (value == 'Breakfast') {
      let Breakfast = [{ name: 'Continental as well as Indian foods', value: 'Continental as well as Indian foods' }, { name: 'Tea/Coffee/Milk/Curd or any other milk product', value: 'Tea/Coffee/Milk/Curd or any other milk product' }]
      Breakfast = Breakfast.map(d => {
        d.value = d.name;
        return d;
      });
      //this.menuListMen = [];
      this.copyArray(this.menuListTransgender, Breakfast);
    }
    this.transgenderControl.hideFields(['foodMenu'], value ? false : true)

  }

  copyArray(arr1, arr2) {
    Helpers.copyArray(arr1, arr2);
  }
  roomAreaChange(value) {
    let roomArea;
    let numberOFBulb;
    if (value >= 70) {
      roomArea = value / 35;
    }
    if (value == 70) {
      numberOFBulb = 1;
    } else if (value > 70 && value <= 139) {
      numberOFBulb = 2;
    } else if (value >= 140 && value <= 220) {
      numberOFBulb = 3;
    } else if (value >= 221 && value <= 279) {
      numberOFBulb = 4;
    } else if (value >= 280) {
      numberOFBulb = 5;
    }
    this.roomControl.patchValues({ numberOfbulb: Math.trunc(numberOFBulb) })
    this.roomControl.updateFormValidation({
      capacity: {
        max: Math.trunc(roomArea)
      }
    })
  }
  matressChange(value) {
    if (value === 'Cotton') {
      this.roomControl.updateFormValidation({
        matressSize: {
          min: 3
        }
      })
    } else {
      this.roomControl.updateFormValidation({
        matressSize: {
          min: 5
        }
      })
    }
  }
  previous() {
    if (this.role === 'pmkkspoc') {
      this.router.navigate(['pmkkspoc/assessment-requests'])
    }
    if (this.role === 'desktopassessor') {
      this.router.navigate(['desktopassessor/assessment-requests'])
    }
    if (this.role === 'inspectionagency') {
      this.router.navigate(['inspectionagency/view-all-appeal-requests'])
    }
    if (this.role === 'holdingagency') {
      this.router.navigate(['holdingagency/appeals-to-accrediation-committee'])
    }
    if (this.role === 'qualitycontrol') {
      this.router.navigate(['qualitycontrol/assessment-requests'])
    }

  }
  residentialForMen(event) {
    if (this.typeOfResidencialData && this.typeOfResidencialData.type && this.typeOfResidencialData.type.men == true) {
      this.validity.residentialMen = event;
    }
  }
  residentialForWoMen(event) {
    if (this.typeOfResidencialData && this.typeOfResidencialData.type && this.typeOfResidencialData.type.women == true) {
      this.validity.residentialWomen = event;
    }
  }
  residentialForTransgender(event) {
    if (this.typeOfResidencialData && this.typeOfResidencialData.type && this.typeOfResidencialData.type.transgender == true) {
      this.validity.residentialTransgender = event;
    }
  }
  addressValidityOfMen(event) {
    if (this.typeOfResidencialData && this.typeOfResidencialData.type && this.typeOfResidencialData.type.men == true) {
      this.validity.addressForMen = event;
    }
  }
  addressValidityOfWomen(event) {
    if (this.typeOfResidencialData && this.typeOfResidencialData.type && this.typeOfResidencialData.type.women == true) {
      this.validity.addressForWomen = event;
    }
  }
  addressValidityOfTransgender(event) {
    if (this.typeOfResidencialData && this.typeOfResidencialData.type && this.typeOfResidencialData.type.transgender == true) {
      this.validity.addressForTransgender = event;
    }
  }
  typeResidential(value) {
    this.validity.menRooms = value.men == false ? true : (this.menRooms && this.menRooms.length > 0) ? true : false
    this.validity.womenRooms = value.women == false ? true : (this.womenRooms && this.womenRooms.length > 0) ? true : false
    this.validity.transgenderRooms = value.transgender == false ? true : (this.transngender && this.transngender.length > 0) ? true : false
    this.validity.residentialWomen = value.women == false ? true : this.validity.residentialWomen;
    this.validity.residentialTransgender = value.transgender == false ? true : this.validity.residentialTransgender;
    this.validity.residentialMen = value.men == false ? true : this.validity.residentialMen;
    this.validity.addressForMen = value.men == false ? true : false;
    this.validity.addressForWomen = value.women == false ? true : false;
    this.validity.addressForTransgender = value.transgender == false ? true : false;
    let validitySeperateEntanceWomen = [];
    let validitySeperateEntanceTransgender = [];
    if (value.women == true && value.men == true) {
      validitySeperateEntanceWomen = [Validators.required]
    } else if (value.transgender == true && value.women == true) {
      validitySeperateEntanceTransgender = [Validators.required]
    }
    this.residentialFormGroup.get('womenForm').get('seperateEntranceForMF').setValidators(validitySeperateEntanceWomen);
    this.residentialFormGroup.get('womenForm').get('seperateEntranceForMF').updateValueAndValidity();
    this.residentialFormGroup.get('transgenderForm').get('seperateEntranceForMF').setValidators(validitySeperateEntanceTransgender);
    this.residentialFormGroup.get('transgenderForm').get('seperateEntranceForMF').updateValueAndValidity();
    if (value.men) {
      this.menTab.nativeElement.click();
    } else if (value.women) {
      this.womenTab.nativeElement.click();
    } else if (value.transgender) {
      this.transgenderTab.nativeElement.click();

    }

    // if (value.men == true) {
    // 	this.menFormCreation();
    // }
    // if (value.women == true) {
    // 	this.womenFormCreation();
    // }
    // if (value.transgender == true) {
    // 	this.transgenderFormCreation();
    // }
  }
  addCotSize(value) {
    this.roomFormGroup.setControl('cotType', this.formBuilder.array([]))
    if (value > 0) {
      const cotType = <FormArray>this.roomFormGroup.get('cotType');
      for (let i = 0; i < value; i++) {
        cotType.push(this.createCotType());
      }
    }
  }

  addCupBoradAlmirahSize(value) {
    this.roomFormGroup.setControl('volumeOfCupboard', this.formBuilder.array([]))
    if (value > 0) {
      const volumeOfCupboard = <FormArray>this.roomFormGroup.get('volumeOfCupboard');
      for (let i = 0; i < value; i++) {
        volumeOfCupboard.push(this.createCubBordSize());
      }
    }
  }

  addCotDetails(value?) {
    const cotType = <FormArray>this.roomFormGroup.get('cotType');
    cotType.push(this.createCotType(value));
  }
  createCotType(value?) {
    return this.formBuilder.group({
      typeOfCot: [value ? value.typeOfCot : null, [Validators.required]],
      cotDetails: [null, this.formBuilder.array([])]
    });
  }
  //this.formBuilder.array([])
  createcupBordType(value?) {
    return this.formBuilder.group({
      typeOfCupBoard: [value ? value.typeOfCupBoard : null, [Validators.required]],
      // volumeOfCupBoardOrTrunk: [null,  [Validators.required, Validators.min(6480)]],
      volumeOfCupBoardOrTrunk: this.formBuilder.group({
        height: [value ? value.volumeOfCupBoardOrTrunk && value.volumeOfCupBoardOrTrunk.height : null, [Validators.required, Validators.min(1)]],
        width: [value ? value.volumeOfCupBoardOrTrunk && value.volumeOfCupBoardOrTrunk.width : null, [Validators.required, Validators.min(1)]],
        thickness: [value ? value.volumeOfCupBoardOrTrunk && value.volumeOfCupBoardOrTrunk.thickness : null, [Validators.required, Validators.min(1)]],
        isvoloumeOfCupboardOrTrunkHidden: [true]
      })
    });
  }
  createCotDetails(value?) {
    return this.formBuilder.group({
      frameOfCot: [value ? value.frameOfCot : null, [Validators.required]],
      cotWidth: [value ? value.cotWidth : null, [Validators.required, Validators.min(3)]],
      cotLength: [value ? value.cotLength : null, [Validators.required, Validators.min(6)]],
      typeOfMatress: [value ? value.typeOfMatress : null, [Validators.required]],
      matressThickness: [value ? value.matressThickness : null, [Validators.required, Validators.min(3)]],
      availabilityOfPillowThickness: [value ? value.availabilityOfPillowThickness : null, [Validators.required]],
      // pillowThickness: [null, [Validators.required,Validators.min(3)]],
      // cotMatressPillowThickness: [null, [Validators.required,Validators.min(5)]]
    })
  }

  createCubBordSize() {
    return this.formBuilder.group({
      cubBordLength: [null, [Validators.required]],
      cubBordWidth: [null, [Validators.required]],
      cupBordBreadth: [null, [Validators.required]]
    });
  }
  createAreaOfToilet(value?) {
    return new FormControl(value ? value : null, [Validators.required, Validators.min(1)]);
  }
  createAreaOfToiletCumBathRoom(value?) {
    return new FormControl(value ? value : null, [Validators.required, Validators.min(1)]);
  }
  createAreaOfBathRoom(value?) {
    return new FormControl(value ? value : null, [Validators.required, Validators.min(1)]);
  }
  createdusibinSizeDiningReational(value?) {
    return new FormControl(value ? value : null, [Validators.required, Validators.min(10)]);
  }
  createdusibinSizeCleanAndHygine(value?) {
    return new FormControl(value ? value : null, [Validators.required, Validators.min(10)]);
  }

  onCCTCDocumentChangeMen(value) {
    const myValue = value;
    if (value) {
      this.menControl.hideFields(['previewcctvCameraDocumentUrl'], this.residentialFacilities
        && this.residentialFacilities.equipedWith.cctvMen == true ? false : true);
      this.menControl.updateFormValidation({
        'previewcctvCameraDocumentUrl': {
          value: myValue
        }
      });
    }
  }
  onCCTCDocumentChangeWoMen(value) {
    const myValue = value;
    if (value) {
      this.womenControl.hideFields(['previewcctvCameraDocumentUrl'], this.residentialFacilitiesWomen
        && this.residentialFacilitiesWomen.equipedWith.cctvWomen == true ? false : true);
      this.womenControl.updateFormValidation({
        'previewcctvCameraDocumentUrl': {
          value: myValue
        }
      });
    }
  }
  onCCTCDocumentChangeTransgender(value) {
    const myValue = value;
    if (value) {
      this.transgenderControl.hideFields(['previewcctvCameraDocumentUrl'], this.residentialFacilitiesTransgender
        && this.residentialFacilitiesTransgender.equipedWith.cctvTransgender == true ? false : true);
      this.transgenderControl.updateFormValidation({
        'previewcctvCameraDocumentUrl': {
          value: myValue
        }
      });
    }
  }

  addAreaOfToiletWoMen(count, value?, controlValue?, formGroupName?) {
    this.setControlsFormInfra(count, value, controlValue, formGroupName);
    // this.residentialFormGroup.get('womenForm').setControl('areaOfToilet',this.formBuilder.array([]));
    // const areaOfToilet = <FormArray>this.residentialFormGroup.get('womenForm').get('areaOfToilet');
    // for (let i = 0; i < count; i++){
    // 	areaOfToilet.push(this.createAreaOfToilet(value && value[i]));
    // }
  }
  addAreaOfBathRoomWoMen(count, value?, controlValue?, formGroupName?) {
    this.setControlsFormInfra(count, value, controlValue, formGroupName);
    // this.residentialFormGroup.get('womenForm').setControl('areaOfBathroom',this.formBuilder.array([]));
    // const areaOfToilet = <FormArray>this.residentialFormGroup.get('womenForm').get('areaOfBathroom');
    // for (let i = 0; i < count; i++){
    // 	areaOfToilet.push(this.createAreaOfBathRoom(value && value[i]));
    // }
  }
  addAreaOfBathRoomCumToiletWoMen(count, value?, controlValue?, formGroupName?) {
    this.setControlsFormInfra(count, value, controlValue, formGroupName);
    // this.residentialFormGroup.get('womenForm').setControl('areaOfToiletCumBathroom',this.formBuilder.array([]));
    // const areaOfToilet = <FormArray>this.residentialFormGroup.get('womenForm').get('areaOfToiletCumBathroom');
    // for (let i = 0; i < count; i++){
    // 	areaOfToilet.push(this.createAreaOfToiletCumBathRoom(value && value[i]));
    // }
  }
  addAreaOfToiletTransgender(count, value?, controlValue?, formGroupName?) {
    this.setControlsFormInfra(count, value, controlValue, formGroupName);
    // this.residentialFormGroup.get('transgenderForm').setControl('areaOfToilet',this.formBuilder.array([]));
    // const areaOfToilet = <FormArray>this.residentialFormGroup.get('transgenderForm').get('areaOfToilet');
    // for (let i = 0; i < count; i++){
    // 	areaOfToilet.push(this.createAreaOfToilet(value && value[i]));
    // }
  }
  addAreaOfBathRoomTransgender(count, value?, controlValue?, formGroupName?) {
    this.setControlsFormInfra(count, value, controlValue, formGroupName);
    // this.residentialFormGroup.get('transgenderForm').setControl('areaOfBathroom',this.formBuilder.array([]));
    // const areaOfToilet = <FormArray>this.residentialFormGroup.get('transgenderForm').get('areaOfBathroom');
    // for (let i = 0; i < count; i++){
    // 	areaOfToilet.push(this.createAreaOfBathRoom(value && value[i]));
    // }
  }
  addAreaOfBathRoomCumToiletTransgender(count, value?, controlValue?, formGroupName?) {
    this.setControlsFormInfra(count, value, controlValue, formGroupName);
    // this.residentialFormGroup.get('transgenderForm').setControl('areaOfToiletCumBathroom',this.formBuilder.array([]));
    // const areaOfToilet = <FormArray>this.residentialFormGroup.get('transgenderForm').get('areaOfToiletCumBathroom');
    // for (let i = 0; i < count; i++){
    // 	areaOfToilet.push(this.createAreaOfToiletCumBathRoom(value && value[i]));
    // }
  }
  addAreaOfToiletMen(count, value?, controlValue?, formGroupName?) {
    this.setControlsFormInfra(count, value, controlValue, formGroupName);
    // this.residentialFormGroup.get('menForm').setControl('areaOfToilet',this.formBuilder.array([]));
    // const areaOfToilet = <FormArray>this.residentialFormGroup.get('menForm').get('areaOfToilet');
    // for (let i = 0; i < count; i++){
    // 	areaOfToilet.push(this.createAreaOfToilet(value && value[i]));
    // }
  }
  addAreaOfBathRoomMen(count, value?, controlValue?, formGroupName?) {
    this.setControlsFormInfra(count, value, controlValue, formGroupName);
    // this.residentialFormGroup.get('menForm').setControl('areaOfBathroom',this.formBuilder.array([]));
    // const areaOfToilet = <FormArray>this.residentialFormGroup.get('menForm').get('areaOfBathroom');
    // for (let i = 0; i < count; i++){
    // 	areaOfToilet.push(this.createAreaOfBathRoom(value && value[i]));
    // }
  }
  addAreaOfBathRoomCumToilet(count, value?, controlValue?, formGroupName?) {
    // 'areaOfToiletCumBathroom'
    this.setControlsFormInfra(count, value, controlValue, formGroupName);
  }
  addDustbinSizeForMenCleanAndHygin(count, value?, controlValue?, formGroupName?) {
    this.setControlsFormInfra(count, value, controlValue, formGroupName);
  }
  setControlsFormInfra(count, value?, controlValue?, formGroupName?) {
    this.residentialFormGroup.get(formGroupName).setControl(controlValue, this.formBuilder.array([]));
    const areaOfToilet = <FormArray>this.residentialFormGroup.get(formGroupName).get(controlValue);
    for (let i = 0; i < count; i++) {
      areaOfToilet.push(this.createAreaOfToiletCumBathRoom(value && value[i]));
    }
  }
  typeOfCotChange(value, index) {
    const type = "Bed With 1 Stories";
    this.roomFormGroup.get('cotType')['controls'][index].setControl('cotDetails', this.formBuilder.array([]));
    const cotDetails = <FormArray>this.roomFormGroup.get('cotType')['controls'][index].get('cotDetails')
    if (value == type) {
      cotDetails.push(this.createCotDetails());
    } else {
      cotDetails.push(this.createCotDetails());
      cotDetails.push(this.createCotDetails());
    }
  }
  changeTypeOFCupBoard(value, index) {
    this.roomFormGroup.get('cupBordType')['controls'][index].get('isvoloumeOfCupboardOrTrunkHidden').setValue(false);
  }
  addCupBoard(value?) {
    const cupBordType = <FormArray>this.roomFormGroup.get('cupBordType');
    cupBordType.push(this.createcupBordType(value));
  }
  removeCotDetails(index) {
    const cotType = <FormArray>this.roomFormGroup.get('cotType');
    if (cotType.value.length > 1) {
      cotType.removeAt(index);
    }
  }
  removeStorage(index) {
    const cupBordType = <FormArray>this.roomFormGroup.get('cupBordType');
    if (cupBordType.value.length > 1) {
      cupBordType.removeAt(index);
    }
  }
  stateChange(event) {

  }
  mapIncomingAddress(data) {
    const addressData = data;
    const formattedAddress = {};
    for (const col in addressData) {
      if (addressData.hasOwnProperty(col)) {
        if (col == 'addressProof') {
          formattedAddress['addressProofType'] = (addressData[col] && addressData[col].type) || addressData['addressProofType'];
          formattedAddress['addressProof'] = (addressData[col] && addressData[col].locationURL) || addressData[col];
        } else {
          formattedAddress[col] = (addressData[col] && addressData[col].name) || addressData[col];

        }
      }
    }
    return formattedAddress;
  }

  copyAddresFromMen() {
    const formattedAddress = this.mapIncomingAddress(this.data.addressForMen);
    this.addressControlMen.patchValues(formattedAddress);
  }
  copyAddresFromWomen() {
    const formattedAddress = this.mapIncomingAddress(this.data.addressForWomen);
    this.addressControlWoMen.patchValues(formattedAddress);
  }
  copyAddresFromTransgender() {
    const formattedAddress = this.mapIncomingAddress(this.data.addressControlTransgender);
    this.addressControlTransgender.patchValues(formattedAddress);
  }
  menNeedToCopyAddressOf(value, really) {
    const women = 'women';
    const transgender = 'transgender';
    let formattedAddress: any;
    if (this.data.addressForMen) {
      const addressKeys = Object.keys(this.data.addressForMen);
      formattedAddress = addressKeys.reduce((data, addressField) => {
        data[addressField] = '';
        return data;
      }, {});
    }
    // this.mapIncomingAddress(null);
    if (value == women && really == true) {
      formattedAddress = this.mapIncomingAddress(this.data.addressForWomen);
    } else if (value == transgender && really == true) {
      formattedAddress = this.mapIncomingAddress(this.data.addressForTransgender);
    }
    this.addressControlMen.patchValues(formattedAddress);
    if (formattedAddress && formattedAddress.addressProof) {
      this.addressControlMen.updateFormValidation(
        {
          'addressProof': {
            value: formattedAddress.addressProof
          }
        }
      );
    }
    this.addressControlMen.makeFieldsReadOnly(this.disableAddressFiled(), really)
  }
  womenNeedToCopyAddressOf(value, really) {
    const men = 'men';
    const transgender = 'transgender';
    let formattedAddress: any;
    if (this.data.addressForWomen) {
      const addressKeys = Object.keys(this.data.addressForWomen);
      formattedAddress = addressKeys.reduce((data, addressField) => {
        data[addressField] = '';
        return data;
      }, {});
    }
    // this.mapIncomingAddress(null);
    if (value == men && really == true) {
      formattedAddress = this.mapIncomingAddress(this.data.addressForMen);
    } else if (value == transgender && really == true) {
      formattedAddress = this.mapIncomingAddress(this.data.addressForTransgender);
    }
    this.addressControlWoMen.patchValues(formattedAddress);
    if (formattedAddress && formattedAddress.addressProof) {
      this.addressControlWoMen.updateFormValidation(
        {
          'addressProof': {
            value: formattedAddress.addressProof
          }
        }
      );
    }
    this.addressControlWoMen.makeFieldsReadOnly(this.disableAddressFiled(), really)

  }
  transgenderNeedToCopyAddressOf(value, really) {
    const women = 'women';
    const men = 'men';
    let formattedAddress: any;
    if (this.data.addressForTransgender) {
      const addressKeys = Object.keys(this.data.addressForTransgender);
      formattedAddress = addressKeys.reduce((data, addressField) => {
        data[addressField] = '';
        return data;
      }, {});
    }
    this.mapIncomingAddress(null);
    if (value == women && really == true) {
      formattedAddress = this.mapIncomingAddress(this.data.addressForWomen);
    } else if (value == men && really == true) {
      formattedAddress = this.mapIncomingAddress(this.data.addressForMen);
    }
    this.addressControlTransgender.patchValues(formattedAddress);
    if (formattedAddress && formattedAddress.addressProof) {
      this.addressControlTransgender.updateFormValidation(
        {
          'addressProof': {
            value: formattedAddress.addressProof
          }
        }
      );
    }
    this.addressControlTransgender.makeFieldsReadOnly(this.disableAddressFiled(), really)
  }
  private disableAddressFiled() {
    const disableAddressFields = [
      'address1',
      'landmark',
      'pincode',
      'state',
      'district',
      'addressProof',
      'addressProofType'
      // 'tehsil',
      // 'city',
      // 'parliamentaryConstituency'
    ];
    return disableAddressFields
  }
  transgenderAvailabilityOfDustbinInDiningArea(value) {
    this.diningAreaFormsTransgender['control'].hideFields(['dustbinSizeInDiningArea'], value == true ? false : true)
    this.residentialFormGroup.get('transgenderForm').get('totalArea').patchValue(
      this.totalAreaCalculations(this.transngender,
        this.residentialFacilitiesTransgender && this.residentialFacilitiesTransgender.diningArea,
        this.residentialFacilitiesTransgender && this.residentialFacilitiesTransgender.diningAreaAndRecreationalArea,
        this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfToilet').value,
        this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfBathroom').value,
        this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfToiletCumBathroom').value
      )
    )
  }
  womenAvailabilityOfDustbinInDiningArea(value) {
    this.diningAreaFormsWomen['control'].hideFields(['dustbinSizeInDiningArea'], value == true ? false : true)
    this.residentialFormGroup.get('womenForm').get('totalArea').patchValue(
      this.totalAreaCalculations(this.womenRooms,
        this.residentialFacilitiesWomen && this.residentialFacilitiesWomen.diningArea,
        this.residentialFacilitiesWomen && this.residentialFacilitiesWomen.diningAreaAndRecreationalArea,
        this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfToilet').value,
        this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfBathroom').value,
        this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfToiletCumBathroom').value
      )
    )


  }
  menAvailabilityOfDustbinInDiningArea(value) {
    this.diningAreaFormsMen['control'].hideFields(['dustbinSizeInDiningArea'], value == true ? false : true)
    // this.residentialFormGroup.get('menForm').get('totalArea').patchValue(
    // 	this.totalAreaCalculations(this.menRooms,
    // 		this.diningAreaFormsMen['formData'] && this.diningAreaFormsMen['formData'].diningArea,
    // 		this.diningAreaRecreationalFormsMen && this.diningAreaRecreationalFormsMen['formData'].diningAreaAndRecreationalArea,
    // 		this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfToilet').value,
    // 		this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfBathroom').value,
    // 		this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfToiletCumBathroom').value
    // 	)
    // );
  }
  transgenderAvailabilityOfDustbinInDiningAreaRecreationalArea(value) {
    this.diningAreaRecreationalFormsTransgender['control'].hideFields(['countOfdustbinSizeInDiningAreaRecreationalArea'], value == true ? false : true)
    if (value == false) {
      this.setControls(this.residentialFormGroup, 'transgenderForm', 'dustbinSizeInDiningAreaRecreationalArea');
    }
  }
  availabilityOfPillow(value, control: FormControl) {
    const validations = [];
    if (value == true) {
      control.markAsTouched();
      control.markAsDirty();
      validations.push(Validators.required);
    }
    control.clearValidators();
    control.setValidators(validations);
    control.updateValueAndValidity();
    control.markAsDirty();
  }
  // setValidation(control: FormControl, selectedRemark) {
  // 	console.log('Hi am Called');
  // 	if (!selectedRemark) { return console.error('Invalid Remark'); }
  // 	const validations = [];
  // 	if (selectedRemark.status.value === 'Not Verified') {
  // 		control.markAsTouched();
  // 		control.markAsDirty();
  // 		validations.push(Validators.required);
  // 	}
  // 	control.clearValidators();
  // 	control.setValidators(validations);
  // 	control.updateValueAndValidity();
  // 	control.markAsDirty();
  // }
  menCountOfToiletChange(value) {
    this.addAreaOfToiletMen(value, this.residentialFormGroup.get('menForm').get('areaOfToilet').value, 'areaOfToilet', 'menForm');
  }
  menCountOfBathroomChange(value) {
    this.addAreaOfBathRoomMen(value, this.residentialFormGroup.get('menForm').get('areaOfBathroom').value, 'areaOfBathroom', 'menForm')
  }
  menCountOfToiletCumBathroomChange(value) {
    this.addAreaOfBathRoomCumToilet(value, this.residentialFormGroup.get('menForm').get('areaOfToiletCumBathroom').value, 'areaOfToiletCumBathroom', 'menForm')
  }
  menCountOfDustbinDiningAreaRecreational(value) {
    this.addAreaOfBathRoomCumToilet(value, this.residentialFormGroup.get('menForm').get('dustbinSizeInDiningAreaRecreationalArea').value, 'dustbinSizeInDiningAreaRecreationalArea', 'menForm')
  }
  womenCountOfDustbinDiningAreaRecreational(value) {
    this.addAreaOfBathRoomCumToilet(value, this.residentialFormGroup.get('womenForm').get('dustbinSizeInDiningAreaRecreationalArea').value, 'dustbinSizeInDiningAreaRecreationalArea', 'womenForm')
  }
  womenCountOfToiletChange(value) {
    this.addAreaOfToiletWoMen(value, this.residentialFormGroup.get('womenForm').get('areaOfToilet').value, 'areaOfToilet', 'womenForm')
  }
  womenCountOfBathroomChang(value) {
    this.addAreaOfBathRoomWoMen(value, this.residentialFormGroup.get('womenForm').get('areaOfBathroom').value, 'areaOfBathroom', 'womenForm')
  }
  womenCountOfToiletCumBathroomChange(value) {
    this.addAreaOfBathRoomCumToiletWoMen(value, this.residentialFormGroup.get('womenForm').get('areaOfToiletCumBathroom').value, 'areaOfToiletCumBathroom', 'womenForm')
  }
  transgenderCountOfDustbinDiningAreaRecreational(value) {
    this.addAreaOfBathRoomCumToilet(value, this.residentialFormGroup.get('transgenderForm').get('dustbinSizeInDiningAreaRecreationalArea').value, 'dustbinSizeInDiningAreaRecreationalArea', 'transgenderForm')
  }
  transgenderCountOfToiletChange(value) {
    this.addAreaOfToiletTransgender(value, this.residentialFormGroup.get('transgenderForm').get('areaOfToilet').value, 'areaOfToilet', 'transgenderForm');
  }
  transgenderCountOfBathroomChang(value) {
    this.addAreaOfBathRoomTransgender(value, this.residentialFormGroup.get('transgenderForm').get('areaOfBathroom').value, 'areaOfBathroom', 'transgenderForm');
  }
  transgenderCountOfToiletCumBathroomChangee(value) {
    this.addAreaOfBathRoomCumToiletTransgender(value, this.residentialFormGroup.get('transgenderForm').get('areaOfToiletCumBathroom').value, 'areaOfToiletCumBathroom', 'transgenderForm');
  }

  mendiningAreaChange(value) {
    this.residentialFormGroup.get('menForm').get('totalArea').patchValue(this.totalAreaCalculations(this.menRooms,
      this.diningAreaFormsMen['formData'] && this.diningAreaFormsMen['formData'].diningArea,
      this.diningAreaRecreationalFormsMen['formData'] && this.diningAreaRecreationalFormsMen['formData'].diningAreaAndRecreationalArea,
      this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfToilet').value,
      this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfBathroom').value,
      this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfToiletCumBathroom').value
    ))
    if (value) {
      //	this.calcualteBulbRequirement(this.diningAreaFormsMen,'diningArea','numberOfBulbDiningArea');
    }
    // this.diningAreaFormsMen['control'].hideFields(['numberOfBulbDiningArea'], value == true ? false : true);
    // this.menControl.patchValues({
    // 	'totalArea':this.totalAreaCalculations(this.menRooms,
    // 		this.residentialFacilities && this.residentialFacilities.diningArea,
    // 		this.residentialFacilities && this.residentialFacilities.diningAreaAndRecreationalArea,
    // 		this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfToilet').value,
    // 		this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfBathroom').value,
    // 		this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfToiletCumBathroom').value
    // 	)
    // });
  }
  mendiningAreaRecreationalChange(value) {
    this.residentialFormGroup.get('menForm').get('totalArea').patchValue(this.totalAreaCalculations(this.menRooms,
      this.diningAreaFormsMen['formData'] && this.diningAreaFormsMen['formData'].diningArea,
      this.diningAreaRecreationalFormsMen['formData'] && this.diningAreaRecreationalFormsMen['formData'].diningAreaAndRecreationalArea,
      this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfToilet').value,
      this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfBathroom').value,
      this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfToiletCumBathroom').value
    ))
    // this.menControl.patchValues({
    // 	'totalArea':this.totalAreaCalculations(this.menRooms,
    // 	this.residentialFacilities && this.residentialFacilities.diningArea,
    // 	this.residentialFacilities && this.residentialFacilities.diningAreaAndRecreationalArea,
    // 	this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfToilet').value,
    // 	this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfBathroom').value,
    // 	this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfToiletCumBathroom').value
    // )});

  }
  womendiningAreaChange(value) {
    this.residentialFormGroup.get('womenForm').get('totalArea').patchValue(this.totalAreaCalculations(this.womenRooms,
      this.diningAreaFormsWomen['formData'] && this.diningAreaFormsWomen['formData'].diningArea,
      this.diningAreaRecreationalFormsWomen['formData'] && this.diningAreaRecreationalFormsWomen['formData'].diningAreaAndRecreationalArea,
      this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfToilet').value,
      this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfBathroom').value,
      this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfToiletCumBathroom').value
    ));
    // this.womenControl.patchValues({
    // 	'totalArea':this.totalAreaCalculations(this.womenRooms,
    // 		this.residentialFacilitiesWomen && this.residentialFacilitiesWomen.diningArea,
    // 		this.residentialFacilitiesWomen && this.residentialFacilitiesWomen.diningAreaAndRecreationalArea,
    // 		this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfToilet').value,
    // 		this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfBathroom').value,
    // 		this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfToiletCumBathroom').value
    // 	)
    // });

  }
  womendiningAreaRecreationalChange(value) {
    this.residentialFormGroup.get('womenForm').get('totalArea').patchValue(
      this.totalAreaCalculations(this.womenRooms,
        this.diningAreaFormsWomen['formData'] && this.diningAreaFormsWomen['formData'].diningArea,
        this.diningAreaRecreationalFormsWomen['formData'] && this.diningAreaRecreationalFormsWomen['formData'].diningAreaAndRecreationalArea,
        this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfToilet').value,
        this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfBathroom').value,
        this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfToiletCumBathroom').value
      )
    )
  }
  transgenderdiningAreaChange(value) {
    this.residentialFormGroup.get('transgenderForm').get('totalArea').patchValue(
      this.totalAreaCalculations(this.transngender,
        this.diningAreaFormsTransgender['formData'] && this.diningAreaFormsTransgender['formData'].diningArea,
        this.diningAreaRecreationalFormsTransgender['formData'] && this.diningAreaRecreationalFormsTransgender['formData'].diningAreaAndRecreationalArea,
        this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfToilet').value,
        this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfBathroom').value,
        this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfToiletCumBathroom').value
      )
    )
  }
  transgenderdiningAreaRecreationalChange(value) {
    this.residentialFormGroup.get('transgenderForm').get('totalArea').patchValue(
      this.totalAreaCalculations(this.transngender,
        this.diningAreaFormsTransgender['formData'] && this.diningAreaFormsTransgender['formData'].diningArea,
        this.diningAreaRecreationalFormsTransgender['formData'] && this.diningAreaRecreationalFormsTransgender['formData'].diningAreaAndRecreationalArea,
        this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfToilet').value,
        this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfBathroom').value,
        this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfToiletCumBathroom').value
      )
    )
  }
  areaOfTolietChange(value) {
    switch (value) {
      case 'men':
        this.residentialFormGroup.get('menForm').get('totalArea').patchValue(
          this.totalAreaCalculations(this.menRooms,
            this.diningAreaFormsMen['formData'] && this.diningAreaFormsMen['formData'].diningArea,
            this.diningAreaRecreationalFormsMen && this.diningAreaRecreationalFormsMen['formData'].diningAreaAndRecreationalArea,
            this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfToilet').value,
            this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfBathroom').value,
            this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfToiletCumBathroom').value
          )
        );
        break;
      case 'women':
        this.residentialFormGroup.get('womenForm').get('totalArea').patchValue(
          this.totalAreaCalculations(this.womenRooms,
            this.diningAreaFormsWomen['formData'] && this.diningAreaFormsWomen['formData'].diningArea,
            this.diningAreaRecreationalFormsWomen['formData'] && this.diningAreaRecreationalFormsWomen['formData'].diningAreaAndRecreationalArea,
            // this.residentialFacilitiesWomen && this.residentialFacilitiesWomen.diningArea,
            // this.residentialFacilitiesWomen && this.residentialFacilitiesWomen.diningAreaAndRecreationalArea,
            this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfToilet').value,
            this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfBathroom').value,
            this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfToiletCumBathroom').value
          )
        )
        break;
      case 'transgender':
        this.residentialFormGroup.get('transgenderForm').get('totalArea').patchValue(
          this.totalAreaCalculations(this.transngender,
            this.diningAreaFormsTransgender['formData'] && this.diningAreaFormsTransgender['formData'].diningArea,
            this.diningAreaRecreationalFormsTransgender['formData'] && this.diningAreaRecreationalFormsTransgender['formData'].diningAreaAndRecreationalArea,
            this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfToilet').value,
            this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfBathroom').value,
            this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfToiletCumBathroom').value
          )
        )
        break;
      default:
        return value;
    }
  }
  areaOfBathroomChange(value) {
    switch (value) {
      case 'men':
        this.residentialFormGroup.get('menForm').get('totalArea').patchValue(
          this.totalAreaCalculations(this.menRooms,
            this.diningAreaFormsMen['formData'] && this.diningAreaFormsMen['formData'].diningArea,
            this.diningAreaRecreationalFormsMen && this.diningAreaRecreationalFormsMen['formData'].diningAreaAndRecreationalArea,
            this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfToilet').value,
            this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfBathroom').value,
            this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfToiletCumBathroom').value
          )
        );
        break;
      case 'women':
        this.residentialFormGroup.get('womenForm').get('totalArea').patchValue(
          this.totalAreaCalculations(this.womenRooms,
            this.diningAreaFormsWomen['formData'] && this.diningAreaFormsWomen['formData'].diningArea,
            this.diningAreaRecreationalFormsWomen['formData'] && this.diningAreaRecreationalFormsWomen['formData'].diningAreaAndRecreationalArea,
            this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfToilet').value,
            this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfBathroom').value,
            this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfToiletCumBathroom').value
          )
        )
        break;
      case 'transgender':
        this.residentialFormGroup.get('transgenderForm').get('totalArea').patchValue(
          this.totalAreaCalculations(this.transngender,
            this.diningAreaFormsTransgender['formData'] && this.diningAreaFormsTransgender['formData'].diningArea,
            this.diningAreaRecreationalFormsTransgender['formData'] && this.diningAreaRecreationalFormsTransgender['formData'].diningAreaAndRecreationalArea,
            this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfToilet').value,
            this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfBathroom').value,
            this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfToiletCumBathroom').value
          )
        )
        break;
      default:
        return value;
    }
  }
  areaOfBathroomCumToiletChange(value) {
    switch (value) {
      case 'men':
        this.residentialFormGroup.get('menForm').get('totalArea').patchValue(
          this.totalAreaCalculations(this.menRooms,
            this.diningAreaFormsMen['formData'] && this.diningAreaFormsMen['formData'].diningArea,
            this.diningAreaRecreationalFormsMen && this.diningAreaRecreationalFormsMen['formData'].diningAreaAndRecreationalArea,
            this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfToilet').value,
            this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfBathroom').value,
            this.residentialFormGroup && this.residentialFormGroup.get('menForm').get('areaOfToiletCumBathroom').value
          )
        );
        break;
      case 'women':
        this.residentialFormGroup.get('womenForm').get('totalArea').patchValue(
          this.totalAreaCalculations(this.womenRooms,
            this.residentialFacilitiesWomen && this.residentialFacilitiesWomen.diningArea,
            this.residentialFacilitiesWomen && this.residentialFacilitiesWomen.diningAreaAndRecreationalArea,
            this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfToilet').value,
            this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfBathroom').value,
            this.residentialFormGroup && this.residentialFormGroup.get('womenForm').get('areaOfToiletCumBathroom').value
          )
        )
        break;
      case 'transgender':
        this.residentialFormGroup.get('transgenderForm').get('totalArea').patchValue(
          this.totalAreaCalculations(this.transngender,
            this.residentialFacilitiesTransgender && this.residentialFacilitiesTransgender.diningArea,
            this.residentialFacilitiesTransgender && this.residentialFacilitiesTransgender.diningAreaAndRecreationalArea,
            this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfToilet').value,
            this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfBathroom').value,
            this.residentialFormGroup && this.residentialFormGroup.get('transgenderForm').get('areaOfToiletCumBathroom').value
          )
        )
        break;
      default:
        return value;
    }
  }
  totalAreaCalculations(totalRoomArea, totaldiningArea, totaldiningAreaRecreationalArea,
    totalareaOfToilet, totalareaOfBathroom, totalareaOfToiletCumBathroom) {
    let roomArea = [];
    let diningArea = 0;
    let diningAreaRecreationalArea = 0;
    let areaOfToilet = [];
    let areaOfBathroom = [];
    let areaOfToiletCumBathroom = [];
    let totalArea = 0;
    // roomArea = totalRoomArea ? totalRoomArea : roomArea;
    if (totalRoomArea && totalRoomArea.length && totalRoomArea.length > 0) {
      totalRoomArea.forEach(romArea => {
        roomArea.push(romArea.roomArea);
      });
    }
    diningArea = totaldiningArea ? totaldiningArea : diningArea;
    diningAreaRecreationalArea = totaldiningAreaRecreationalArea ? totaldiningAreaRecreationalArea : diningAreaRecreationalArea;
    areaOfToilet = totalareaOfToilet ? totalareaOfToilet : areaOfToilet;
    areaOfBathroom = totalareaOfBathroom ? totalareaOfBathroom : areaOfBathroom;
    areaOfToiletCumBathroom = totalareaOfToiletCumBathroom ? totalareaOfToiletCumBathroom : areaOfToiletCumBathroom;
    if (roomArea && roomArea.length && roomArea.length > 0) {
      roomArea.forEach(room => {
        totalArea = totalArea + room;
      });
    }
    if (areaOfToilet && areaOfToilet.length && areaOfToilet.length > 0) {
      areaOfToilet.forEach(areaToilet => {
        totalArea = totalArea + areaToilet
      })
    }
    if (areaOfBathroom && areaOfBathroom.length && areaOfBathroom.length > 0) {
      areaOfBathroom.forEach(areaBathroom => {
        totalArea = totalArea + areaBathroom
      });
    }
    if (areaOfToiletCumBathroom && areaOfToiletCumBathroom.length && areaOfToiletCumBathroom.length > 0) {
      areaOfToiletCumBathroom.forEach(areaToiletCumBathroom => {
        totalArea = totalArea + areaToiletCumBathroom
      });
    }
    totalArea = totalArea + diningAreaRecreationalArea;
    totalArea = totalArea + diningArea;
    return totalArea;
  }
  residentialCapacity(rooms) {
    let residenCapacityValue = 0;
    if (rooms && rooms.length > 0) {
      rooms.forEach(room => {
        residenCapacityValue = residenCapacityValue + room.capacity;
      });
    }
    return residenCapacityValue;
  }
  seperateEntranceChangeChange(value) {
    this.menControl.updateFormValidation({
      seperateEntranceForMF: {
        metainfo: ''
      }
    })
    if (value == true) {
      this.menControl.updateFormValidation({
        seperateEntranceForMF: {
          metainfo: 'Male & Female Facilities can be on different floors of the same building but with dedicated entrance'
        }
      })
    }
  }
  menTotalAreaChange() {
    this.calculationForTotalArea();
  }
  menTotalResidentialCapacityChange() {
    this.calculationForTotalCapacity()
  }
  womenTotalAreaChange() {
    this.calculationForTotalArea()
  }
  womenTotalResidentialCapacityChange() {
    this.calculationForTotalCapacity()
  }
  transgenderTotalAreaChange() {
    this.calculationForTotalArea()
  }
  transgenderTotalResidentialCapacityChange() {
    this.calculationForTotalCapacity()
  }
  calculationForTotalArea() {
    const dataToPatch = (this.typeOfResidencialData && this.typeOfResidencialData.type && this.typeOfResidencialData.type.men == true && this.residentialFormGroup.get('menForm').get('totalArea').value ? this.residentialFormGroup.get('menForm').get('totalArea').value : 0) +
      (this.typeOfResidencialData && this.typeOfResidencialData.type && this.typeOfResidencialData.type.women == true && this.residentialFormGroup.get('womenForm').get('totalArea').value ? this.residentialFormGroup.get('womenForm').get('totalArea').value : 0) +
      (this.typeOfResidencialData && this.typeOfResidencialData.type && this.typeOfResidencialData.type.transgender == true && this.residentialFormGroup.get('transgenderForm').get('totalArea').value ? this.residentialFormGroup.get('transgenderForm').get('totalArea').value : 0)
    this.homePageFormGroup.get('totalArea').patchValue(dataToPatch);
  }
  calculationForTotalCapacity() {
    const dataToPatch = (this.typeOfResidencialData && this.typeOfResidencialData.type && this.typeOfResidencialData.type.men == true && this.residentialFormGroup.get('menForm').get('capacity').value ? this.residentialFormGroup.get('menForm').get('capacity').value : 0) +
      (this.typeOfResidencialData && this.typeOfResidencialData.type && this.typeOfResidencialData.type.women == true && this.residentialFormGroup.get('womenForm').get('capacity').value ? this.residentialFormGroup.get('womenForm').get('capacity').value : 0) +
      (this.typeOfResidencialData && this.typeOfResidencialData.type && this.typeOfResidencialData.type.transgender == true && this.residentialFormGroup.get('transgenderForm').get('capacity').value ? this.residentialFormGroup.get('transgenderForm').get('capacity').value : 0)
    this.homePageFormGroup.get('totalCapacity').patchValue(dataToPatch);
  }
  patchOugoingofHomePage() {
    const dataInResidential = {
      totalArea: this.homePageFormGroup.get('totalArea').value,
      totalCapacity: this.homePageFormGroup.get('totalCapacity').value,
      nameOfResidentialFacility: this.homePageFormGroup.get('nameOfResidentialFacility').value,
      availabilityOfDisplayBoardFrontBuild: this.homePageFormGroup.get('availabilityOfDisplayBoardFrontBuild').value
    }
    return dataInResidential
  }
  menDustbinCleanandHygienChange(value) {
    this.addDustbinSizeForMenCleanAndHygin(value, this.residentialFormGroup.get('menForm').get('dustbinSize').value, 'dustbinSize', 'menForm')
  }
  womenDustbinCleanandHygienChange(value) {
    this.addDustbinSizeForMenCleanAndHygin(value, this.residentialFormGroup.get('womenForm').get('dustbinSize').value, 'dustbinSize', 'womenForm')
  }
  transgenderDustbinCleanandHygienChange(value) {
    this.addDustbinSizeForMenCleanAndHygin(value, this.residentialFormGroup.get('transgenderForm').get('dustbinSize').value, 'dustbinSize', 'transgenderForm')
  }
  getMenValidity() {
    if (this.homePageFormGroup.valid == false || this.residentialFormGroup.get('menForm').valid == false ||
      this.validity.residentialMen == false || this.infraFormMen.validity == false || this.diningAreaFormsMen.validity == false ||
      this.diningAreaRecreationalFormsMen.validity == false || this.validity.residentialMen == false ||
      this.validity.addressForMen == false || this.validity.menRooms == false
    ) {
      return true;
    }
  }
  getWoMenValidity() {
    if (this.homePageFormGroup.valid == false || this.residentialFormGroup.get('womenForm').valid == false ||
      this.validity.residentialWomen == false || this.infraFormWomen.validity == false || this.diningAreaFormsWomen.validity == false ||
      this.diningAreaRecreationalFormsWomen.validity == false ||
      this.validity.addressForWomen == false || this.validity.womenRooms == false
    ) {
      return true;
    }
  }
  getTransgenderValidity() {
    if (this.homePageFormGroup.valid == false || this.residentialFormGroup.get('transgenderForm').valid == false ||
      this.validity.residentialTransgender == false || this.infraFormTransgender.validity == false || this.diningAreaFormsTransgender.validity == false ||
      this.diningAreaRecreationalFormsTransgender.validity == false ||
      this.validity.addressForTransgender == false || this.validity.transgenderRooms == false
    ) {
      return true;
    }
  }

  // onSectionChange(sectionId: string) {
  // 	this.currentSection = sectionId;
  // 	console.log(this.currentSection);
  // }

  // scrollTo(section) {
  //   document.querySelector('#' + section)
  //   .scrollIntoView();
  // }


}


